import * as i1 from '@ngrx/store';
import { createAction, props, createReducer, on, createFeatureSelector, createSelector, Store, StoreModule } from '@ngrx/store';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, inject, Inject, APP_INITIALIZER, NgModule, Optional } from '@angular/core';
import { combineLatest, of, throwError, timer, filter as filter$1, take as take$1, EMPTY, from, merge, interval, concatMap as concatMap$1, first as first$1, mergeMap as mergeMap$1, exhaustMap as exhaustMap$1, iif, map as map$1, catchError as catchError$1 } from 'rxjs';
import * as i2 from '@panamax/app-state';
import { jwtDecode } from '@panamax/app-state';
import { first, filter, distinctUntilChanged, catchError, map, tap, pairwise, take, switchMap, concatMap, withLatestFrom, exhaustMap, mergeMap } from 'rxjs/operators';
import * as i1$1 from '@panamax/browser-storage';
import { MessageTypes } from '@panamax/browser-storage';
import { createEntityAdapter } from '@ngrx/entity';
import * as i1$3 from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { v4 } from 'uuid';
import { OrderTransactionEventActions } from '@usf/order-types';
import * as i1$2 from '@panamax/websocket';
import * as i1$4 from '@ngrx/effects';
import { createEffect, ofType, concatLatestFrom, EffectsModule } from '@ngrx/effects';
import dayjs from 'dayjs';
import { UserKinds } from '@usf/user-types/user';

/* eslint-disable @typescript-eslint/naming-convention, no-shadow */
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["IN_PROGRESS"] = "IN_PROGRESS";
    OrderStatus["SUBMITTING"] = "SUBMITTING";
    OrderStatus["SUBMITTED"] = "SUBMITTED";
    OrderStatus["SUBMITTED_CREDIT_HOLD"] = "SUBMITTED_CREDIT_HOLD";
    OrderStatus["SUBMITTED_WITH_EXCEPTIONS"] = "SUBMITTED_WITH_EXCEPTIONS";
    OrderStatus["EDITING_SUBMITTED"] = "EDITING_SUBMITTED";
    OrderStatus["ORDER_ERROR"] = "ORDER_ERROR";
    OrderStatus["SHIPPED"] = "SHIPPED";
    OrderStatus["SHIPPED_WITH_EXCEPTIONS"] = "SHIPPED_WITH_EXCEPTIONS";
    OrderStatus["PICKING"] = "PICKING";
    OrderStatus["INVOICE"] = "INVOICE";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["DELETED"] = "DELETED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["CANCELLING"] = "CANCELLING";
    OrderStatus["TANDEM_DELETED"] = "TANDEM_DELETED";
    OrderStatus["SUBMITTED_NEW"] = "SUBMITTED_NEW";
    OrderStatus["NO_ORDER"] = "NO_ORDER";
    OrderStatus["SUBMISSION_ERROR"] = "SUBMISSION_ERROR";
    OrderStatus["QUANTITIES_UPDATED"] = "QUANTITIES_UPDATED";
    OrderStatus["OUT_FOR_DELIVERY"] = "OUT_FOR_DELIVERY";
    OrderStatus["DELIVERY_DELAYED"] = "DELIVERY_DELAYED";
    OrderStatus["ATTEMPTED_DELIVERY"] = "ATTEMPTED_DELIVERY";
    OrderStatus["ORDER_CANCELLED"] = "ORDER_CANCELLED";
    OrderStatus["DELIVERY_ISSUE"] = "DELIVERY_ISSUE";
})(OrderStatus || (OrderStatus = {}));

const getDeliveryInfo = createAction('[Next Delivery] Get Next Delivery Info');
const getDeliveryInfoSuccess = createAction('[Next Delivery] Get Next Delivery Info Success', props());
const getDeliveryInfoFail = createAction('[Next Delivery] Get Next Delivery Info Fail', props());
const resetStore = createAction('[Next Delivery] Reset Store');
const NEXT_DELIVERY_ACTIONS = {
    getDeliveryInfo,
    getDeliveryInfoFail,
    getDeliveryInfoSuccess,
    resetStore,
};

const initializeStorage = createAction('[NgRx - Order] - Initialize Offline Storage');
const getRecentOrders = createAction('[NgRx - My Orders] Get Recent Orders');
const getRecentOrdersSuccess = createAction('[NgRx - My Orders] Get Recent Orders Success', props());
const getRecentOrdersFail = createAction('[NgRx - My Orders] Get Recent Orders Fail', props());
const getCustomerOrders = createAction('[NgRx - My Orders] Get Customer Orders');
const getCustomerOrdersSuccess = createAction('[NgRx - My Orders] Get Customer Orders Success', props());
const getCustomerOrdersFail = createAction('[NgRx - My Orders] Get Customer Orders Fail', props());
const getMyOrdersContext = createAction('[NgRx - My Orders] Get My Orders Context');
const getMyOrdersContextSuccess = createAction('[NgRx - My Orders] Get My Orders Context Success', props());
const getMyOrdersContextFail = createAction('[NgRx - My Orders] Get My Orders Context Fail', props());
const getInProgressOrdersContext = createAction('[NgRx - My Orders] Get Inprogress Orders Context');
const getInProgressOrdersContextSuccess = createAction('[NgRx - My Orders] Get Inprogress Orders Context Success', props());
const getInProgressOrdersContextFail = createAction('[NgRx - My Orders] Get Inprogress Orders Context Fail', props());
const removeFromMyOrders = createAction('[NgRx - My Orders] Remove From My Orders', props());
const clearCart$1 = createAction('[NgRx - My Orders] Clear Cart');
const cancelOrderAsync = createAction('[NgRx - My Orders Asnyc] Cancel Order', props());
const submitIpOrderAsync = createAction('[NgRx - My Orders Async] Submit In Progress Order', props());
const updateSubmittedOrderAsync = createAction('[NgRx - My Orders Async] Update Submitted  Order', props());
const convertToWillCallAsync = createAction('[NgRx - My Orders Async] Convert To Will Call Order', props());
const convertToWillCallAsyncFail = createAction('[NgRx - My Orders Async] Convert To Will Call Order Fail', props());
const updateShipToDetailsAsync = createAction('[NgRx - My Orders Async] Update Ship To Details', props());
const updateShipToDetailsAsyncFail = createAction('[NgRx - My Orders Async] Update Ship To Details Fail', props());
const upsertOne = createAction('[NgRx - My Orders] Update/Insert Order', props());
const upsertMany = createAction('[NgRx - My Orders] Update/Insert Orders', props());
const getOrderDetails = createAction('[NgRx - My Orders] Get Submitted Order Details', props());
const getOrderDetailsSuccess = createAction('[NgRx - My Orders] Get Submitted Order Details Success', props());
const getOrderDetailsFailure = createAction('[NgRx - My Orders] Get Submitted Order Details Failure', props());
const convertToWillCall = createAction('[NgRx - My Orders] Convert To Will Call Order', props());
const convertToWillCallSuccess = createAction('[NgRx - My Orders] Convert To Will Call Order Success', props());
const setMyOrdersWillCallInFlight = createAction('[NgRx - My Orders] Set My Orders Will Call In Flight', props());
const convertToWillCallFail = createAction('[NgRx - My Orders] Convert To Will Call Order Fail', props());
//IndexedDB Actions
const initializeUserStorage = createAction('[NgRx - Order] - Initialize User Offline Storage', props());
const writeToUserOfflineStorage = createAction('[NgRx - Order] Write To User Storage');
const loadFromUserOfflineStorage = createAction('[NgRx - Order] Load From User Storage', props());
const loadFromUserOfflineStorageSuccess = createAction('[NgRx - Order] Load From User Storage Success', props());
const loadFromUserOfflineStorageFail = createAction('[NgRx - Order] Load From User Storage Fail', props());
const checkOrderStatus = createAction('[NgRx - Order] Check Order Status', props());
const checkOrderStatusSuccess = createAction('[NgRx - Order] Check Order Status Success', props());
const checkOrderStatusFailure = createAction('[NgRx - Order] Check Order Status Failure', props());
//end IndexedDB Actions
const MY_ORDERS_ACTIONS = {
    initializeStorage,
    getInProgressOrdersContext,
    getInProgressOrdersContextSuccess,
    getInProgressOrdersContextFail,
    getMyOrdersContext,
    getMyOrdersContextSuccess,
    getMyOrdersContextFail,
    getRecentOrders,
    getRecentOrdersSuccess,
    getRecentOrdersFail,
    getCustomerOrders,
    getCustomerOrdersSuccess,
    getCustomerOrdersFail,
    removeFromMyOrders,
    clearCart: clearCart$1,
    cancelOrderAsync,
    submitIpOrderAsync,
    updateSubmittedOrderAsync,
    convertToWillCallAsync,
    convertToWillCallAsyncFail,
    updateShipToDetailsAsync,
    updateShipToDetailsAsyncFail,
    upsertOne,
    upsertMany,
    initializeUserStorage,
    getOrderDetails,
    getOrderDetailsSuccess,
    getOrderDetailsFailure,
    convertToWillCall,
    convertToWillCallSuccess,
    convertToWillCallFail,
    setMyOrdersWillCallInFlight,
    checkOrderStatus,
    checkOrderStatusSuccess,
    checkOrderStatusFailure,
    //IndexedDB
    writeToUserOfflineStorage,
    loadFromUserOfflineStorage,
    loadFromUserOfflineStorageSuccess,
    loadFromUserOfflineStorageFail,
};

const setOrderExceptionsForOrder = createAction('[NgRx - OrderException] Set Order Exceptions', props());
const homePageRouteResolveExceptions = createAction('[NgRx - OrderException] Home Page Tile Resolve Exceptions', props());
const homePageRouteResolveExceptionsSuccess = createAction('[NgRx - OrderException] Home Page Tile Resolve Exceptions Success', props());
const homePageRouteResolveExceptionsFail = createAction('[NgRx - OrderException] Home Page Tile Resolve Exceptions Fail', props());
const homePageRouteResolveExceptionsApiFail = createAction('[NgRx - OrderException] Home Page Tile Resolve Exceptions API Fail', props());
const resolveException = createAction('[NgRx - OrderException] Resolve Exceptions', props());
const expandSection = createAction('[NgRx - OrderException] Expand/Collapse an exception section', props());
const resolveOrder = createAction('[NgRx - OrderException] Resolve Order', props());
const resolveOrderSuccess = createAction('[NgRx - OrderException] Resolve Order Success', props());
const resolveOrderFail = createAction('[NgRx - Order] Resolve Order Fail', props());
const clearOrderExceptions = createAction('[NgRx - OrderException] Clear Order Exception State');
const setIsConfirmationFlow = createAction('[NgRx - OrderException] Set Confirmaton Flow', props());
const ORDER_EXCEPTION_ACTIONS = {
    setOrderExceptionsForOrder,
    homePageRouteResolveExceptions,
    homePageRouteResolveExceptionsSuccess,
    homePageRouteResolveExceptionsFail,
    homePageRouteResolveExceptionsApiFail,
    resolveException,
    resolveOrder,
    resolveOrderSuccess,
    resolveOrderFail,
    expandSection,
    clearOrderExceptions,
    setIsConfirmationFlow,
};

const getDyfProducts = createAction('[NgRx - DYF] Get DFY Products');
const getDyfProductsSuccess = createAction('[NgRx - DYF] Get DFY Products Success', props());
const getDyfProductsError = createAction('[NgRx - DYF] Get DFY Products Error', props());
const DYF_ACTIONS = {
    getDyfProducts,
    getDyfProductsSuccess,
    getDyfProductsError,
};

const getInspiredPicks = createAction('[NgRx - Inspired Picks] Get Inspired Picks');
const getInspiredPicksSuccess = createAction('[NgRx - Inspired Picks] Get Inspired Picks Success', props());
const getInspiredPicksFail = createAction('[NgRx - Inspired Picks] Get Inspired Picks Fail', props());
const INSPIRED_PICKS_ACTIONS = {
    getInspiredPicks,
    getInspiredPicksSuccess,
    getInspiredPicksFail,
};

const getDirectShippingSavings = createAction('[NgRx - Direct Shipping] Get Direct Shipping Savings', props());
const getDirectShippingSavingsSuccess = createAction('[NgRx - Direct Shipping] Get Direct Shipping Savings Success', props());
const getDirectShippingSavingsFail = createAction('[NgRx - Direct Shipping] Get Direct Shipping Savings Fail', props());
const clearLastModified = createAction('[NgRx - Direct Shipping] Clear Last Modified Timestamp', props());
const DIRECT_SHIPPING_ACTIONS = {
    getDirectShippingSavings,
    getDirectShippingSavingsSuccess,
    getDirectShippingSavingsFail,
    clearLastModified,
};

const clearCart = createAction('[NgRx - Order] Initialize Cart');
const updateCart = createAction('[NgRx - Order] Update Cart', props());
const createNewCart = createAction('[NgRx - Order] Create New Cart', props());
const createNewCartSuccess = createAction('[NgRx - Order] Create New Cart Success', props());
const createNewCartFail = createAction('[NgRx - Order] Create New Cart Fail', props());
const createNewCartMessage = createAction('[NgRx - Order] Cancel New Cart Message', props());
const deleteCart = createAction('[NgRx - Order] Delete Cart', props());
const deleteCartSuccess = createAction('[NgRx - Order] Delete Cart Success', props());
const deleteCartFail = createAction('[NgRx - Order] Delete Cart Fail', props());
const deleteCartWithErrorDetails = createAction('[NgRx - Order] Delete Cart With Error Details', props());
const createCopiedOrder = createAction('[NgRx - Order] Create Copied Order', props());
const createCopiedOrderSuccess = createAction('[NgRx - Order] Create Copied Order Success', props());
const createCopiedOrderFail = createAction('[NgRx - Order] Create Copied Order Fail', props());
const loadCartIntoContext = createAction('[NgRx - Order] Load Cart Into Context', props());
const cancelSubmittedCart = createAction('[NgRx - Order] Cancel Submitted Cart', props());
const cancelSubmittedCartSuccess = createAction('[NgRx - Order] Cancel Submitted Cart Success', props());
const cancelSubmittedCartFail = createAction('[NgRx - Order] Cancel Submitted Cart Fail', props());
const cancelSubmittedCartWithErrorDetails = createAction('[NgRx - Order] Cancel Submitted Cart With Error Details');
const updateDeliveryDates = createAction('[NgRx - Order] Update Delivery Dates', props());
const submitCart = createAction('[NgRx - Order] Submit Cart', props());
const submitCartSuccess = createAction('[NgRx - Order] Submit Cart Success', props());
const submitCartFail = createAction('[NgRx - Order] Submit Cart Fail', props());
const removeEmptyCartItems = createAction('[NgRx - Order] Remove Empty Cart Items');
const removeBadOrderFromCart = createAction('[NgRx - Order] Remove deleted/cancelled order from cart');
const setLoading = createAction('[NgRx - Order] Set Loading', props());
const CART_ACTIONS = {
    clearCart,
    updateCart,
    deleteCart,
    deleteCartSuccess,
    deleteCartFail,
    deleteCartWithErrorDetails,
    createNewCart,
    createNewCartSuccess,
    createNewCartFail,
    createCopiedOrder,
    createCopiedOrderSuccess,
    createCopiedOrderFail,
    createNewCartMessage,
    loadCartIntoContext,
    updateDeliveryDates,
    cancelSubmittedCart,
    cancelSubmittedCartSuccess,
    cancelSubmittedCartFail,
    cancelSubmittedCartWithErrorDetails,
    submitCart,
    submitCartSuccess,
    submitCartFail,
    removeEmptyCartItems,
    removeBadOrderFromCart,
    setLoading,
};

const loadVptOrder = createAction('[NgRx - Order] Load Vpt Order');
const getVptOrderByOrderNumber = createAction('[NgRx - Order] Get Vpt Order By Order Number', props());
const getVptOrderByOrderNumberSuccess = createAction('[NgRx - Order] Get Vpt Order By Order Number Success', props());
const getVptOrderByOrderNumberFail = createAction('[NgRx - Order] Get Vpt Order By Order Number Fail', props());
const submitVptOrder = createAction('[NgRx - Order] Submit Vpt Order', props());
const submitVptOrderSuccess = createAction('[NgRx - Order] Submit Vpt Order Success', props());
const submitVptOrderFail = createAction('[NgRx - Order] Submit Vpt Order Fail', props());
const VISUAL_PUNCHTHRU_ACTIONS = {
    loadVptOrder,
    getVptOrderByOrderNumber,
    getVptOrderByOrderNumberSuccess,
    getVptOrderByOrderNumberFail,
    submitVptOrder,
    submitVptOrderSuccess,
    submitVptOrderFail,
};

const loadNvptOrder = createAction('[NgRx - Order] Load Nvpt Order');
const getNvptOrderByOrderNumber = createAction('[NgRx - Order] Get Nvpt Order By Order Number', props());
const getNvptOrderByOrderNumberSuccess = createAction('[NgRx - Order] Get Nvpt Order By Order Number Success', props());
const getNvptOrderByOrderNumberFail = createAction('[NgRx - Order] Get Nvpt Order By Order Number Fail', props());
const NON_VISUAL_PUNCHTHRU_ACTIONS = {
    loadNvptOrder,
    getNvptOrderByOrderNumber,
    getNvptOrderByOrderNumberSuccess,
    getNvptOrderByOrderNumberFail,
};

const cartSync = createAction('[NgRx - Order] Cart Sync', props());
const cartSyncSuccess = createAction('[NgRx - Order] Cart Sync Success', props());
const cartSyncFail = createAction('[NgRx - Order] Cart Sync Fail', props());
// Dispatched when the cart is not updatable on the server (canceled, deleted, etc.)
const cartNotUpdatable = createAction('[NgRx - Order] Cart Non Updatable', props());
const CART_SYNC_ACTIONS = {
    cartSync,
    cartSyncSuccess,
    cartSyncFail,
    cartNotUpdatable,
};

const initialize = createAction('[NgRx - Order] Initialize Import Orders');
const load = createAction('[NgRx - Order] Load Import Orders', props());
const loadSuccess = createAction('[NgRx - Order] Load Import Orders Success', props());
const loadFail = createAction('[NgRx - Order] Load Import Orders Fail', props());
const submit = createAction('[NgRx - Order] Submit Import Orders', props());
const submitSuccess = createAction('[NgRx - Order] Submit Import Orders Success', props());
const submitFail = createAction('[NgRx - Order] Submit Import Orders Fail', props());
const setImportOrderCheck = createAction('[NgRx - Order] Set Import Expectation', props());
const getImportedOrdersById = createAction('[NgRx - Order] Get Imported Orders By ID', props());
const getImportedOrdersByIdSuccess = createAction('[NgRx - Order] Get Imported Orders By ID Success', props());
const getImportedOrdersByIdFail = createAction('[NgRx - Order] Get Imported Orders By ID Fail', props());
const getImportedOrdersByDate = createAction('[NgRx - Order] Get Imported Orders By Date', props());
const getImportedOrdersByDateSuccess = createAction('[NgRx - Order] Get Imported Orders By Date Success', props());
const getImportedOrdersByDateFail = createAction('[NgRx - Order] Get Imported Orders By Date Fail', props());
const pollGetImportedOrders = createAction('[NgRx - Order] Poll Get Imported Orders Call', props());
const IMPORT_ORDERS_ACTIONS = {
    initialize,
    load,
    loadSuccess,
    loadFail,
    submit,
    submitSuccess,
    submitFail,
    setImportOrderCheck,
    getImportedOrdersByDate,
    getImportedOrdersByDateSuccess,
    getImportedOrdersByDateFail,
    getImportedOrdersById,
    getImportedOrdersByIdSuccess,
    getImportedOrdersByIdFail,
    pollGetImportedOrders,
};

const punchoutLogout = createAction('[NgRx - Order Punchout] Punchout Logout', props());
const punchoutLogoutSuccess = createAction('[NgRx - Order Punchout] Punchout Logout Success', props());
const punchoutLogoutFail = createAction('[NgRx - Order Punchout] Punchout Logout Fail', props());
const ORDER_PUNCHOUT_ACTIONS = {
    punchoutLogout,
    punchoutLogoutSuccess,
    punchoutLogoutFail,
};

const getUqeProducts = createAction('[NgRx - Order] Get Unusual Quantity Products', props());
const getUqeProductsSuccess = createAction('[NgRx - Order] Get Unusual Quantity Products Success', props());
const getUqeProductsFail = createAction('[NgRx - Order] Get Unusual Quantity Products Fail', props());
const clearUqe = createAction('[NgRx - Order] Initialize Unusual Quantities');
const UQE_ACTIONS = {
    getUqeProducts,
    getUqeProductsSuccess,
    getUqeProductsFail,
    clearUqe,
};

const setImportedOrdersFilters = createAction('[NgRx - Order] Set the Imported Orders Filters', props());
const IMPORTED_ORDERS_FILTERS_ACTIONS = {
    setImportedOrdersFilters,
};

const getPartnerData = createAction('[Ngrx - Partner] Get Partner Data', props());
const getPartnerDataSuccess = createAction('[Ngrx - Partner] Get Partner Data Success', props());
const getPartnerDataFail = createAction('[Ngrx - Partner] Get Partner Data Fail', props());
const PARTNER_ACTIONS = {
    getPartnerData,
    getPartnerDataFail,
    getPartnerDataSuccess,
};

const updateShipToDetails = createAction('[NgRx - Order] Update Ship To Details', props());
const updateShipToDetailsSuccess = createAction('[NgRx - Order] Update Ship To Details Success', props());
const updateShipToDetailsFail = createAction('[NgRx - Order] Update Ship To Details Fail', props());
const SHIP_TO_ACTIONS = {
    updateShipToDetails,
    updateShipToDetailsSuccess,
    updateShipToDetailsFail,
};

const setOrderItemFilter = createAction('[NgRx - Order] Set Order Item Filter', props());
const ORDER_ITEM_FILTER_ACTIONS = {
    setOrderItemFilter,
};

const clearEditCart = createAction('[NgRx - Order] Clear Edit Cart');
const updateEditCart = createAction('[NgRx - Order] Update Edit Cart', props());
const loadProductsForEditCart = createAction('[NgRx - Order] Load Products For Edit Cart', props());
const EDIT_CART_ACTIONS = {
    clearEditCart,
    updateEditCart,
    loadProductsForEditCart,
};

const getOrderReviewPreferences = createAction('[NgRx - Order] Get Order Review Preferences');
const getOrderReviewPreferencesSuccess = createAction('[NgRx - Order] Get Order Review Preferences Success', props());
const getOrderReviewPreferencesFail = createAction('[NgRx - Order] Get Order Review Preferences Fail', props());
const updateOrderReviewPreferences = createAction('[NgRx - Order] Update Order Review Preferences', props());
const updateOrderReviewPreferencesSuccess = createAction('[NgRx - Order] Update Order Review Preferences Success', props());
const updateOrderReviewPreferencesFail = createAction('[NgRx - Order] Update Order Review Preferences Fail', props());
const clearOrderReviewPreferences = createAction('[NgRx - Order] Clear Order Review Preferences');
const ORDER_REVIEW_ACTIONS = {
    getOrderReviewPreferences,
    getOrderReviewPreferencesSuccess,
    getOrderReviewPreferencesFail,
    updateOrderReviewPreferences,
    updateOrderReviewPreferencesSuccess,
    updateOrderReviewPreferencesFail,
    clearOrderReviewPreferences,
};

const loadOrderControl = createAction('[NgRx - Order Control] Load OrderControl');
const loadOrderControlSuccess = createAction('[NgRx - Order Control] Load Order Control Success', props());
const loadOrderControlFailure = createAction('[NgRx - Order Control] Load Order Control Failure', props());
const ORDER_CONTROL_ACTIONS = {
    loadOrderControl,
    loadOrderControlSuccess,
    loadOrderControlFailure,
};

const getDsmInfo = createAction('[NgRx - Order] Get Dsm Info');
const getDsmInfoSuccess = createAction('[NgRx - Order] Get Dsm Info Success', props());
const getDsmInfoFailure = createAction('[NgRx - Order] Get Dsm Info Failure', props());
const DSM_ACTIONS = {
    getDsmInfo,
    getDsmInfoSuccess,
    getDsmInfoFailure,
};

const NEXT_DELIVERY_KEY = 'next-delivery';
const ORDERS_KEY = 'orders';
const ORDERS_FILTERS_KEY = 'orders-filters';
const ORDER_DOMAIN_NAME = 'order';
const ORDER_EXCEPTION_KEY = 'order-exception';
const DYF_PRODUCT_KEY = 'dyf-products';
const INSPIRED_PICKS_KEY = 'inspired-picks';
const DIRECT_SHIPPING_KEY = 'direct-ship';
const CART_KEY = 'cart';
const EDIT_CART_KEY = 'edit-cart';
const IMPORT_ORDERS_KEY = 'import-orders';
const PARTNER_KEY = 'partner';
const UQE_KEY = 'unusual-quantities';
const IMPORTED_ORDERS_FILTERS_KEY = 'imported-orders-filters';
const ORDER_ITEM_FILTER_KEY = 'order-item-filter';
const ORDER_REVIEW_KEY = 'order-review';
const ORDER_CONTROL_KEY = 'order-control';
const DSM_KEY = 'dsm';
const ORDER_STORAGE_KEYS = [
    NEXT_DELIVERY_KEY,
    ORDERS_KEY,
    ORDERS_FILTERS_KEY,
    ORDER_EXCEPTION_KEY,
    DYF_PRODUCT_KEY,
    INSPIRED_PICKS_KEY,
    DIRECT_SHIPPING_KEY,
    CART_KEY,
    IMPORT_ORDERS_KEY,
    PARTNER_KEY,
    IMPORTED_ORDERS_FILTERS_KEY,
    EDIT_CART_KEY,
    ORDER_CONTROL_KEY,
    DSM_KEY,
];

/* eslint-disable @typescript-eslint/naming-convention, no-shadow */
var OrderETAMessageType;
(function (OrderETAMessageType) {
    OrderETAMessageType["PLANNED"] = "Planned";
    OrderETAMessageType["ETA"] = "ETA";
})(OrderETAMessageType || (OrderETAMessageType = {}));

/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
const OrderStatusSortOrder = {
    [OrderStatus.IN_PROGRESS]: 1,
    [OrderStatus.SUBMISSION_ERROR]: 2,
    [OrderStatus.SUBMITTING]: 3,
    [OrderStatus.ORDER_ERROR]: 4,
    [OrderStatus.SUBMITTED_WITH_EXCEPTIONS]: 5,
    [OrderStatus.SUBMITTED]: 6,
    [OrderStatus.SUBMITTED_CREDIT_HOLD]: 7,
    [OrderStatus.PICKING]: 8,
    [OrderStatus.INVOICE]: 9,
    [OrderStatus.SHIPPED_WITH_EXCEPTIONS]: 10,
    [OrderStatus.SHIPPED]: 11,
    [OrderStatus.DELIVERED]: 12,
    [OrderStatus.EDITING_SUBMITTED]: 13,
    [OrderStatus.DELETED]: 14,
    [OrderStatus.CANCELLED]: 15,
    [OrderStatus.CANCELLING]: 16,
};

const sortByOrderStatus = (a, b) => OrderStatusSortOrder[a.orderHeader.orderStatus] -
    OrderStatusSortOrder[b.orderHeader.orderStatus];
const orderAdapter = createEntityAdapter({
    selectId: (order) => `${order.orderHeader.customerNumber}:${order.orderHeader.departmentNumber}:${order.orderHeader.orderId}`,
    sortComparer: sortByOrderStatus,
});
const initialOrderState = orderAdapter.getInitialState({
    customerOrdersLoading: true,
    importedOrdersLoading: false,
    recentOrdersLoading: false,
    inProgressOrdersLoading: false,
    ready: false,
    error: null,
    watermark: '1995-08-26T15:28:17.854Z',
    customerWatermarks: {},
    willCallInFlight: false,
    orderStatusInFlight: false,
});
const reducer$e = createReducer(initialOrderState, on(MY_ORDERS_ACTIONS.getMyOrdersContext, (state) => ({
    ...state,
    error: null,
})), on(MY_ORDERS_ACTIONS.getRecentOrders, (state) => ({
    ...state,
    recentOrdersLoading: true,
    error: null,
})), on(MY_ORDERS_ACTIONS.getRecentOrdersSuccess, (state, { orders }) => {
    let filteredOrders = [];
    if (orders && orders.length) {
        filteredOrders = orders.filter((order) => isDisplayableOrderType(order));
    }
    return orderAdapter.upsertMany(filteredOrders, {
        ...state,
        recentOrdersLoading: false,
        error: null,
    });
}), on(MY_ORDERS_ACTIONS.getRecentOrdersFail, (state, { error }) => ({
    ...state,
    recentOrdersLoading: false,
    error,
})), on(MY_ORDERS_ACTIONS.getInProgressOrdersContext, (state) => ({
    ...state,
    inProgressOrdersLoading: true,
    error: null,
})), on(MY_ORDERS_ACTIONS.getInProgressOrdersContextSuccess, (state, { orders }) => orderAdapter.upsertMany(orders, {
    ...state,
    inProgressOrdersLoading: false,
})), on(MY_ORDERS_ACTIONS.getInProgressOrdersContextFail, (state, { error }) => ({
    ...state,
    inProgressOrdersLoading: false,
    error,
})), on(MY_ORDERS_ACTIONS.getCustomerOrders, (state) => ({
    ...state,
    customerOrdersLoading: true,
    error: null,
})), on(MY_ORDERS_ACTIONS.getCustomerOrdersSuccess, (state, { orders }) => {
    let maxWatermark = state.customerWatermarks;
    let filteredOrders = [];
    let customerWatermarks = {};
    customerWatermarks = { ...state.customerWatermarks };
    if (orders && orders.length) {
        filteredOrders = orders.filter((order) => isDisplayableOrderType(order));
        if (!!filteredOrders && filteredOrders.length) {
            const customerNumber = filteredOrders[0]?.orderHeader?.customerNumber;
            maxWatermark = filteredOrders.reduce((a, b) => a.orderHeader.watermarkDtm > b.orderHeader.watermarkDtm ? a : b).orderHeader.watermarkDtm;
            if (!customerWatermarks[customerNumber] ||
                maxWatermark > customerWatermarks[customerNumber]) {
                customerWatermarks[customerNumber] = maxWatermark;
            }
        }
    }
    return orderAdapter.upsertMany(filteredOrders, {
        ...state,
        customerOrdersLoading: false,
        customerWatermarks,
        error: null,
    });
}), on(MY_ORDERS_ACTIONS.getCustomerOrdersFail, (state, { error }) => ({
    ...state,
    customerOrdersLoading: false,
    error,
})), on(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDate, IMPORT_ORDERS_ACTIONS.getImportedOrdersById, (state) => ({ ...state, importedOrdersLoading: true, error: null })), on(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDateSuccess, (state, { orders }) => {
    let maxWatermark = state.watermark;
    let filteredOrders = [];
    if (orders && orders.length) {
        filteredOrders = orders.filter((order) => isDisplayableOrderType(order));
        if (filteredOrders && filteredOrders.length) {
            maxWatermark = filteredOrders.reduce((a, b) => a.orderHeader.watermarkDtm > b.orderHeader.watermarkDtm ? a : b).orderHeader.watermarkDtm;
        }
    }
    return orderAdapter.upsertMany(filteredOrders, {
        ...state,
        importedOrdersLoading: false,
        error: null,
        watermark: maxWatermark,
    });
}), on(IMPORT_ORDERS_ACTIONS.getImportedOrdersByIdSuccess, (state, { orders }) => {
    let filteredOrders = [];
    if (orders && orders.length) {
        filteredOrders = orders.filter((order) => isDisplayableOrderType(order));
    }
    return orderAdapter.upsertMany(filteredOrders, {
        ...state,
        importedOrdersLoading: false,
        error: null,
    });
}), on(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDateFail, IMPORT_ORDERS_ACTIONS.getImportedOrdersByIdFail, (state, { error }) => ({
    ...state,
    importedOrdersLoading: false,
    error,
})), on(MY_ORDERS_ACTIONS.getMyOrdersContextSuccess, (state, { orders }) => {
    let maxWatermark = state.watermark;
    let filteredOrders = [];
    if (orders && orders.length) {
        filteredOrders = orders.filter((order) => isDisplayableOrderType(order));
        if (filteredOrders && filteredOrders.length) {
            maxWatermark = filteredOrders.reduce((a, b) => a.orderHeader.watermarkDtm > b.orderHeader.watermarkDtm ? a : b).orderHeader.watermarkDtm;
        }
    }
    return orderAdapter.upsertMany(filteredOrders, {
        ...state,
        error: null,
        watermark: maxWatermark,
    });
}), on(MY_ORDERS_ACTIONS.getMyOrdersContextFail, (state, { error }) => ({
    ...state,
    error,
})), on(MY_ORDERS_ACTIONS.removeFromMyOrders, (state, { id }) => orderAdapter.removeOne(id, state)), on(MY_ORDERS_ACTIONS.upsertOne, (state, { order }) => orderAdapter.upsertOne(order, { ...state, willCallInFlight: false })), on(MY_ORDERS_ACTIONS.upsertMany, (state, { orders }) => orderAdapter.upsertMany(orders, state)), on(MY_ORDERS_ACTIONS.loadFromUserOfflineStorageSuccess, (state, action) => {
    const result = {
        ...state,
        ...action.orders,
        ready: true,
    };
    return result;
}), on(MY_ORDERS_ACTIONS.writeToUserOfflineStorage, (state) => {
    //filter out deleted orders over 24 hours old before writing to storage
    const yesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000).toISOString();
    const ordersToPurge = state.ids.map((id) => {
        if (state.entities[id].orderHeader.watermarkDtm <= yesterday &&
            (state.entities[id].orderHeader.orderStatus === OrderStatus.DELETED ||
                state.entities[id].orderHeader.orderStatus ===
                    OrderStatus.SUBMITTED_NEW)) {
            return id;
        }
    });
    return orderAdapter.removeMany(ordersToPurge, state);
}), on(MY_ORDERS_ACTIONS.getOrderDetailsSuccess, (state, { order, isEditFlow }) => orderAdapter.upsertOne({
    ...order,
    orderHeader: {
        ...order.orderHeader,
        lastRealtimeUpdate: new Date().toISOString(),
    },
}, state)), 
// willCallInFlight is true at the initial call
// and false at both api fail, or asyncSuccess and Fail.
// Also, adds and new action to set manually
on(MY_ORDERS_ACTIONS.convertToWillCall, (state) => ({
    ...state,
    willCallInFlight: true,
    error: null,
})), on(MY_ORDERS_ACTIONS.setMyOrdersWillCallInFlight, (state, payload) => ({
    ...state,
    willCallInFlight: payload.willCallInFlight,
})), on(MY_ORDERS_ACTIONS.convertToWillCallSuccess, (state) => ({
    ...state,
    error: null,
})), on(MY_ORDERS_ACTIONS.convertToWillCallFail, (state, payload) => ({
    ...state,
    willCallInFlight: false,
    error: payload.error,
})), on(MY_ORDERS_ACTIONS.convertToWillCallAsyncFail, (state) => ({
    ...state,
    willCallInFlight: false,
})), on(MY_ORDERS_ACTIONS.checkOrderStatus, (state) => ({
    ...state,
    orderStatusInFlight: true,
})), on(MY_ORDERS_ACTIONS.checkOrderStatusFailure, (state) => ({
    ...state,
    orderStatusInFlight: false,
})), on(MY_ORDERS_ACTIONS.checkOrderStatusSuccess, (state, { order }) => orderAdapter.upsertOne(order, { ...state, orderStatusInFlight: false })), on(ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptionsSuccess, (state, { order }) => orderAdapter.upsertOne(order, { ...state })), on(ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptionsFail, (state, { order }) => orderAdapter.upsertOne(order, { ...state })));
const isDisplayableOrderType = (order) => ['RT', 'VS', 'WC', 'CC'].includes(order?.orderHeader?.orderType);
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function orderReducer(state, action) {
    return reducer$e(state, action);
}
const { selectAll: selectAll$3, selectEntities: selectEntities$4, selectIds: selectIds$3, selectTotal: selectTotal$3, } = orderAdapter.getSelectors();

const selectAllOrders = selectAll$3;
const selectEntities$3 = selectEntities$4;
const selectOrderContextState = createFeatureSelector(ORDERS_KEY);
const getAllMyOrders = createSelector(selectOrderContextState, selectAllOrders);
const selectWatermark$1 = () => createSelector(selectOrderContextState, (orders) => orders.watermark);
const selectCustomerWatermarks = () => createSelector(selectOrderContextState, (orders) => orders.customerWatermarks);
const selectReadyState = () => createSelector(selectOrderContextState, (orders) => orders.ready);
const selectOrdersLoaded = () => createSelector(selectOrderContextState, (orders) => orders.ready &&
    !(orders.customerOrdersLoading ||
        orders.inProgressOrdersLoading ||
        orders.recentOrdersLoading ||
        orders.importedOrdersLoading));
const selectCustomerOrdersLoaded = () => createSelector(selectOrderContextState, (orders) => orders.ready && !orders.customerOrdersLoading);
const selectOrderStatusInFlight = () => createSelector(selectOrderContextState, (orders) => orders.orderStatusInFlight);
const selectOrderWithId = (orderId) => createSelector(selectOrderContextState, (orderState) => {
    const order = orderState.entities[orderId];
    return order;
});
const selectOrdersWithStatus = (status) => createSelector(selectOrderContextState, (orderState) => {
    const orders = Object.values(orderState.entities).filter((order) => order.orderHeader.orderStatus === status);
    return orders;
});
const selectImportedOrdersById = (importOrderIdentifier) => createSelector(selectOrderContextState, (orderState) => Object.values(orderState.entities).filter((order) => order?.orderHeader?.importOrderIdentifier &&
    importOrderIdentifier &&
    order.orderHeader.importOrderIdentifier === importOrderIdentifier &&
    (order.orderHeader.orderStatus === OrderStatus.SUBMITTED ||
        order.orderHeader.orderStatus === OrderStatus.SUBMITTED_CREDIT_HOLD ||
        order.orderHeader.orderStatus ===
            OrderStatus.SUBMITTED_WITH_EXCEPTIONS)));
const selectImportedOrdersByDate = (importedDate) => createSelector(selectOrderContextState, (orderState) => Object.values(orderState.entities).filter((order) => order?.orderHeader?.importOrderIdentifier &&
    importedDate &&
    (order.orderHeader.orderStatus === OrderStatus.SUBMITTED ||
        order.orderHeader.orderStatus === OrderStatus.SUBMITTED_CREDIT_HOLD ||
        order.orderHeader.orderStatus ===
            OrderStatus.SUBMITTED_WITH_EXCEPTIONS) &&
    importedDate === getDateKey(new Date(order.orderHeader.importOrderDtm))));
const getDateKey = (date) => {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return month + '/' + day + '/' + year;
};
const orderSelectors = {
    selectOrderContextState,
    getAllMyOrders,
    selectOrderWithId,
    selectAllOrders,
    selectEntities: selectEntities$3,
    selectWatermark: selectWatermark$1,
    selectCustomerWatermarks,
    selectReadyState,
    selectOrdersLoaded,
    selectCustomerOrdersLoaded,
    selectOrdersWithStatus,
    selectOrderStatusInFlight,
    selectImportedOrdersById,
    selectImportedOrdersByDate,
};

/* eslint-disable prefer-arrow/prefer-arrow-functions */
// Define the feature selector for the cart state slice
const selectCart = createFeatureSelector('cart');
// Define individual selectors
const selectOrderHeader$1 = createSelector(selectCart, (state) => state.orderHeader);
const selectOrderItems$1 = createSelector(selectCart, (state) => state.orderItems);
const selectLoading$2 = createSelector(selectCart, (state) => state.loading);
const selectError$1 = createSelector(selectCart, (state) => state.error);
const selectDirty = createSelector(selectCart, (state) => state.dirty);
const selectSaving = createSelector(selectCart, (state) => state.saving);
const selectWatermark = createSelector(selectCart, (state) => state.watermark);
const selectFailCount = createSelector(selectCart, (state) => state?.failCount ? state.failCount : 0);
const selectAsLegacyOrderItemState = createSelector(selectCart, (state) => ({
    ids: createOrderItemIds(state?.orderItems),
    entities: createOrderItemEntities(state?.orderItems),
    tallies: createOrderItemTallies(state?.orderItems),
    loading: state?.loading,
    error: state?.error,
}));
const selectAsLegacyOrderHeaderState = createSelector(selectCart, (state) => ({
    ids: [state?.orderHeader?.orderId],
    entities: createOrderHeaderEntity(state?.orderHeader),
    loading: state?.loading,
    error: state?.error,
}));
// Helper function to create entities from an array of OrderItems
function createOrderItemEntities(orderItems) {
    if (!orderItems) {
        return;
    }
    return orderItems.reduce((entities, orderItem) => ({
        ...entities,
        [orderItem.productNumber]: orderItem,
    }), {});
}
function createOrderHeaderEntity(orderHeader) {
    if (!orderHeader) {
        return {};
    }
    return {
        [orderHeader.orderId]: orderHeader,
    };
}
function createOrderItemTallies(orderItems) {
    if (!orderItems) {
        return {};
    }
    let totalItems = 0;
    let totalCases = 0;
    let totalEaches = 0;
    const totalShipments = 1;
    for (const orderItem of orderItems) {
        totalCases += orderItem.unitsOrdered.currentValue || 0;
        totalEaches += orderItem.eachesOrdered.currentValue || 0;
        totalItems = totalCases + totalEaches;
    }
    return {
        totalItems,
        totalCases,
        totalEaches,
        totalShipments,
    };
}
function createOrderItemIds(orderItems) {
    if (!orderItems) {
        return;
    }
    return orderItems.map((orderItem) => orderItem.productNumber);
}
const CART_SELECTORS = {
    selectCart,
    selectOrderHeader: selectOrderHeader$1,
    selectOrderItems: selectOrderItems$1,
    selectLoading: selectLoading$2,
    selectError: selectError$1,
    selectDirty,
    selectSaving,
    selectWatermark,
    selectFailCount,
    selectAsLegacyOrderItemState,
    selectAsLegacyOrderHeaderState,
};

const selectOrderHeaderContextState = createSelector(CART_SELECTORS.selectAsLegacyOrderHeaderState, (cartState) => cartState);
const selectOrderHeader = createSelector(selectOrderHeaderContextState, (orderHeaderState) => {
    const orderHeaderEntityKeys = Object.keys(orderHeaderState.entities);
    return {
        ...orderHeaderState.entities[orderHeaderEntityKeys[0]],
        error: orderHeaderState?.error,
    };
});
const orderHeaderSelectors = {
    selectOrderContextState: selectOrderHeaderContextState,
    selectOrderHeader,
};

// Feature selector
const selectEditCartState = createFeatureSelector(EDIT_CART_KEY);
// Individual selectors
const selectEditCartOrder = createSelector(selectEditCartState, (state) => ({
    orderHeader: state.orderHeader,
    orderItems: state.orderItems,
}));
const EDIT_CART_SELECTORS = {
    selectEditCartState,
    selectEditCartOrder,
};

/* eslint-disable @typescript-eslint/naming-convention */
const FEATURES = {
    split_global_inspired_pick_products: 'split_global_inspired_pick_products',
    split_global_direct_shipping_savings: 'split_global_direct_shipping_savings',
    split_global_order_edit_cart: 'split_global_order_edit_cart',
    split_global_order_reviewed: 'split_global_order_reviewed',
};

const selectInspiredPicksState = createFeatureSelector(INSPIRED_PICKS_KEY);
const selectInspiredPicks = createSelector(selectInspiredPicksState, (inspiredPicksState) => inspiredPicksState);
const inspiredPicksSelectors = {
    selectInspiredPicks,
};

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class InspiredPicksStoreService {
    constructor(store, panamax) {
        this.store = store;
        this.panamax = panamax;
        this.inspiredPicks$ = this.store.select(inspiredPicksSelectors.selectInspiredPicks);
    }
    getInspiredPicks() {
        this.panamax
            .feature$([FEATURES.split_global_inspired_pick_products])
            .pipe(first())
            .subscribe((flagEnabled) => {
            if (flagEnabled) {
                this.store.dispatch(INSPIRED_PICKS_ACTIONS.getInspiredPicks());
            }
            else {
            }
        });
    }
}
InspiredPicksStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksStoreService, deps: [{ token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
InspiredPicksStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }, { type: i2.PanAppState }]; } });

class OrderStateService {
    constructor(browserStorageService, store, panAppState, inspiredPicksStoreService) {
        this.browserStorageService = browserStorageService;
        this.store = store;
        this.panAppState = panAppState;
        this.inspiredPicksStoreService = inspiredPicksStoreService;
        this.customerSubscription = null;
    }
    initializeUserStorage(user) {
        const dbInfo = [];
        dbInfo.push({
            dbName: `${user.userId}_${ORDER_DOMAIN_NAME}`,
            objectStoreNames: ORDER_STORAGE_KEYS,
        });
        return this.browserStorageService.initialize({ dbInfo });
    }
    initializeStore() {
        combineLatest([
            this.panAppState.user$,
            this.store.select(orderSelectors.selectReadyState()),
        ])
            .pipe(filter(([user, isReady]) => {
            const userIsValid = !!user &&
                user.hasOwnProperty('assignedCustomers') &&
                user.userId !== 'GUESTUSER';
            return userIsValid && !isReady;
        }))
            .subscribe(([user, isReady]) => {
            this.store.dispatch(MY_ORDERS_ACTIONS.initializeUserStorage({ user }));
            this.checkForPartnerData();
            this.store.dispatch(ORDER_REVIEW_ACTIONS.getOrderReviewPreferences());
            this.initializeCustomerSubscription();
            this.monitorUserLogout();
        });
        // Emit only when a full customer object is in state and only when
        // the customer switches
        const selectedCustomer$ = this.panAppState.customer$.pipe(filter((customer) => !!customer?.hasOwnProperty('customerName') &&
            !!customer?.hasOwnProperty('customerNumber') &&
            !!customer?.hasOwnProperty('departmentNumber')), distinctUntilChanged((curCustomer, prevCustomer) => prevCustomer.customerName === curCustomer.customerName &&
            prevCustomer.customerNumber === curCustomer.customerNumber &&
            prevCustomer.departmentNumber === curCustomer.departmentNumber), catchError(() => of(null)));
        // Only emit when there are orders in state
        const myOrders$ = this.store
            .select(orderSelectors.selectOrderContextState)
            .pipe(filter((ordersState) => ordersState.ready &&
            !ordersState.customerOrdersLoading &&
            !ordersState.importedOrdersLoading &&
            !ordersState.inProgressOrdersLoading &&
            !ordersState.orderStatusInFlight &&
            !ordersState.recentOrdersLoading), map((ordersState) => {
            const orders = Object.values(ordersState.entities);
            return orders;
        }), catchError(() => of(null)));
        combineLatest([
            selectedCustomer$,
            myOrders$,
            this.store.select(EDIT_CART_SELECTORS.selectEditCartState),
            this.panAppState.feature$([FEATURES.split_global_order_edit_cart]),
        ])
            .pipe(distinctUntilChanged(([curCustomer, co], [prevCustomer, po]) => prevCustomer.customerName === curCustomer.customerName), filter(([customers, orders, editCartState, enableEditCartUpdates]) => enableEditCartUpdates
            ? !editCartState || !Object.keys(editCartState.orderHeader).length
            : true), map(([customer, orders]) => this.getCurrentOrder(customer, orders)), tap((order) => {
            if (order) {
                this.store.dispatch(CART_ACTIONS.loadCartIntoContext({
                    order: {
                        orderHeader: order.orderHeader,
                        orderItems: order.orderItems,
                    },
                }));
            }
        }))
            .subscribe();
        this.store
            .select(orderHeaderSelectors.selectOrderHeader)
            .pipe(map((orderHeader) => orderHeader?.orderId), pairwise(), filter(([prevOrderId, currOrderId]) => prevOrderId !== currOrderId))
            .subscribe(([_, orderId]) => {
            if (orderId) {
                sessionStorage.setItem('orderInCart', `${orderId}`);
            }
        });
    }
    getFromUserOfflineStorage(user, storeEntityName) {
        const dbName = `${user?.userId}_${ORDER_DOMAIN_NAME}`;
        return this.browserStorageService.loadFromOfflineStorage(dbName, storeEntityName);
    }
    writeToUserOfflineStorage(user, storeEntityName, state) {
        const dbName = `${user?.userId}_${ORDER_DOMAIN_NAME}`;
        return this.browserStorageService.indexDB(dbName, storeEntityName, '0', state, MessageTypes.saveBrowserStorage);
    }
    checkForPartnerData() {
        this.panAppState.accessToken$
            .pipe(filter((token) => !!token), take(1), map((token) => {
            const decoded = this.decodeToken(token);
            const isPunchout = decoded['usf-claims']?.punchoutSession;
            const isPunchthru = decoded['usf-claims']?.punchthruSession;
            if (decoded && (isPunchout || isPunchthru)) {
                this.store.dispatch(PARTNER_ACTIONS.getPartnerData({
                    isPunchthru: isPunchthru ?? false,
                }));
            }
        }))
            .subscribe();
    }
    decodeToken(token) {
        return jwtDecode(token);
    }
    initializeCustomerSubscription() {
        if (this.customerSubscription) {
            return;
        }
        this.customerSubscription = combineLatest([
            this.panAppState.customer$,
            this.store.select(orderSelectors.selectReadyState()),
        ])
            .pipe(filter(([customer, isReady]) => {
            const customerIsValid = !!customer &&
                customer.hasOwnProperty('customerName') &&
                customer.hasOwnProperty('customerNumber') &&
                customer.hasOwnProperty('departmentNumber');
            return customerIsValid && isReady;
        }), distinctUntilChanged(([prevCustomer], [currCustomer]) => {
            const customerUnchanged = prevCustomer.customerName === currCustomer.customerName &&
                prevCustomer.customerNumber === currCustomer.customerNumber &&
                prevCustomer.departmentNumber === currCustomer.departmentNumber;
            return customerUnchanged;
        }))
            .subscribe(([session, customer]) => {
            this.store.dispatch(NEXT_DELIVERY_ACTIONS.getDeliveryInfo());
            this.store.dispatch(MY_ORDERS_ACTIONS.getCustomerOrders());
            this.store.dispatch(MY_ORDERS_ACTIONS.getInProgressOrdersContext());
            this.store.dispatch(DYF_ACTIONS.getDyfProducts());
            this.inspiredPicksStoreService.getInspiredPicks();
            this.store.dispatch(DSM_ACTIONS.getDsmInfo());
        });
    }
    getCurrentOrder(customer, orders) {
        const currentOrderId = sessionStorage.getItem('orderInCart');
        if (!currentOrderId) {
            return;
        }
        const currentOrder = orders.find((order) => order.orderHeader.orderId === currentOrderId);
        if (!!currentOrder &&
            currentOrder.orderHeader?.customerNumber === customer?.customerNumber) {
            return currentOrder;
        }
    }
    monitorUserLogout() {
        this.panAppState.user$.subscribe((user) => {
            if (user == null) {
                if (this.customerSubscription) {
                    this.customerSubscription.unsubscribe();
                    this.customerSubscription = null;
                }
            }
        });
    }
}
OrderStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStateService, deps: [{ token: i1$1.BrowserStorageService }, { token: i1.Store }, { token: i2.PanAppState }, { token: InspiredPicksStoreService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.BrowserStorageService }, { type: i1.Store }, { type: i2.PanAppState }, { type: InspiredPicksStoreService }]; } });

class OrderExceptionMessageParseService {
    /**
     *
     * @param unparsed OrderException param formatted with variable leading zeros like 0020220428
     * @returns 'mm/dd/yyyy'
     */
    static parseToDate(unparsed) {
        if (!unparsed) {
            return unparsed;
        }
        // Remove Leading Zeros
        const noLeadingZeros = unparsed.replace(/^0+/, '');
        const year = noLeadingZeros.substring(0, 4);
        const month = noLeadingZeros.substring(4, 6);
        const day = noLeadingZeros.substring(6);
        return `${month}/${day}/${year}`;
    }
}
OrderExceptionMessageParseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionMessageParseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OrderExceptionMessageParseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionMessageParseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionMessageParseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class PriceParseService {
    /**
     *
     * @param exceptionDetailPrice OrderExceptions contain an array of
     * exceptionDetails, sometimes a price with 4 digits for cents.
     * Use this method to parse that 4 decimal place number to fixed 2 precision.
     * @returns The price rounded to the nearest penny (2 precision decimal)
     */
    static parseExceptionDetailPrice(exceptionDetailPrice) {
        // Convert string price to number
        const priceToNumber = Number(exceptionDetailPrice);
        // Round to the nearest 100's
        const roundedPrice = Math.round(priceToNumber / 100) * 100;
        // Move the decimal place 4 digits
        const parsedPrice = roundedPrice / 10000;
        return parsedPrice;
    }
}
PriceParseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PriceParseService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PriceParseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PriceParseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PriceParseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class PercentNumberExpression extends RegExp {
    constructor(pattern, flags, arr) {
        super(pattern, flags);
        this.array = arr;
    }
    [Symbol.replace](str) {
        const matches = str.match(this);
        let results = str;
        matches?.forEach((item) => {
            const index = Number(item.replace('%', ''));
            const newExp = new RegExp('%' + index, this.flags);
            results = RegExp.prototype[Symbol.replace].call(newExp, results, this.array[index - 1]);
        });
        return results;
    }
}

/* eslint-disable max-len */
const orderExceptionMessages = {
    101: 'The order date must be at least %1 days prior to the next delivery date of %2. Please choose a new delivery date',
    102: 'Your requested delivery date of %1 exceeds the maximum order lead time of %2 days. Please choose a new delivery date.',
    103: 'The delivery date you entered is invalid. Your next scheduled delivery date is %1.',
    104: 'Please enter a different delivery date or accept the default date.',
    105: 'The order cutoff for (next day) requested delivery reached. Please enter a new date.',
    107: 'Delivery date %1 is past the Max of %2 Days Allowed from Order Date.',
    108: 'Delivery Date Overrides are NOT Allowed for Division %1',
    109: 'Delivery Date could not be determined for this order. Please contact your local division to schedule shipment.',
    200: 'This order exceeds the available credit limit for your account',
    501: 'Entered price %1 above limit. Price defaulted to %2.',
    502: 'The entered price of %1 is below the limit and pending approval. The product will ship at %2 unless approved. Update price to resolve now or resolve later to keep approval pending.',
    505: 'Price bracket entered of %1 is invalid for this customer',
    506: 'Custom pricing rationale cannot be updated from portable terminal.',
    507: 'Custom pricing fixed price update not allowed.',
    508: 'Custom pricing guaranteed price update not allowed.',
    509: 'Entered price %1 above limit of %2. Price taken.',
    510: 'Entered price %1 above warning limit of %2 - Price taken.',
    511: 'Entered price %1 below warning limit - Price taken.',
    512: 'Call Procurement, %1 Price Basis not found.',
    513: 'Call Procurement, Basis Amount not found for Price Basis: %1.',
    514: 'The extended cost for this product %p exceeds $1,000,000. Please reduce the number of units.',
    515: 'Rationale update not performed. Basis amount or input unit price is zero.',
    516: 'Entered bracket %1 resulted in no system price. Kept prior price.',
    518: 'No UPDATE_CPR_PRICE_BASIS in OPPBTDBT record',
    521: 'Product on contract, override not allowed. Entered price %1.',
    524: 'Price control customer, override not allowed. Entered price %1.',
    550: 'Entered Price, %1, qualifies for deviation on demand. Price taken.',
    551: 'No longer Deviation on Demand qualified due to order change.',
    604: 'Product %p is invalid.',
    605: 'Duplicate product %p on order. Please verify order quantities for this product.',
    606: 'This product is only available seasonally.',
    607: 'Product %p is not available.',
    608: 'This product can only be purchased in cases. Enter the number of cases to order.',
    609: 'This is a proprietary product. You have not been authorized.',
    610: 'Price for this product could not be determined.',
    611: 'Product %p was not added due to to a technical issue. Please call customer service to add this product to your order.',
    612: 'Order Guide line number %1 is not valid.',
    613: 'Customer Product Number %1 is not valid.',
    614: 'You have ordered individual units equal to or more than in a case. We have adjusted the quantities. Please accept or update the quantity.',
    615: 'Product %p was not added due to to a technical issue. Please call customer service to add this product to your order.',
    617: 'The original product ordered, %p for qty %1 / %2 is now available and has been added to your order.',
    618: 'Pricing Bus Type %1 Not Found for District %2 Dated',
    620: 'This product can only be purchased in cases. Enter the number of cases to order.',
    621: 'Product %p was not added to your order. Please call customer service to add this product to your order.',
    623: 'An error occurred while attempting to reserve this product. Please call customer service to validate product status.',
    624: 'You cannot order eaches on this order.',
    625: 'This is a Special Order product. Please create a separate order for this product.',
    626: 'Product %p is not available.',
    627: 'This product will only reserve one business day out.',
    700: 'You ordered more than the normal quantity.',
    701: 'The quantity requested exceeds the currently available inventory.',
    702: 'This product has been discontinued and no further inventory is available.',
    703: '%1 cases have been reserved. Remaining cases ordered are pending approval. Did you want to order %2 cases?',
    704: 'You have requested more than the quantity',
    705: 'Only a certain number of cases of this product can be ordered. You have exceeded your allocation or none was setup. Please call customer service for more information.',
    706: 'This is a USDA order and contains only USDA products. Product %p is not USDA.',
    707: 'This is a USDA product and can only be added to a USDA order. This is not a USDA order.',
    708: 'This USDA order is for %1 cases. At least %2 cases must be ordered.',
    709: 'Product number %p is not on your current order guide and cannot be ordered at this time.',
    711: 'Product %p is a special order item. Please call customer service to add this product to your order.',
    712: 'Product %p is a special order item. Please call customer service to add this product to your order.',
    713: 'This product is not available.',
    714: 'Special order, reserved %1 cases.',
    715: 'Special order, reserved %1 cases.',
    716: 'Special order, reserved %1 cases.',
    717: 'Your order for this product is on the waiting list.',
    718: 'Product %p was not added to your order. Please call customer service to add this product to your order.',
    719: 'Your order was received after the cutoff time for this product.',
    720: 'Incorrect Pick-up time for this product. Product is not added to the order.',
    721: 'Your order was received after the cutoff time for this product.',
    722: 'Product %p is not available.',
    725: 'You have not met the vendor minimum of %1 cases. This order will not be shipped.',
    726: 'You have exceeded the vendor maximum of %1 cases. This order will not be shipped.',
    727: 'You have not met the vendor minimum of %2. This order will not be shipped.',
    728: 'You have exceeded the vendor maximum of %2. This order will not be shipped.',
    729: 'You have not met the vendor minimum weight of %2. This order will not be shipped.',
    730: 'You have exceeded the vendor maximum weight of %2. This order will not be shipped.',
    731: 'Product %p is not in stock. Product must be re-ordered.',
    741: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    742: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    743: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    744: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    745: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    746: 'Product %p is not available for purchase. Please accept the recommended substitute or search for an alternate product.',
    750: 'Product %p is currently restricted. Please contact your sales team for more information.',
    751: 'Product %p is only available at Cash & Carry Store locations.',
    800: 'Weekly allocation of %1 cases exceeded. Order adjusted %2 cases / %3 eaches.',
    801: 'Product %p is an allocated product and cannot be ordered at this time.',
    1023: 'FATAL ERROR when trying to get price basis %1 for this product.',
    1024: 'Product %p is a USF Direct product. Please contact your sales team for more information.',
    1025: 'This is a USF Direct product. Orders should be entered through eComm (usfoods.com).',
    1026: 'You are not allowed to price override a USF Direct product.',
    1027: 'You are not allowed to create a CPR for a USF Direct product (561).',
    1029: 'Product %p insufficient inventory. Replaced with product %z.',
    1030: 'Product %p has been discontinued. Replaced with product %z.',
    1031: 'Product %p is proprietary. Replaced with product %z.',
    1032: 'Product %p is blocked for purchase. Replaced with product %z.',
    1035: 'Direct Product %p is unavailable today. We are working to get more inventory.',
    1036: 'Direct Product %p is no longer available.',
    1037: 'Unable to Order Direct Product %p. Contact your US Foods representative for more details.',
    2012: 'The current Order Guide number is not valid. Unable to accept this order for processing.',
};
const errorMessageForOrderException = (orderException) => {
    if (!orderException.errorCode) {
        return;
    }
    let templateString = orderExceptionMessages[orderException.errorCode];
    templateString = templateString.replace('%p', orderException.productNumber.toString());
    templateString = templateString.replace('%z', orderException?.exceptionDetails[1]?.toString() || '');
    switch (orderException.errorCode) {
        case 101:
            templateString = templateString
                .replace('%1', Number(orderException.exceptionDetails[0]).toString())
                .replace('%2', OrderExceptionMessageParseService.parseToDate(orderException.exceptionDetails[1]));
            break;
        case 102:
        case 103:
        case 107:
            templateString = templateString
                .replace('%1', OrderExceptionMessageParseService.parseToDate(orderException.exceptionDetails[0]))
                .replace('%2', Number(orderException.exceptionDetails[1]).toString());
            break;
        case 501:
            templateString = templateString
                .replace('%1', `$${PriceParseService.parseExceptionDetailPrice(orderException.exceptionDetails[0]).toFixed(2)}`)
                .replace('%2', `$${PriceParseService.parseExceptionDetailPrice(orderException.exceptionDetails[2]).toFixed(2)}`);
            break;
        case 502:
        case 509:
        case 510:
        case 511:
        case 521:
        case 524:
        case 550:
            templateString = templateString
                .replace('%1', `$${PriceParseService.parseExceptionDetailPrice(orderException.exceptionDetails[0]).toFixed(2)}`)
                .replace('%2', `$${PriceParseService.parseExceptionDetailPrice(orderException.exceptionDetails[1]).toFixed(2)}`);
            break;
        case 505:
        case 516:
        case 512:
        case 513:
        case 1023:
            templateString = templateString.replace('%1', Number(orderException.exceptionDetails[0]).toString());
            templateString = templateString.replace('%2', Number(orderException.exceptionDetails[1]).toString());
            break;
        case 703:
            /* No need to replace %2 here for error 703. %2 is unit ordered & handled in template */
            templateString = templateString.replace('%1', Number(orderException.exceptionDetails[0]).toString());
            break;
        default:
            const newExp = new PercentNumberExpression(/%\d/, 'g', orderException.exceptionDetails);
            templateString = templateString.replace(newExp, undefined);
            break;
    }
    return templateString;
};

/**
 * PURE static functions for client side calculated pricing logic
 */
class OrderPricingService {
    /**
     * PURE function for calculating price a customer will be charged
     *
     * @param totalDollars Cost of products
     * @param totalSalesTax Sales tax on dollars
     * @param totalCharges Extra charges
     * @param totalAllowances Discounts
     * @returns The total price an order will cost a customer
     */
    static calculateTotalPrice(totalDollars, totalSalesTax, totalCharges, totalAllowances) {
        return ((totalDollars || 0) +
            (totalSalesTax || 0) +
            (totalCharges || 0) -
            (totalAllowances || 0));
    }
}
OrderPricingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPricingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OrderPricingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPricingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPricingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class OrderItemDTOService {
    constructor() { }
    /**
     * Transform an array of server model OrderItems to client model OrderItems
     *
     * @param orderItemDTO Array of server model OrderItems
     * @returns Array of client model OrderItems
     */
    toClientModelArray(orderItemDTOs) {
        const orderItems = [];
        if (orderItemDTOs) {
            for (const orderItemDTO of orderItemDTOs) {
                // Remove Order Items that have neither units or eaches on order
                if (!!orderItemDTO.unitsOrdered || !!orderItemDTO.eachesOrdered) {
                    orderItems.push(this.toClientModel(orderItemDTO));
                }
            }
        }
        return orderItems;
    }
    /**
     * Transfom a server OrderItem to client model OrderItem
     *
     * @param orderItemDTO server model OrderItem
     * @returns client model OrderItem
     */
    toClientModel(orderItemDTO) {
        const orderItem = {
            ...orderItemDTO,
            unitsOrdered: {
                currentValue: !!orderItemDTO.unitsOrdered
                    ? orderItemDTO.unitsOrdered
                    : undefined,
                previousValue: !!orderItemDTO.unitsOrdered
                    ? orderItemDTO.unitsOrdered
                    : undefined,
                loading: false,
                error: null,
            },
            eachesOrdered: {
                currentValue: !!orderItemDTO.eachesOrdered
                    ? orderItemDTO.eachesOrdered
                    : undefined,
                previousValue: !!orderItemDTO.eachesOrdered
                    ? orderItemDTO.eachesOrdered
                    : undefined,
                loading: false,
                error: null,
            },
        };
        return orderItem;
    }
    /**
     * Transforms an Array of client model OrderItems to server model OrderItems
     *
     * @param orderItems Array of client model OrderItems
     * @returns Array of server model OrderItems
     */
    toServerModelArray(orderItems) {
        const orderItemDTOs = [];
        if (!!orderItems?.length) {
            for (const orderItem of orderItems) {
                orderItemDTOs.push(this.toServerModel(orderItem));
            }
        }
        return orderItemDTOs;
    }
    /**
     * Transforms a client model OrderItem to a server model OrderItem
     *
     * @param orderItem client model OrderItem
     * @returns server model OrderItem
     */
    toServerModel(orderItem) {
        const orderItemDTO = {
            ...orderItem,
            unitsOrdered: orderItem.unitsOrdered.currentValue,
            eachesOrdered: orderItem.eachesOrdered.currentValue,
        };
        return orderItemDTO;
    }
}
OrderItemDTOService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemDTOService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
OrderItemDTOService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemDTOService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemDTOService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class OrderDtoService {
    constructor(orderItemDTOService) {
        this.orderItemDTOService = orderItemDTOService;
    }
    /**
     * Transforms a server model Order to a client model Order
     *
     * @param orderDTO Server model Order
     * @returns Client model Order
     */
    toClientModel(orderDTO) {
        const { orderItems, ...orderHeader } = orderDTO;
        const orderExceptions = orderHeader.orderExceptions?.map((exception) => ({
            ...exception,
            subOrReplaceItems: this.orderItemDTOService.toClientModelArray(exception.subOrReplaceItems),
            errorMessage: errorMessageForOrderException(exception),
        }));
        return {
            ...orderHeader,
            orderStatus: OrderStatus[orderDTO.orderStatus],
            totalPrice: OrderPricingService.calculateTotalPrice(orderDTO.totalDollars, orderDTO.totalSalesTax, orderDTO.totalCharges, orderDTO.totalAllowances),
            orderExceptions,
        };
    }
    /**
     * Transfom a client Order to server model Order
     *
     * @param orderHeader client model Order
     * @returns server model Order
     */
    toServerModel(orderHeader) {
        const orderExceptions = orderHeader.orderExceptions?.map((exception) => ({
            ...exception,
            subOrReplaceItems: this.orderItemDTOService.toServerModelArray(exception.subOrReplaceItems),
        }));
        // Remove client only domain fields from incoming orderHeader
        const { totalPrice, ...restOfOrderHeader } = orderHeader;
        const orderDTO = {
            ...restOfOrderHeader,
            errorDetails: null,
            orderItems: [],
            orderExceptions,
        };
        return orderDTO;
    }
}
OrderDtoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDtoService, deps: [{ token: OrderItemDTOService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderDtoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDtoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDtoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: OrderItemDTOService }]; } });

const setOrdersFilters = createAction('[NgRx - Order] Set the orders filters', props());
const MY_ORDERS_FILTER_ACTIONS = {
    setOrdersFilters,
};

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class MyOrdersStoreService {
    constructor(store, panamax) {
        this.store = store;
        this.panamax = panamax;
    }
    retrieveMyOrders() {
        this.store.dispatch(MY_ORDERS_ACTIONS.getMyOrdersContext());
    }
    retrieveCustomerOrders() {
        this.store.dispatch(MY_ORDERS_ACTIONS.getCustomerOrders());
    }
    retrieveRecentOrders() {
        this.store.dispatch(MY_ORDERS_ACTIONS.getRecentOrders());
    }
    retrieveImportedOrdersById(importOrderIdentifier) {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.getImportedOrdersById({ importOrderIdentifier }));
    }
    retrieveImportedOrdersByDate(importDate) {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDate({ importDate }));
    }
    setImportedOrdersFilters(filters, filtersSelected) {
        this.store.dispatch(IMPORTED_ORDERS_FILTERS_ACTIONS.setImportedOrdersFilters({
            filters,
            filtersSelected,
        }));
    }
    setMyOrdersFilters(filters, filterSelected) {
        this.store.dispatch(MY_ORDERS_FILTER_ACTIONS.setOrdersFilters({ filters, filterSelected }));
    }
    getOrderWithId(orderId) {
        return this.store.select(orderSelectors.selectOrderWithId(orderId));
    }
    retrieveOrderDetails(tandemOrderNumber, isEditFlow) {
        this.store.dispatch(MY_ORDERS_ACTIONS.getOrderDetails({ tandemOrderNumber, isEditFlow }));
    }
    state$() {
        return this.store.select(orderSelectors.selectOrderContextState);
    }
}
MyOrdersStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersStoreService, deps: [{ token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
MyOrdersStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }, { type: i2.PanAppState }]; } });

const selectNextDeliveryDetailState = createFeatureSelector(NEXT_DELIVERY_KEY);
const selectNextDeliveryDetails = createSelector(selectNextDeliveryDetailState, (nextDeliveryInfoState) => nextDeliveryInfoState);
const nextDeliverySelectors = {
    selectNextDeliveryDetails,
};

class DeliveryStoreService {
    constructor(store) {
        this.store = store;
        this.nextDelivery$ = this.store.select(nextDeliverySelectors.selectNextDeliveryDetails);
    }
    getNextDeliveryInformation() {
        return this.store.select(nextDeliverySelectors.selectNextDeliveryDetails);
    }
}
DeliveryStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DeliveryStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
DeliveryStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DeliveryStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DeliveryStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const NGRX_ORDER_LIB_CONFIG = new InjectionToken('NGRX_ORDER_LIB_CONFIG');

const HEADER_CACHE_CONTROL = 'Cache-Control';
const HEADER_PRAGMA = 'Pragma';
const HEADER_EXPIRES = 'Expires';
class HttpVerbService {
    constructor() {
        this.http = inject(HttpClient);
    }
    /**
     * @param url full path of the endpoint
     * @param params optional additional HttpParams
     */
    get(url, params) {
        const headers = new HttpHeaders({
            [HEADER_CACHE_CONTROL]: 'no-cache',
            [HEADER_PRAGMA]: 'no-cache',
            [HEADER_EXPIRES]: '0',
        });
        return this.http
            .get(url, {
            params,
            headers,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param url full path of the endpoint
     * @param body the body of the put call
     * @param params optional additional HttpParams
     */
    put(url, body, params) {
        return this.http
            .put(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param url full path of the endpoint
     * @param body the body of the post call
     * @param params optional additional HttpParams
     */
    post(url, body, params) {
        return this.http
            .post(url, body || {}, {
            params,
        })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param url full path of the endpoint
     * @param body the body of the delete call
     */
    delete(url, body) {
        return this.http
            .request('delete', url, { body })
            .pipe(catchError(this.handleError));
    }
    /**
     * @param errror - error response received from the api request
     * @returns empty Observable
     */
    handleError(error) {
        return throwError(error);
    }
}
HttpVerbService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpVerbService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HttpVerbService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpVerbService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HttpVerbService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class OrderDataService {
    constructor(config, httpVerbService, orderItemDTOService, orderDTOService) {
        this.config = config;
        this.httpVerbService = httpVerbService;
        this.orderItemDTOService = orderItemDTOService;
        this.orderDTOService = orderDTOService;
    }
    getInProgressOrders() {
        return this.getOrders(`orders`);
    }
    getMyOrders(watermark = null) {
        let url = 'myorders';
        if (watermark) {
            url += '?watermark=' + watermark;
        }
        return this.getOrders(url);
    }
    getRecentOrders() {
        return this.getOrders('recentorders');
    }
    getCustomerOrders(customerWatermarks = null, customerNumber) {
        let url = 'customerOrders';
        if (customerWatermarks[customerNumber]) {
            url += `?watermark=${customerWatermarks[customerNumber]}`;
        }
        else {
            url += '?watermark=1995-08-26T15:28:17.854Z';
        }
        return this.getOrders(url);
    }
    deleteOrder(payload) {
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(payload.orderHeader),
        };
        return this.httpVerbService
            .delete(`${this.config.apiUrl}/orders`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    getOrderContext(order) {
        if (!order) {
            const date = new Date();
            order = {};
            order.requestedDeliveryDate = date;
            order.confirmedDeliveryDate = date;
            order.orderItems = [];
        }
        //client should always set decomposeFlag to true; //
        const myOrder = {
            ...order,
            confirmedDeliveryDate: order.requestedDeliveryDate,
            decomposeFlag: true,
        };
        return this.httpVerbService
            .put(`${this.config.apiUrl}/orders`, myOrder)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            // const serverOrderItems = [...resp.orderItems];
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    getDeliveryDate() {
        return this.httpVerbService
            .get(`${this.config.requestReplyApiUrl}/nextDeliveryDate`)
            .pipe(take(1), filter((resp) => !!resp), map((res) => res), catchError((error) => throwError(error)));
    }
    updateOrderHeader(payload) {
        return this.updateOrder({ ...payload, updateOrderItem: null });
    }
    submitOrder(payload) {
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(payload.orderHeader),
        };
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(payload.orderItems),
        ];
        const isNotInOneOfTheSubmittedStatus = orderTransaction.orderStatus === 'IN_PROGRESS' ||
            orderTransaction.tandemOrderNumber == null ||
            orderTransaction.tandemOrderNumber === 0;
        const path = isNotInOneOfTheSubmittedStatus
            ? `submitIpOrder`
            : `updateSubmittedOrder`;
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/${path}`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    convertToWillCall(payload) {
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(payload.orderHeader),
        };
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(payload.orderItems),
        ];
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/convertToWillCall`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp?.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    createCopiedOrder(order) {
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(order.orderHeader),
        };
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(order.orderItems),
        ];
        let totalEaches = 0;
        let totalUnits = 0;
        orderTransaction.orderItems.forEach((eachItem) => {
            totalEaches += eachItem.eachesOrdered ? eachItem.eachesOrdered : 0;
            totalUnits += eachItem.unitsOrdered ? eachItem.unitsOrdered : 0;
        });
        orderTransaction.totalEaches = totalEaches;
        orderTransaction.totalUnits = totalUnits;
        return this.httpVerbService
            .put(`${this.config.apiUrl}/orders`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    updateOrder(payload) {
        // Create a new OrderTransaction for the API
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(payload.orderHeader),
        };
        // Populate the existing OrderItems
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(payload.orderItems),
        ];
        let adding = false;
        let deleting = false;
        let editing = false;
        let incrementing = false;
        if (!!payload.updateOrderItem) {
            // If the updateOrderItem's product number is not found in the existing order items array, it means we are 'adding'
            adding = !payload.orderItems.find((oi) => oi.productNumber === payload.updateOrderItem.productNumber);
            // falsy values in both cases and eaches mean we are doing a 'deleting'
            deleting =
                !payload.updateOrderItem.eachesOrdered.currentValue &&
                    !payload.updateOrderItem.unitsOrdered.currentValue;
            // truthy value in either cases or eaches mean we are doing an 'editing'
            editing =
                !!payload.updateOrderItem.eachesOrdered.currentValue ||
                    !!payload.updateOrderItem.unitsOrdered.currentValue;
            incrementing =
                editing &&
                    (payload.updateOrderItem.eachesOrdered.currentValue >
                        (payload.updateOrderItem.eachesOrdered.previousValue
                            ? payload.updateOrderItem.eachesOrdered.previousValue
                            : 0) ||
                        payload.updateOrderItem.unitsOrdered.currentValue >
                            (payload.updateOrderItem.unitsOrdered.previousValue
                                ? payload.updateOrderItem.unitsOrdered.previousValue
                                : 0));
            if (adding) {
                orderTransaction.orderItems.push(this.orderItemDTOService.toServerModel(payload.updateOrderItem));
            }
            else if (deleting) {
                const index = orderTransaction.orderItems.findIndex((orderItem) => orderItem.productNumber === payload.updateOrderItem.productNumber);
                if (index > -1) {
                    orderTransaction.orderItems.splice(index, 1);
                }
            }
            else if (editing) {
                const index = orderTransaction.orderItems.findIndex((orderItem) => orderItem.productNumber === payload.updateOrderItem.productNumber);
                if (index > -1) {
                    orderTransaction.orderItems[index] = this.orderItemDTOService.toServerModel(payload.updateOrderItem);
                }
            }
        }
        let totalEaches = 0;
        let totalUnits = 0;
        orderTransaction.orderItems.forEach((eachItem) => {
            totalEaches += eachItem.eachesOrdered ? eachItem.eachesOrdered : 0;
            totalUnits += eachItem.unitsOrdered ? eachItem.unitsOrdered : 0;
        });
        orderTransaction.totalEaches = totalEaches;
        orderTransaction.totalUnits = totalUnits;
        return this.httpVerbService
            .put(`${this.config.apiUrl}/orders`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    resolveOrder(payload) {
        // Create a new OrderTransaction for the API
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(payload.orderHeader),
        };
        // Populate the existing OrderItems
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(payload.orderItems),
        ];
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/updateSubmittedOrder`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    updateShipToDetails(order) {
        const orderTransaction = {
            ...this.orderDTOService.toServerModel(order.orderHeader),
        };
        orderTransaction.orderItems = [
            ...this.orderItemDTOService.toServerModelArray(order.orderItems),
        ];
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/shipToConversion`, orderTransaction)
            .pipe(take(1), filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    cancelSubmittedOrder(o) {
        const requestBody = {
            divisionNumber: o.orderHeader.divisionNumber,
            customerNumber: o.orderHeader.customerNumber,
            departmentNumber: o.orderHeader.departmentNumber,
            tandemOrderNumber: o.orderHeader.tandemOrderNumber,
        };
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/cancelSubmittedOrder`, requestBody)
            .pipe(take(1), filter((resp) => !!resp), map((orderTransaction) => {
            const orderItems = this.orderItemDTOService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDTOService.toClientModel(orderTransaction);
            return {
                order: {
                    orderHeader,
                    orderItems,
                },
            };
        }), catchError((error) => throwError(error)));
    }
    getOrderDetails(tandemOrderNumber) {
        return this.httpVerbService
            .get(`${this.config.requestReplyApiUrl}/orderDetail?orderNumber=${tandemOrderNumber}`)
            .pipe(filter((resp) => !!resp), map((orderTransaction) => {
            const orderItems = this.orderItemDTOService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDTOService.toClientModel(orderTransaction);
            return {
                orderHeader,
                orderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    getOrders(url) {
        return this.httpVerbService
            .get(`${this.config.apiUrl}/${url}`)
            .pipe(filter((resp) => !!resp), map((resp) => resp
            .filter((a) => !!a)
            .map((orderTransaction) => {
            const orderItems = this.orderItemDTOService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDTOService.toClientModel(orderTransaction);
            return {
                orderHeader,
                orderItems,
            };
        })), catchError((error) => throwError(error)));
    }
    getOrderById(orderId) {
        return this.httpVerbService
            .get(`${this.config.apiUrl}/orders?orderId=${orderId}`)
            .pipe(filter((resp) => !!resp), map((orderTransactionArray) => {
            const orderTransaction = orderTransactionArray[0];
            const orderItems = this.orderItemDTOService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDTOService.toClientModel(orderTransaction);
            return {
                orderHeader,
                orderItems,
            };
        }), catchError((error) => throwError(error)));
    }
    /**
     * Retrieves a VPT order by its ID.
     *
     * @param orderId The ID of the order to retrieve.
     * @returns An observable that emits the retrieved order.
     */
    getVptOrderByOrderNumber(orderNumber) {
        return this.httpVerbService
            .get(`${this.config.submissionApiUrl}/vptorder?ec_ord_id=${orderNumber}`)
            .pipe(filter((resp) => !!resp), map((orderTransaction) => {
            const orderItems = this.orderItemDTOService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDTOService.toClientModel(orderTransaction);
            return {
                order: {
                    orderHeader,
                    orderItems,
                },
                orderNumber,
            };
        }), catchError((error) => throwError(error)));
    }
}
OrderDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDataService, deps: [{ token: NGRX_ORDER_LIB_CONFIG }, { token: HttpVerbService }, { token: OrderItemDTOService }, { token: OrderDtoService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ORDER_LIB_CONFIG]
                }] }, { type: HttpVerbService }, { type: OrderItemDTOService }, { type: OrderDtoService }]; } });

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class OrderStoreService {
    constructor(store, panamax) {
        this.store = store;
        this.panamax = panamax;
    }
    static applyUpdateOrderItem(orderHeader, orderItems, updateOrderItem) {
        const updateOrderHeader = JSON.parse(JSON.stringify(orderHeader));
        const updateOrderItems = JSON.parse(JSON.stringify(orderItems));
        const itemIndex = updateOrderItems?.findIndex((element) => element?.productNumber === updateOrderItem?.productNumber);
        if (itemIndex >= 0) {
            // edit existing item in a cart
            updateOrderItems[itemIndex].eachesOrdered =
                updateOrderItem?.eachesOrdered;
            updateOrderItems[itemIndex].eachesReserved =
                updateOrderItem?.eachesReserved;
            updateOrderItems[itemIndex].unitsOrdered = updateOrderItem?.unitsOrdered;
            updateOrderItems[itemIndex].unitsReserved =
                updateOrderItem?.unitsReserved;
            updateOrderItems[itemIndex].unitPriceOverride =
                updateOrderItem?.unitPriceOverride;
            updateOrderItems[itemIndex].unitPrice = updateOrderItem?.unitPrice;
            updateOrderItems[itemIndex].quantityAccepted =
                updateOrderItem?.quantityAccepted;
            updateOrderItems[itemIndex].submittedQuantityAccepted =
                updateOrderItem?.submittedQuantityAccepted;
            updateOrderItems[itemIndex].dirtyFlag = true;
        }
        if (itemIndex === -1) {
            // adding new item
            updateOrderItems.push({ ...updateOrderItem, dirtyFlag: true });
        }
        // Final orderItems array:
        return {
            orderHeader: updateOrderHeader,
            orderItems: updateOrderItems,
        };
    }
    submitOrder(orderHeader, orderItems, trackingData) {
        this.store.dispatch(CART_ACTIONS.submitCart({
            order: { orderHeader, orderItems },
        }));
    }
    convertToWillCall(orderHeader, orderItems, isEditWillCallFlow, trackingData) {
        this.store.dispatch(MY_ORDERS_ACTIONS.convertToWillCall({
            orderHeader,
            orderItems,
            isEditWillCallFlow,
            trackingData,
        }));
    }
    updateOrderHeader(orderHeader, orderItems) {
        this.store.dispatch(CART_ACTIONS.updateCart({ order: { orderHeader, orderItems } }));
    }
    deleteOrder(orderHeader, orderItems) {
        this.store.dispatch(CART_ACTIONS.deleteCart({
            order: { orderHeader, orderItems },
        }));
    }
    updateOrder(orderHeader, orderItems, updateOrderItem) {
        const order = OrderStoreService.applyUpdateOrderItem(orderHeader, orderItems, updateOrderItem);
        if (updateOrderItem?.specialVendor) {
            this.store.dispatch(DIRECT_SHIPPING_ACTIONS.clearLastModified({
                orderId: orderHeader.orderId,
            }));
        }
        this.store.dispatch(CART_ACTIONS.updateCart({ order }));
    }
    createCopiedOrder(order, previousOrder) {
        this.store.dispatch(CART_ACTIONS.createCopiedOrder({ newOrder: order, previousOrder }));
    }
    createNewOrder(message, defaultPo) {
        if (message && !message.id) {
            message.id = v4();
        }
        this.store.dispatch(CART_ACTIONS.createNewCart({ message, defaultPo }));
    }
    removeEmptyOrderItems() {
        this.store.dispatch(CART_ACTIONS.removeEmptyCartItems());
    }
    loadOrderIntoContext(order) {
        this.store.dispatch(CART_ACTIONS.loadCartIntoContext({
            order: {
                orderHeader: order.orderHeader,
                orderItems: order.orderItems,
            },
        }));
    }
    cancelSubmittedOrder(order) {
        this.store.dispatch(CART_ACTIONS.cancelSubmittedCart({ order }));
    }
    resetOrder() {
        this.store.dispatch(CART_ACTIONS.clearCart());
    }
    checkOrderStatus(orderId) {
        this.store.dispatch(MY_ORDERS_ACTIONS.checkOrderStatus({ orderId }));
    }
    setLoading(isLoading) {
        this.store.dispatch(CART_ACTIONS.setLoading({ isLoading }));
    }
    getVptOrderByOrderNumber(orderNumber) {
        this.store.dispatch(VISUAL_PUNCHTHRU_ACTIONS.getVptOrderByOrderNumber({ orderNumber }));
    }
    updateShipToDetails(order) {
        this.store.dispatch(SHIP_TO_ACTIONS.updateShipToDetails({ order }));
    }
    getNvptOrderByOrderNumber(orderNumber, orderType) {
        this.store.dispatch(NON_VISUAL_PUNCHTHRU_ACTIONS.getNvptOrderByOrderNumber({
            orderNumber,
            orderType,
        }));
    }
}
OrderStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStoreService, deps: [{ token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
OrderStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }, { type: i2.PanAppState }]; } });

const selectOrderItemState = createSelector(CART_SELECTORS.selectAsLegacyOrderItemState, (cartState) => cartState);
const selectOrderItemEntities = createSelector(selectOrderItemState, (orderItemState) => orderItemState?.entities);
const selectOrderItems = createSelector(selectOrderItemEntities, (entities) => {
    if (!entities) {
        return [];
    }
    else {
        return Object.keys(entities).map((id) => entities[parseInt(id, 10)]);
    }
});
const selectOrderItemTallies = createSelector(selectOrderItemState, (orderItemState) => ({
    totalItems: orderItemState?.tallies?.totalItems || 0,
    totalCases: orderItemState?.tallies?.totalCases || 0,
    totalEaches: orderItemState?.tallies?.totalEaches || 0,
    totalShipments: orderItemState?.tallies?.totalShipments || 0,
}));
const orderItemSelectors = {
    selectOrderItemState,
    selectOrderItemEntities,
    selectOrderItems,
    selectOrderItemTallies,
};

class OrderItemStoreService {
    constructor(store) {
        this.store = store;
    }
    loadOrderItemTallies() {
        return this.store.select(orderItemSelectors.selectOrderItemTallies);
    }
    removeEmptyOrderItems() {
        this.store.dispatch(CART_ACTIONS.removeEmptyCartItems());
    }
}
OrderItemStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderItemStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderItemStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const orderExceptionAdapter = createEntityAdapter({
    selectId: (exception) => 
    // eslint-disable-next-line @typescript-eslint/dot-notation
    `${exception.orderException.errorCode}:${exception.orderException.productNumber}`,
});
const initialOrderExceptionState = orderExceptionAdapter.getInitialState({
    order: undefined,
    expandedSection: {},
    isConfirmationFlow: false,
});
const reducer$d = createReducer(initialOrderExceptionState, on(ORDER_EXCEPTION_ACTIONS.setOrderExceptionsForOrder, (state, { order, exceptionResolutions, expandedSection }) => orderExceptionAdapter.setAll(exceptionResolutions, {
    ...state,
    order,
    expandedSection,
})), on(ORDER_EXCEPTION_ACTIONS.resolveException, (state, { exceptionResolution }) => orderExceptionAdapter.upsertOne(exceptionResolution, { ...state })), on(ORDER_EXCEPTION_ACTIONS.expandSection, (state, { isExpanded, sectionType }) => {
    const expandedSection = {
        ...state.expandedSection,
        [sectionType]: isExpanded,
    };
    return {
        ...state,
        expandedSection,
    };
}), on(ORDER_EXCEPTION_ACTIONS.resolveOrder, (state) => orderExceptionAdapter.setAll([], {
    ...state,
    order: undefined,
})), on(ORDER_EXCEPTION_ACTIONS.clearOrderExceptions, (_) => initialOrderExceptionState), on(ORDER_EXCEPTION_ACTIONS.setIsConfirmationFlow, (state, { isConfirmationFlow }) => ({
    ...state,
    isConfirmationFlow,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function orderExceptionReducer(
// replaced object type by Record<string, unknown> per eslint recommendation
state, action) {
    return reducer$d(state, action);
}
const { selectAll: selectAll$2, selectEntities: selectEntities$2, selectIds: selectIds$2, selectTotal: selectTotal$2, } = orderExceptionAdapter.getSelectors();

const selectOrderExceptionState = createFeatureSelector(ORDER_EXCEPTION_KEY);
const selectIsConfirmationFlow = () => createSelector(selectOrderExceptionState, (orderExceptionState) => orderExceptionState.isConfirmationFlow);
const orderExceptionSelectors = {
    selectOrderExceptionState,
    selectIsConfirmationFlow,
    selectEntities: selectEntities$2,
};

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class OrderExceptionStoreService {
    constructor(store) {
        this.store = store;
    }
    setOrderExceptions(order, exceptionResolutions) {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.setOrderExceptionsForOrder({
            order,
            exceptionResolutions,
            expandedSection: {},
        }));
    }
    expandException(isExpanded, sectionType) {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.expandSection({ isExpanded, sectionType }));
    }
    getOrderException() {
        return this.store.select(orderExceptionSelectors.selectOrderExceptionState);
    }
    resolveException(exceptionResolution) {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.resolveException({ exceptionResolution }));
    }
    resolveOrder(order) {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.resolveOrder({ order }));
    }
    clearOrderExceptions() {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.clearOrderExceptions());
    }
    setIsConfirmationFlow(isConfirmationFlow) {
        this.store.dispatch(ORDER_EXCEPTION_ACTIONS.setIsConfirmationFlow({ isConfirmationFlow }));
    }
    isConfirmationFlow() {
        return this.store.select(orderExceptionSelectors.selectIsConfirmationFlow());
    }
}
OrderExceptionStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderExceptionStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const NG_RX_ORDER_EVENTS = {
    namespace: 'Order',
    eventType: [
        'CancelOrderEvent',
        'SubmitIpOrderEvent',
        'UpdateSubmittedOrderEvent',
        'ConvertToWillCallEvent',
        'ShipToConversionEvent',
    ],
};

class OrderClientWebSocketService {
    constructor(webSocketService, store) {
        this.webSocketService = webSocketService;
        this.store = store;
        this.subscriptions = [];
        /**
         * @remarks
         * This method maps the incoming websocket event event action defined in @usf/order-types
         * to the appropriate NgRx action.  New events can be added to the map without impacting performance
         *
         * @param eventAction - The action attached to the websocket event
         * @param event - The data attached to the websocket event
         * @returns The NgRx action that will interact with the store
         */
        this.handleEvent = (eventAction, event) => ({
            [OrderTransactionEventActions.CancelOrder]: () => MY_ORDERS_ACTIONS.cancelOrderAsync({
                orderTransactions: event.data.messageContent,
                watermark: event.data.watermark,
                contexts: event.data.contexts,
                version: event.version,
            }),
            [OrderTransactionEventActions.SubmitIpOrder]: () => MY_ORDERS_ACTIONS.submitIpOrderAsync({
                orderTransactions: event.data.messageContent,
                watermark: event.data.watermark,
                contexts: event.data.contexts,
                version: event.version,
            }),
            [OrderTransactionEventActions.UpdateSubmittedOrder]: () => MY_ORDERS_ACTIONS.updateSubmittedOrderAsync({
                orderTransactions: event.data.messageContent,
                watermark: event.data.watermark,
                contexts: event.data.contexts,
                version: event.version,
            }),
            [OrderTransactionEventActions.ConvertToWillCall]: () => MY_ORDERS_ACTIONS.convertToWillCallAsync({
                orderTransactions: event.data.messageContent,
                watermark: event.data.watermark,
                contexts: event.data.contexts,
                version: event.version,
            }),
            [OrderTransactionEventActions.ShipToConversion]: () => MY_ORDERS_ACTIONS.updateShipToDetailsAsync({
                orderTransactions: event.data.messageContent,
                watermark: event.data.watermark,
                contexts: event.data.contexts,
                version: event.version,
            }),
        })[eventAction]();
    }
    initialize() {
        // if there is no websocket service injected, return out
        // eslint-disable-next-line @typescript-eslint/dot-notation
        if (!this.webSocketService['baseUrl']) {
            // eslint-disable-next-line no-console
            console.info('%c** no websocket injected for order domain **', 'color: black; font-weight:bold;');
            return;
        }
        // subscribe to the websocket events scoped to the order domain
        // panamax websocket service lib will handle keeping the websocket connection
        // alive and will update the isConnected$ observable accordingly
        this.subscriptions.push(this.webSocketService?.isConnected$.subscribe((connected) => {
            if (connected) {
                // Register websocket namespace and event types to subscribe to
                this.webSocketService.register([NG_RX_ORDER_EVENTS]);
                this.subscriptions.push(this.webSocketService?.getTopicData().subscribe((event) => {
                    let eventData;
                    try {
                        if (!!event?.data && this.isObject(JSON.parse(event?.data))) {
                            eventData = JSON.parse(event?.data);
                            // dispatch appropriate NgRx action based on incoming websocket event action
                            if (eventData?.data?.namespace === 'Order' &&
                                eventData?.data?.eventAction) {
                                console.log('WEBSOCKET EVENT:  ', eventData);
                                console.log('EVENT:  ', eventData?.data?.eventAction);
                                if (eventData?.data?.messageContent) {
                                    this.store.dispatch(this.handleEvent(eventData?.data?.eventAction, eventData));
                                }
                            }
                        }
                        else {
                            eventData = null;
                        }
                    }
                    catch (e) {
                        console.log('Error handling websocket event: ', e);
                    }
                }));
            }
            else {
                // eslint-disable-next-line no-console
                console.info('%c** order domain web socket disconnected. **', 'color: red; font-weight:bold;');
            }
        }));
    }
    isObject(obj) {
        return obj === Object(obj);
    }
}
OrderClientWebSocketService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderClientWebSocketService, deps: [{ token: i1$2.WebSocketService }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderClientWebSocketService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderClientWebSocketService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderClientWebSocketService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.WebSocketService }, { type: i1.Store }]; } });

const ANALYTICS_ACTIONS = {
    trackingOrderPageLoad: createAction('[NgRxOrder Analytics] - Track Order page Load', props()),
    trackSubmitOrderStart: createAction('[NgRxTrace - Order] - Track Submit Order Start', props()),
    trackSubmitOrderApiResponseSuccess: createAction('[NgRxTrace - Order] - Track Submit Order API Response Success', props()),
    trackSubmitOrderApiResponseFail: createAction('[NgRxTrace - Order] - Track Submit Order API Response Failed', props()),
    trackSubmitOrderWebsocket: createAction('[NgRxTrace - Order] - Track Submit Order Websocket Response', props()),
};

/**
 * SUBMIT ORDER
 *
 * @param tracking
 * @returns Data Layer needed for tracking the submit order event
 */
const submitOrder = (tracking) => {
    const result = {
        event: tracking.data.event,
        capability: tracking.data.capability,
        order: tracking.data.order,
        products: tracking.data.products,
    };
    return result;
};
/**
 * SUBMIT ORDER SUCCESS TRACING
 *
 * @param tracking
 * @returns Data Layer needed for tracking the submit order tracing event
 */
const submitOrderTracing = (tracking) => {
    const result = {
        ...tracking?.data?.attributes,
    };
    return result;
};
/**
 * SUBMIT ORDER FAIL TRACING
 *
 * @param tracking
 * @returns Data Layer needed for tracking the submit order failed tracing event
 */
const submitOrderTracingFail = (tracking) => {
    const result = {
        ...tracking?.data?.attributes,
    };
    return result;
};
/**
 * NEW ORDER SUBMIT: WEB SOCKET ARRIVAL TRACING
 *
 * @param tracking
 * @returns Data Layer needed for tracking the submit order WEBSOCKET tracing event
 */
const submitOrderWebsocketTracing = (tracking) => {
    const result = {
        ...tracking?.data?.attributes,
    };
    return result;
};
const submitOrderStartTracing = (trackingData) => {
    const result = {
        event: trackingData.data.attributes?.event,
        order: {
            orderId: trackingData.data.attributes?.orderId,
        },
    };
    return result;
};
const submitEditOrderStartTracing = (trackingData) => {
    const result = {
        event: trackingData.data.attributes?.event,
        order: {
            orderId: trackingData.data.attributes?.orderId,
            tandemOrderNumber: trackingData.data.attributes?.tandemOrderNumber,
        },
    };
    return result;
};
const submitOrderSuccessTracing = (trackingData) => {
    const result = {
        event: trackingData.data.attributes?.event,
        order: {
            orderId: trackingData.data.attributes?.order?.orderId,
            totalAmount: trackingData.data.attributes?.order?.totalAmount,
        },
        products: trackingData.data.attributes?.products,
    };
    return result;
};

class OrderAnalyticsService {
    constructor(store) {
        this.store = store;
    }
    trackSubmitOrder() {
        this.store
            .select(orderHeaderSelectors.selectOrderHeader)
            .pipe(take(1))
            .subscribe((orderHeader) => {
            const tracking = {
                tracing: {
                    data: {
                        isEndOfTrace: false,
                        isStartOfTrace: true,
                        traceContext: 'order',
                        attributes: {
                            event: 'Submit Order Start',
                            orderId: orderHeader.orderId,
                            tandemOrderNumber: orderHeader.tandemOrderNumber,
                        },
                    },
                    transformFunc: submitOrderStartTracing,
                },
            };
            if (orderHeader.tandemOrderNumber) {
                tracking.tracing.transformFunc = submitEditOrderStartTracing;
                tracking.tracing.data.attributes.event = 'Submit Edit Order Start';
            }
            this.store.dispatch(ANALYTICS_ACTIONS.trackSubmitOrderStart({ tracking }));
        });
    }
    trackSubmitOrderApiFail(error) {
        const tracking = {
            tracing: {
                data: {
                    isEndOfTrace: true,
                    isStartOfTrace: false,
                    traceContext: 'order',
                    attributes: {
                        error: !!error ? error : {},
                    },
                },
                transformFunc: submitOrderTracingFail,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackSubmitOrderApiResponseFail({ tracking }));
    }
    trackSubmitOrderApiSuccess(trackingData) {
        if (!trackingData.tracing.data.attributes?.errorDetails) {
            const tracking = {
                analytics: {
                    data: {
                        ...trackingData.analytics.data,
                        event: 'order submitted',
                        capability: 'orders',
                    },
                    transformFunc: submitOrder,
                },
                tracing: {
                    data: {
                        ...trackingData?.tracing?.data,
                        traceContext: 'order',
                    },
                    transformFunc: submitOrderSuccessTracing,
                },
            };
            this.store.dispatch(ANALYTICS_ACTIONS.trackSubmitOrderApiResponseSuccess({ tracking }));
        }
    }
    trackSubmitOrderWebsocket(trackingData) {
        const tracking = {
            tracing: {
                data: {
                    ...trackingData.tracing.data,
                    isEndOfTrace: true,
                    isStartOfTrace: false,
                    traceContext: 'order',
                },
                transformFunc: submitOrderWebsocketTracing,
            },
        };
        this.store.dispatch(ANALYTICS_ACTIONS.trackSubmitOrderWebsocket({ tracking }));
    }
}
OrderAnalyticsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderAnalyticsService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderAnalyticsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderAnalyticsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class OrderPunchoutStoreService {
    constructor(store) {
        this.store = store;
    }
    punchoutLogout(orderXml) {
        this.store.dispatch(ORDER_PUNCHOUT_ACTIONS.punchoutLogout({ orderXml }));
    }
}
OrderPunchoutStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderPunchoutStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

const selectDirectShippingState = createFeatureSelector(DIRECT_SHIPPING_KEY);
const selectDirectShippingSavingsForOrderId = (orderId) => createSelector(selectDirectShippingState, (directShippingState) => {
    const directShippingSavings = directShippingState.entities[orderId];
    return directShippingSavings;
});
const directShippingSelectors = {
    selectDirectShippingState,
    selectDirectShippingSavingsForOrderId,
};

class DirectShippingStoreService {
    constructor(store, panAppState) {
        this.store = store;
        this.panAppState = panAppState;
    }
    getDirectShippingSavings(order, checkTimestamp) {
        const selectDirectShippingSavingsForOrderId$ = this.store.select(directShippingSelectors.selectDirectShippingSavingsForOrderId(order?.orderHeader?.orderId));
        const directShippingSavingsEnabled$ = this.panAppState.feature$([
            FEATURES.split_global_direct_shipping_savings,
        ]);
        combineLatest([
            selectDirectShippingSavingsForOrderId$,
            directShippingSavingsEnabled$,
        ])
            .pipe(take(1))
            .subscribe(([directShipSavings, directShippingSavingsEnabled]) => {
            if (directShippingSavingsEnabled) {
                //Filter for only unique special vendor products
                const uniqueVSItems = new Set();
                const filteredItems = order?.orderItems?.filter((orderItem) => {
                    if (orderItem?.specialVendor &&
                        !uniqueVSItems.has(orderItem.productNumber)) {
                        uniqueVSItems.add(orderItem.productNumber);
                        return true;
                    }
                    return false;
                });
                if (!filteredItems.length) {
                    return;
                }
                const filteredOrder = { ...order, orderItems: filteredItems };
                if (checkTimestamp) {
                    const thirtyMinutesAgo = new Date(new Date().getTime() - 1000 * 60 * 30).toISOString();
                    if (!directShipSavings?.lastUpdated ||
                        directShipSavings.lastUpdated < thirtyMinutesAgo) {
                        this.store.dispatch(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavings({
                            order: filteredOrder,
                        }));
                    }
                }
                else {
                    this.store.dispatch(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavings({
                        order: filteredOrder,
                    }));
                }
            }
        });
    }
}
DirectShippingStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingStoreService, deps: [{ token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
DirectShippingStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }, { type: i2.PanAppState }]; } });

const selectDYFState = createFeatureSelector(DYF_PRODUCT_KEY);
const selectDYF = createSelector(selectDYFState, (dyfProductState) => dyfProductState);
const dyfSelectors = {
    selectDYF,
};

/**
 * This service should only select and dispatch from the @ngrx/store
 */
class DidYouForgetStoreService {
    constructor(store) {
        this.store = store;
        this.didYouForget$ = this.store.select(dyfSelectors.selectDYF);
    }
}
DidYouForgetStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DidYouForgetStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
DidYouForgetStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DidYouForgetStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DidYouForgetStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

/**
 * CartSyncService is responsible for synchronizing the cart state with the server.
 * The service listens for changes in the cart state and initiates synchronization actions
 * when necessary, such as when the cart is dirty or the order status is IN_PROGRESS.
 */
class CartSyncService {
    constructor() {
        /**
         * Creates an instance of CartSyncService.
         *
         * @param store The NgRx store
         */
        this.store = inject(Store);
    }
    initialize() {
        // Select cart state and fail count from the store
        const cartState$ = this.store.select(CART_SELECTORS.selectCart);
        // Default 1 second interval, take until feature flag is false
        const ticker$ = timer(0, 1000);
        this.cartSyncSubscription$ = cartState$
            .pipe(switchMap((cartState) => ticker$.pipe(filter(() => new Date(cartState.dirty) <= new Date()), 
        // Only include cartStates with an order status of IN_PROGRESS
        filter(() => cartState.orderHeader.orderStatus === OrderStatus.IN_PROGRESS ||
            !cartState.orderHeader.orderStatus), 
        // Only include cartStates marked as dirty
        filter(() => !!cartState.dirty?.length), 
        // Only include cartStates currently not saving
        filter(() => !cartState.saving?.length), 
        // Only include cartStates currently not loading
        filter(() => !cartState.loading), 
        // Map to Order object
        map(() => ({
            orderHeader: cartState.orderHeader,
            orderItems: cartState.orderItems,
        })))))
            .subscribe((order) => {
            // Dispatch syncCart action
            this.store.dispatch(CART_SYNC_ACTIONS.cartSync({ order }));
        });
    }
    unsubscribe() {
        this.cartSyncSubscription$?.unsubscribe();
    }
}
CartSyncService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CartSyncService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

// Define the feature selector for the import orders state slice
const selectState$1 = createFeatureSelector(IMPORT_ORDERS_KEY);
const selectLoading$1 = createSelector(selectState$1, (state) => state.loading);
const selectLoaded = createSelector(selectState$1, (state) => state.loaded);
const selectError = createSelector(selectState$1, (state) => state.error);
const selectOrders = createSelector(selectState$1, (state) => {
    const { entities } = state;
    return Object.values(entities);
});
const selectFileImportError = createSelector(selectState$1, (state) => state.fileImportError);
const selectFileImportErrors = createSelector(selectState$1, (state) => state.fileImportErrors);
const selectMessage = createSelector(selectState$1, (state) => state.message);
const selectTransactionArray = createSelector(selectState$1, (state) => Object.values(state.entities));
const selectFileName = createSelector(selectState$1, (state) => state.fileName);
const selectFileFormat = createSelector(selectState$1, (state) => state.fileFormat);
const selectImportOrderCheck = createSelector(selectState$1, (state) => state.importOrderCheck);
const IMPORT_ORDERS_SELECTORS = {
    selectState: selectState$1,
    selectLoading: selectLoading$1,
    selectLoaded,
    selectError,
    selectOrders,
    selectFileImportError,
    selectFileImportErrors,
    selectMessage,
    selectTransactionArray,
    selectFileName,
    selectFileFormat,
    selectImportOrderCheck,
};

class ImportOrdersStoreService {
    constructor() {
        this.store = inject(Store);
    }
    /**
     * Sets Import Orders State Slice to initial state
     */
    initialize() {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.initialize());
    }
    /**
     * Sends a file containing orders to be imported
     *
     * @param ordersFile the file containing the orders to be imported
     */
    load(ordersFile, fileType) {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.load({ ordersFile, fileType }));
    }
    /**
     * Submits all the orders in the import-orders state slice that aren't deleted
     *
     * @param orders the orders not deleted from the import-orders state slice
     */
    submit(orders, expectation) {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.submit({
            orders,
            expectation,
        }));
    }
    /**
     * Sets the ImportOrderCheck state slice
     *
     * @param expectation The desired ImportOrderCheck state
     */
    setImportOrderCheck(expectation) {
        this.store.dispatch(IMPORT_ORDERS_ACTIONS.setImportOrderCheck({ expectation }));
    }
    /**
     * Selects the entire ImportOrdersState from the store.
     *
     * @returns An observable of the complete ImportOrdersState.
     */
    state$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectState);
    }
    /**
     * Selects the loading status from the ImportOrdersState.
     *
     * @returns An observable representing the loading status, either true or false.
     */
    loading$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectLoading);
    }
    /**
     * Selects the loading status from the ImportOrdersState.
     *
     * @returns An observable representing the loading status, either true or false.
     */
    loaded$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectLoaded);
    }
    /**
     * Selects the error property from the ImportOrdersState.
     *
     * @returns An observable representing any error that might have occurred. The value is undefined if there are no errors.
     */
    error$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectError);
    }
    /**
     * Selects all OrderTransaction objects from the ImportOrdersState.
     *
     * @returns An observable of an array of OrderTransaction objects.
     */
    orders$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectOrders);
    }
    /**
     * Selects the fileImportError flag.
     *
     * @returns An observable representing the fileImportError flag.
     */
    fileImportError$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectFileImportError);
    }
    /**
     * Selects the fileImportErrors array of errors.
     *
     * @returns An observable representing the fileImportErrors.
     */
    fileImportErrors$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectFileImportErrors);
    }
    /**
     * Selects the Message.
     *
     * @returns An observable representing the message.
     */
    message$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectMessage);
    }
    /**
     * Selects the order transactions as an array.
     *
     * @returns An observable representing the order transactions.
     */
    orderTransactions$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectTransactionArray);
    }
    /**
     * Selects the file name the user selected for upload.
     *
     * @returns An observable representing the file name.
     */
    fileName$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectFileName);
    }
    /**
     * Selects the file format the user selected for upload.
     *
     * @returns An observable representing the file format.
     */
    fileFormat$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectFileFormat);
    }
    /**
     * Selects the import order check.
     *
     * @returns An observable representing the import order check.
     */
    importOrderCheck$() {
        return this.store.select(IMPORT_ORDERS_SELECTORS.selectImportOrderCheck);
    }
}
ImportOrdersStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersStoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ImportOrdersStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const selectPartnerState = createFeatureSelector(PARTNER_KEY);
const selectPartner = createSelector(selectPartnerState, (partnerState) => partnerState);
const partnerSelectors = {
    selectPartner,
};

class PartnerStoreService {
    constructor(store) {
        this.store = store;
        this.partner$ = this.store.select(partnerSelectors.selectPartner);
    }
}
PartnerStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
PartnerStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class OrderPunchoutDataService {
    constructor(http, usfTokenStorageService) {
        this.http = http;
        this.usfTokenStorageService = usfTokenStorageService;
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
    }
    logUserXml(orderXML) {
        return this.usfTokenStorageService.getPunchoutSession().pipe(switchMap((punchoutSession) => {
            const formattedXml = 'browserFormPost=' +
                punchoutSession?.browserFormPost +
                '|' +
                orderXML;
            console.log('Logging orderXml:', formattedXml);
            const headers = new HttpHeaders({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'Content-Type': 'text/plain',
            });
            return this.http
                .post(`${this.config.apiUrl}/punchoutLog`, formattedXml, {
                headers,
            })
                .pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
        }));
    }
}
OrderPunchoutDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutDataService, deps: [{ token: i1$3.HttpClient }, { token: i2.UsfTokenStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderPunchoutDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: i2.UsfTokenStorageService }]; } });

const uqeAdapter = createEntityAdapter({
    selectId: (uqeProductLimits) => uqeProductLimits.productNumber,
});
const initialUqeState = uqeAdapter.getInitialState({
    loading: false,
    error: null,
});
const reducer$c = createReducer(initialUqeState, on(UQE_ACTIONS.clearUqe, (state) => ({ ...state, ...initialUqeState })), on(UQE_ACTIONS.getUqeProducts, (state) => ({ ...state, loading: true })), on(UQE_ACTIONS.getUqeProductsSuccess, (state, { uqeProducts }) => uqeAdapter.upsertMany(uqeProducts, {
    ...state,
    loading: false,
    error: null,
})), on(UQE_ACTIONS.getUqeProductsFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function uqeReducer(state, action) {
    return reducer$c(state, action);
}
const { selectAll: selectAll$1, selectIds: selectIds$1, selectEntities: selectEntities$1, selectTotal: selectTotal$1, } = uqeAdapter.getSelectors();

const selectAllUnusualQuantities = selectAll$1;
const selectState = createFeatureSelector(UQE_KEY);
const selectUnusualQuantities = createSelector(selectState, selectAllUnusualQuantities);
const selectUqeProductNumbers = createSelector(selectState, (state) => Object.keys(state.entities).map(Number));
const selectUqeByProductNumber = (productNumber) => createSelector(selectState, (state) => Object.values(state.entities).find((uqe) => uqe.productNumber === productNumber));
const filterOutExistingUqeProducts = (uqeProductNumbers) => createSelector(selectState, (state) => uqeProductNumbers.filter((uqeProductNum) => !Object.keys(state.entities)
    .map(Number)
    .includes(uqeProductNum.productNumber)));
const selectLoading = createSelector(selectState, (state) => state.loading);
const UQE_SELECTORS = {
    selectState,
    selectLoading,
    selectUnusualQuantities,
    selectUqeProductNumbers,
    selectUqeByProductNumber,
    filterOutExistingUqeProducts,
};

class UqeStoreService {
    constructor() {
        this.store = inject(Store);
    }
    /**
     * Sets Unusual Quantities State Slice to initial state
     */
    initialize() {
        this.store.dispatch(UQE_ACTIONS.clearUqe());
    }
    /**
     * Makes /getUqeProducts API call and fills in Unusual Quantities state.
     * The API is only called with the product numbers not loaded in the Unusual Quantities state.
     *
     * @param uqeProductNumbers product numbers with pimGroupId to get unusual quantity limits
     */
    getUnusualQuantities(uqeProductNumbers) {
        this.store.dispatch(UQE_ACTIONS.getUqeProducts({ productNumbers: uqeProductNumbers }));
    }
    /**
     * Selects the entire Unusual Quantities State
     *
     * @returns An observable of the complete Unusual Quantities state
     */
    state$() {
        return this.store.select(UQE_SELECTORS.selectState);
    }
    /**
     * Selects the loading status from the Unusual Quantities State
     *
     * @returns An observable representing the loading status
     */
    loading$() {
        return this.store.select(UQE_SELECTORS.selectLoading);
    }
    /**
     * Selects all UnusualQuantityLimits from the UnusualQuantitiesState
     *
     * @returns An observable of an array of UnusualQuantityLimits
     */
    unusualQuantities$() {
        return this.store.select(UQE_SELECTORS.selectUnusualQuantities);
    }
    unusualQuantityByProductNumber$(productNumber) {
        return this.store.select(UQE_SELECTORS.selectUqeByProductNumber(productNumber));
    }
}
UqeStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeStoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
UqeStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const initialOrderReviewState = {
    loading: false,
    error: null,
    ids: [],
    entities: {},
};

const orderReviewAdapter = createEntityAdapter({
    selectId: (orderPref) => `${orderPref.customerNumber}:${orderPref.departmentNumber}:${orderPref.tandemOrderNumber}`,
    sortComparer: false,
});
const reducer$b = createReducer(initialOrderReviewState, on(ORDER_REVIEW_ACTIONS.getOrderReviewPreferences, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(ORDER_REVIEW_ACTIONS.getOrderReviewPreferencesSuccess, (state, { orderReviewPreferences }) => orderReviewAdapter.upsertMany(orderReviewPreferences, {
    ...state,
    loading: false,
    error: null,
})), on(ORDER_REVIEW_ACTIONS.getOrderReviewPreferencesFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
})), on(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferences, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferencesSuccess, (state, { orderReviewPreferences }) => orderReviewAdapter.upsertOne(orderReviewPreferences, {
    ...state,
    loading: false,
    error: null,
})), on(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferencesFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
})), on(ORDER_REVIEW_ACTIONS.clearOrderReviewPreferences, (state) => ({
    ...state,
    ...initialOrderReviewState,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function orderReviewReducer(state, action) {
    return reducer$b(state, action);
}
const { selectAll, selectEntities, selectIds, selectTotal } = orderReviewAdapter.getSelectors();

const selectOrderReviewState = createFeatureSelector(ORDER_REVIEW_KEY);
const selectAllOrderReviewPreferences = createSelector(selectOrderReviewState, selectAll);
const selectOrderReviewLoading = createSelector(selectOrderReviewState, (state) => state.loading);
const ORDER_REVIEW_SELECTORS = {
    selectOrderReviewState,
    selectAllOrderReviewPreferences,
    selectOrderReviewLoading,
};

/* eslint-disable no-underscore-dangle */
class OrderReviewStoreService {
    constructor(store) {
        this.store = store;
        this._allOrderReviewPreferences$ = this.store.select(ORDER_REVIEW_SELECTORS.selectAllOrderReviewPreferences);
        this._loading$ = this.store.select(ORDER_REVIEW_SELECTORS.selectOrderReviewLoading);
    }
    getOrderReviewPreferences() {
        this.store.dispatch(ORDER_REVIEW_ACTIONS.getOrderReviewPreferences());
    }
    get allOrderReviewPreferences$() {
        return this._allOrderReviewPreferences$;
    }
    get loading$() {
        return this._loading$;
    }
    updateOrderReviewPreferences(orderId) {
        this.store.dispatch(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferences({
            orderId,
        }));
    }
}
OrderReviewStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewStoreService, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderReviewStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; } });

class OrderReviewDataService {
    constructor(config, httpVerbService, orderDTOService, orderItemDTOService) {
        this.config = config;
        this.httpVerbService = httpVerbService;
        this.orderDTOService = orderDTOService;
        this.orderItemDTOService = orderItemDTOService;
    }
    getOrderReviewPreferences$() {
        return this.httpVerbService
            .get(`${this.config.apiUrl}/orderReviewPreferences`)
            .pipe(filter$1((resp) => !!resp), take$1(1));
    }
    updateOrderReviewPreferences(order) {
        const orderTransaction = this.orderDTOService.toServerModel(order?.orderHeader);
        orderTransaction.orderItems = this.orderItemDTOService.toServerModelArray(order?.orderItems);
        return this.httpVerbService
            .post(`${this.config.apiUrl}/orderReviewPreferences`, orderTransaction)
            .pipe(filter$1((resp) => !!resp), take$1(1));
    }
}
OrderReviewDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewDataService, deps: [{ token: NGRX_ORDER_LIB_CONFIG }, { token: HttpVerbService }, { token: OrderDtoService }, { token: OrderItemDTOService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderReviewDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ORDER_LIB_CONFIG]
                }] }, { type: HttpVerbService }, { type: OrderDtoService }, { type: OrderItemDTOService }]; } });

const initialNextDeliveryState = {
    creditIndicator: false,
    deliveryDate: null,
    loading: true,
    error: null,
};
const reducer$a = createReducer(initialNextDeliveryState, on(NEXT_DELIVERY_ACTIONS.resetStore, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(NEXT_DELIVERY_ACTIONS.getDeliveryInfo, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(NEXT_DELIVERY_ACTIONS.getDeliveryInfoSuccess, (state, action) => ({
    ...state,
    creditIndicator: action.nextDelivery.creditIndicator,
    deliveryDate: action.nextDelivery.deliveryDate,
    errNumber: action.nextDelivery.errNumber,
    loading: false,
    error: null,
})), on(NEXT_DELIVERY_ACTIONS.getDeliveryInfoFail, (state, error) => ({
    ...state,
    loading: false,
    error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function nextDeliveryReducer(state, action) {
    return reducer$a(state, action);
}

const ordersFiltersState = {
    filters: {},
    filterSelected: 0,
};
const reducer$9 = createReducer(ordersFiltersState, on(MY_ORDERS_FILTER_ACTIONS.setOrdersFilters, (state, { filters, filterSelected }) => ({
    filters,
    filterSelected,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function ordersFiltersReducer(
// replaced object type by Record<string, unknown> per eslint recommendation
state, action) {
    return reducer$9(state, action);
}

// Define the initial state
const initialCartState = {
    orderHeader: {},
    orderItems: [],
    loading: false,
    error: null,
    dirty: null,
    saving: null,
    watermark: null,
    failCount: 0,
    tallies: null,
};

const cartReducer = createReducer(initialCartState, on(CART_ACTIONS.clearCart, (state) => ({
    ...state,
    ...initialCartState,
})), on(CART_ACTIONS.updateCart, (state, { order }) => ({
    ...state,
    ...order,
    failCount: 0,
    tallies: tallyOrderItems(order.orderItems),
    dirty: new Date().toISOString(),
})), on(CART_ACTIONS.createNewCart, (state) => ({
    ...state,
    loading: true,
})), on(CART_ACTIONS.createNewCartSuccess, (state, { order }) => ({
    ...state,
    ...order,
    loading: false,
    error: null,
    dirty: null,
    saving: null,
    tallies: {
        totalItems: 0,
        totalCases: 0,
        totalEaches: 0,
        totalShipments: 0,
    },
})), on(CART_ACTIONS.createNewCartFail, (state, { error }) => ({
    ...state,
    error,
    loading: false,
})), on(CART_ACTIONS.createCopiedOrder, (state) => ({
    ...state,
    loading: true,
})), on(CART_ACTIONS.createCopiedOrderSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    dirty: null,
    saving: null,
})), on(CART_ACTIONS.createCopiedOrderFail, (state, { error }) => ({
    ...state,
    error,
    loading: false,
})), on(CART_ACTIONS.updateDeliveryDates, (state, { nextDeliveryDate }) => ({
    ...state,
    orderHeader: {
        ...state.orderHeader,
        requestedDeliveryDate: nextDeliveryDate,
        confirmedDeliveryDate: nextDeliveryDate,
    },
})), on(CART_ACTIONS.submitCart, (state, { order }) => ({
    ...state,
    ...order,
    loading: true,
    error: null,
})), on(CART_ACTIONS.submitCartSuccess, (state, { order }) => ({
    ...state,
    ...order,
    loading: false,
    dirty: null,
})), on(CART_ACTIONS.submitCartFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
})), on(CART_SYNC_ACTIONS.cartSync, (state) => ({
    ...state,
    loading: true,
    saving: new Date().toISOString(),
    dirty: null,
    error: null,
})), on(CART_SYNC_ACTIONS.cartSyncSuccess, (state, { order }) => cartSyncSuccessState(state, order)), on(CART_SYNC_ACTIONS.cartSyncFail, (state, { error }) => {
    const failCount = state.failCount < 10 ? state.failCount + 1 : 10;
    const dirtyDate = new Date();
    dirtyDate.setSeconds(dirtyDate.getSeconds() + failCount + 1);
    return {
        ...state,
        error,
        loading: false,
        saving: null,
        failCount,
        dirty: dirtyDate.toISOString(),
    };
}), on(CART_ACTIONS.loadCartIntoContext, (state, { order }) => {
    if (order.orderHeader.orderStatus === OrderStatus.ORDER_ERROR ||
        order.orderHeader.orderStatus === OrderStatus.SUBMITTING) {
        const orderWithOriginalStatus = {
            ...order,
            orderHeader: {
                ...order.orderHeader,
                orderStatus: getOrderErrorOriginalStatus(order.orderHeader),
            },
        };
        return {
            ...state,
            orderHeader: orderWithOriginalStatus.orderHeader,
            orderItems: orderWithOriginalStatus.orderItems,
            loading: false,
            error: null,
            dirty: new Date().toISOString(),
            saving: null,
            tallies: {
                totalItems: 0,
                totalCases: 0,
                totalEaches: 0,
                totalShipments: 0,
            },
        };
    }
    else {
        return {
            ...state,
            orderHeader: order.orderHeader,
            orderItems: order.orderItems,
            loading: false,
            error: null,
            dirty: null,
            saving: null,
            tallies: {
                totalItems: 0,
                totalCases: 0,
                totalEaches: 0,
                totalShipments: 0,
            },
        };
    }
}), on(CART_ACTIONS.removeEmptyCartItems, (state) => {
    const nonEmptyItems = state.orderItems.filter((item) => item.unitsOrdered?.currentValue || item.eachesOrdered?.currentValue);
    return { ...state, orderItems: nonEmptyItems };
}), on(CART_ACTIONS.setLoading, (state, { isLoading }) => ({
    ...state,
    loading: isLoading,
})));
/**
 * When the API responds with an order, for the first time, we
 * need to update the state with the orderHeader, but not the orderItems.
 * This way if the user has update qty's those new qty's will be preserved,
 * and a new sync requested since dirty is preserved.
 */
const cartSyncSuccessState = (state, order) => {
    /**
     * When no orderId, preserve the orderItems, update the orderHeader.
     * Otherwise, just set flags, dont modify orderHeader or OrderItems.
     * Need to update the orderItems updateDtm every time. API uses it as versioning.
     */
    if (state.dirty) {
        if (state.orderHeader.orderId) {
            return {
                ...state,
                orderHeader: updateStampsOnOrderHeader(state.orderHeader, order.orderHeader),
                orderItems: updateDtmStampOnOrderItems(state.orderItems, order.orderItems),
                loading: false,
                saving: null,
                failCount: 0,
                error: null,
            };
        }
        else {
            const { orderItems, ...rest } = state;
            // Only update the fields from order listed below
            rest.orderHeader = order.orderHeader;
            rest.loading = false;
            rest.saving = null;
            rest.failCount = 0;
            rest.error = null;
            // Return updated state with original state orderItems and updated stamps
            return {
                ...rest,
                orderItems: updateDtmStampOnOrderItems(orderItems, order.orderItems),
            };
        }
    }
    else {
        return {
            ...state,
            orderHeader: order.orderHeader,
            orderItems: order.orderItems,
            loading: false,
            saving: null,
            failCount: 0,
            error: null,
        };
    }
};
const updateDtmStampOnOrderItems = (stateOrderItems, cartOrderItems) => stateOrderItems.map((stateOrderItem) => {
    const matchingCartItem = cartOrderItems.find((cartOrderItem) => cartOrderItem.productNumber === stateOrderItem.productNumber);
    if (matchingCartItem) {
        return {
            ...stateOrderItem,
            updateDtm: matchingCartItem.updateDtm,
        };
    }
    else {
        return stateOrderItem;
    }
});
const updateStampsOnOrderHeader = (stateHeader, orderHeader) => ({
    ...stateHeader,
    updateDtm: orderHeader.updateDtm,
    version: orderHeader.version,
    watermarkDtm: orderHeader.watermarkDtm,
});
const tallyOrderItems = (orderItems) => {
    let totalItems = 0;
    let totalCases = 0;
    let totalEaches = 0;
    const totalShipments = 1; // No calculations are done yet due to API not returning shipments
    for (const orderItem of orderItems) {
        totalCases += orderItem?.unitsOrdered?.currentValue || 0;
        totalEaches += orderItem?.eachesOrdered?.currentValue || 0;
        totalItems = totalCases + totalEaches;
    }
    return {
        totalItems,
        totalCases,
        totalEaches,
        totalShipments,
    };
};
const getOrderErrorOriginalStatus = (orderHeader) => {
    if (orderHeader.tandemOrderNumber) {
        if (orderHeader.orderExceptions?.length > 0) {
            return OrderStatus.SUBMITTED_WITH_EXCEPTIONS;
        }
        else {
            return OrderStatus.SUBMITTED;
        }
    }
    else {
        return OrderStatus.IN_PROGRESS;
    }
};

const importOrdersAdapter = createEntityAdapter(
// create selectId to populate the clientId
{
    selectId: (orderTransaction) => orderTransaction.clientId,
});
const initialImportOrdersState = {
    ...importOrdersAdapter.getInitialState(),
    fileImportError: null,
    fileImportErrors: [],
    fileName: '',
    fileFormat: '',
    message: null,
    importOrderCheck: null,
    loading: false,
    loaded: false,
    error: null,
};
const reducer$8 = createReducer(initialImportOrdersState, on(IMPORT_ORDERS_ACTIONS.initialize, (state) => ({
    ...state,
    ...initialImportOrdersState,
})), on(IMPORT_ORDERS_ACTIONS.load, (state, { ordersFile, fileType }) => ({
    ...state,
    ...initialImportOrdersState,
    fileName: ordersFile.name,
    fileFormat: fileType,
    loading: true,
    loaded: false,
})), on(IMPORT_ORDERS_ACTIONS.loadSuccess, (state, { importOrders }) => importOrdersAdapter.setAll(importOrders.orderTransactions, {
    ...state,
    loading: false,
    loaded: true,
    fileImportError: importOrders.fileImportError,
    fileImportErrors: importOrders.fileImportErrors,
    message: importOrders.message,
    error: null,
})), on(IMPORT_ORDERS_ACTIONS.loadFail, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    fileImportError: false,
    fileImportErrors: [],
    message: null,
    error,
})), on(IMPORT_ORDERS_ACTIONS.submit, (state) => ({
    ...state,
    loading: true,
    error: null,
})), on(IMPORT_ORDERS_ACTIONS.submitSuccess, (state, { orders, expectation }) => ({
    ...state,
    ...initialImportOrdersState,
    importOrderCheck: expectation,
})), on(IMPORT_ORDERS_ACTIONS.submitFail, (state, { error }) => ({
    ...state,
    loading: false,
    error,
})), on(IMPORT_ORDERS_ACTIONS.setImportOrderCheck, (state, { expectation }) => ({
    ...state,
    importOrderCheck: expectation,
})));
const importOrdersReducer = (state, action) => reducer$8(state, action);

const initialPartnerState = {
    loading: false,
    error: undefined,
    partnerName: undefined,
    partnerId: undefined,
    punchoutProfile: undefined,
    siteRoleProfile: null,
    isPunchthru: false,
};
const reducer$7 = createReducer(initialPartnerState, on(PARTNER_ACTIONS.getPartnerData, (state, action) => ({
    ...state,
    isPunchthru: action.isPunchthru,
    loading: true,
    error: null,
})), on(PARTNER_ACTIONS.getPartnerDataSuccess, (state, action) => ({
    ...state,
    partnerName: action.partner.partnerName,
    partnerId: action.partner.partnerId,
    punchoutProfile: action.partner.punchoutProfile,
    siteRoleProfile: action.partner.siteRoleProfile,
    loading: false,
    error: null,
})), on(PARTNER_ACTIONS.getPartnerDataFail, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function partnerReducer(state, action) {
    return reducer$7(state, action);
}

const orderControlFeatureKey = 'orderControl';
const initialState$3 = {
    orderControl: [],
    error: null,
    loading: true,
};
const reducer$6 = createReducer(initialState$3, on(ORDER_CONTROL_ACTIONS.loadOrderControl, (state, action) => ({
    ...state,
    loading: true,
    error: null,
})), on(ORDER_CONTROL_ACTIONS.loadOrderControlSuccess, (state, action) => ({
    ...state,
    orderControl: action.orderControls,
    loading: false,
    error: null,
})), on(ORDER_CONTROL_ACTIONS.loadOrderControlFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function orderControlReducer(state, action) {
    return reducer$6(state, action);
}

const dsmInfoFeatureKey = 'dsmInfo';
const initialState$2 = {
    dsmInfo: [],
    error: null,
    loading: true,
};
const reducer$5 = createReducer(initialState$2, on(DSM_ACTIONS.getDsmInfo, (state, action) => ({
    ...state,
    loading: true,
    error: null,
})), on(DSM_ACTIONS.getDsmInfoSuccess, (state, action) => ({
    ...state,
    dsmInfo: action.dsmInfo,
    loading: false,
    error: null,
})), on(DSM_ACTIONS.getDsmInfoFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function dsmInfoReducer(state, action) {
    return reducer$5(state, action);
}

// replaced object type by Record<string, unknown> per eslint recommendation
const selectOrdersFiltersState = createFeatureSelector(ORDERS_FILTERS_KEY);
const selectOrdersFilters = createSelector(selectOrdersFiltersState, (ordersFiltersState) => ordersFiltersState);
const ordersFiltersSelectors = {
    selectOrdersFilters,
};

const selectImportedOrdersFiltersState = createFeatureSelector(IMPORTED_ORDERS_FILTERS_KEY);
const selectImportedOrdersFilters = createSelector(selectImportedOrdersFiltersState, (importedOrdersFiltersState) => importedOrdersFiltersState);
const IMPORTED_ORDERS_FILTERS_SELECTORS = {
    selectImportedOrdersFilters,
};

const selectOrderItemFilterState = createFeatureSelector(ORDER_ITEM_FILTER_KEY);
const selectSearchKey = createSelector(selectOrderItemFilterState, (filterState) => filterState?.searchKey);
const ORDER_ITEM_FILTER_SELECTORS = {
    selectSearchKey,
};

const selectDsmInfoState = createFeatureSelector(DSM_KEY);
const selectDsmInfo = createSelector(selectDsmInfoState, (dsmInfoState) => dsmInfoState);
const dsmSelectors = {
    selectDsmInfo,
};

const generateMockOrder = () => {
    return {
        orderHeader: generateMockOrderHeader(),
        orderItems: [generateMockOrderItem()],
    };
};
const generateMockOrderHeader = () => {
    return {
        decomposeFlag: false,
        origSplitOrderId: '',
        orderId: '2525-w72',
        divisionNumber: 1,
        customerNumber: 123456789,
        departmentNumber: 2,
        tandemOrderNumber: 24353,
        orderGuideNumber: 10345,
        purchaseOrderNumber: 'Test PO',
        requestedDeliveryDate: '2020-10-10T01:02:03Z',
        confirmedDeliveryDate: '2020-10-10T01:02:03Z',
        orderType: 'RT',
        orderStatus: OrderStatus.SUBMITTED,
        purchasedFromVendor: 23451,
        origOrderId: '23451',
        version: '23451',
        orderDate: '2020-10-10T01:02:03Z',
        contactName: 'Test Contact Name',
        specialDeliveryInstructions: 'Test Special Instruction',
        totalAllowances: 5,
        totalCharges: 1045,
        totalTaxExempt: 5,
        totalSalesTax: 103,
        totalDollars: 1034,
        deliveryMode: '1',
        deleteFlag: false,
        orderTakerId: '123',
        addOrderSource: '',
        updateOrderSource: '',
        addUserRole: '',
        updateUserRole: '',
        trackingAvailable: false,
        totalUnits: 0,
        totalEaches: 0,
        orderModifiable: false,
        orderExceptions: [],
        orderTracking: [],
        updateDtm: '',
        addDtm: '',
        addUserId: '',
        updateUserId: '',
        watermarkDtm: '',
        errorDetails: null,
        totalPrice: 2177,
    };
};
const generateMockOrderItem = () => {
    return {
        addDtm: '',
        addUserId: '',
        updateDtm: '',
        updateUserId: '',
        sequence: 1,
        productNumber: 1,
        unitsOrdered: {
            currentValue: 1,
            previousValue: 1,
            loading: false,
            error: null,
        },
        eachesOrdered: {
            currentValue: 1,
            previousValue: 1,
            loading: false,
            error: null,
        },
        unitPriceOverride: 1,
        quantityAccepted: false,
        deleteFlag: false,
        unitsReserved: 1,
        eachesReserved: 1,
        unitPrice: 1,
        eachPrice: 1,
        totalDollars: 1,
        substituteFor: 1,
        addOrderSource: '',
        updateOrderSource: '',
        addUserRole: '',
        updateUserRole: '',
        substituteFlag: '',
        priceUOM: '',
        productExceptionCount: 0,
        purchasedFromVendor: 0,
        vendorLeadTime: 0,
        specialVendor: false,
    };
};
const generateMockOrderItemState = () => {
    return {
        ids: [100],
        entities: {
            100: {
                productNumber: 100,
                unitsOrdered: {
                    previousValue: 1,
                    currentValue: 1,
                    loading: false,
                    error: null,
                },
                eachesOrdered: {
                    previousValue: 1,
                    currentValue: 1,
                    loading: false,
                    error: null,
                },
            },
        },
        loading: false,
        error: null,
    };
};
const generateMockOrderHeaderState = () => {
    const orderHeader = generateMockOrderHeader();
    return {
        ids: [orderHeader.orderId],
        entities: {
            [orderHeader.orderId]: orderHeader,
        },
        loading: false,
        error: null,
    };
};
const generateMockOrderTransaction = () => {
    const order = generateMockOrder();
    const orderItems = order.orderItems.map((item) => ({
        ...item,
        unitsOrdered: item.unitsOrdered.currentValue,
        eachesOrdered: item.eachesOrdered.currentValue,
        deleteFlag: item.deleteFlag,
    }));
    const orderTransaction = {
        ...order.orderHeader,
        orderItems,
        orderExceptions: [],
        orderTracking: [],
    };
    return orderTransaction;
};
const generateMockCartState = () => {
    const order = generateMockOrder();
    const cartState = {
        orderHeader: {
            ...order.orderHeader,
            orderStatus: OrderStatus.IN_PROGRESS,
        },
        orderItems: order.orderItems,
        loading: false,
        error: null,
        watermark: new Date().toISOString(),
        dirty: null,
        saving: null,
        failCount: 0,
        tallies: {
            totalItems: 0,
            totalCases: 0,
            totalEaches: 0,
            totalShipments: 0,
        },
    };
    return cartState;
};
const cartMocks = {
    generateMockOrder,
    generateMockOrderHeader,
    generateMockOrderItem,
    generateMockOrderItemState,
    generateMockOrderHeaderState,
    generateMockOrderTransaction,
    generateMockCartState,
};

const apiUpdatableMock = (overrides) => {
    const defaultApiUpdatable = {
        currentValue: null,
        previousValue: null,
        loading: false,
        error: undefined,
    };
    return { ...defaultApiUpdatable, ...overrides };
};

const asyncApiResponseMock = (overrides) => {
    const defaultAsyncApiResponse = {
        eventId: '',
        correlationId: '',
        version: '',
        namespace: '',
        eventType: '',
        data: {
            messageScope: '',
            messageId: '',
            domainScope: '',
        },
    };
    return { ...defaultAsyncApiResponse, ...overrides };
};

const deliveryDetailsMock = (overrides) => {
    const defaultDeliveryDetails = {
        actualDeliveryDate: new Date(),
        currentStop: 'Stop 1',
        customerLatitude: 0.0,
        customerLongitude: 0.0,
        customerName: 'Default Name',
        customerNumber: 1234,
        divCode: 'Default Code',
        driverId: 5678,
        estimatedDeliveryDate: new Date(),
        isDelivered: false,
        lastStop: 10,
        lastUpdatedDate: new Date(),
        orderNumber: 'Order 1',
        planStop: 5,
        routeNumber: 123,
        totalStops: 20,
        truckLatitude: 0.0,
        truckLongitude: 0.0,
        xDisTripID: 1,
        xataTripId: 1,
        delDate: new Date(),
        udTripID: 1,
    };
    return { ...defaultDeliveryDetails, ...overrides };
};

const directShippingSavingsMock = (overrides) => {
    const defaultDirectShippingSavings = {
        orderId: '2525-w72',
        lastUpdated: new Date().toISOString(),
        directShippingSavings: {},
    };
    return { ...defaultDirectShippingSavings, ...overrides };
};

const directShippingStateMock = (overrides) => {
    const defaultDirectShippingState = {
        ids: [],
        entities: {},
        loading: false,
        error: null,
    };
    return { ...defaultDirectShippingState, ...overrides };
};

const productAndRankMock = (overrides) => {
    const defaultProductAndRank = {
        productNumber: 123,
        rank: 1,
    };
    return { ...defaultProductAndRank, ...overrides };
};
/**
 * Create a factory function that returns a mock of the DyfProduct class.
 * const mockDyfProduct = dyfProductMock({
 *    productsForDay: {
 *       '2023-07-27': [productAndRankMock(), productAndRankMock({ rank: 2 })],
 *    },
 * });
 */
const dyfProductMock = (overrides) => {
    const defaultDyfProduct = {
        customerNumber: 12345,
        departmentNumber: 123,
        divisionNumber: 123,
        productsForDay: {},
        loading: false,
        error: null,
    };
    return { ...defaultDyfProduct, ...overrides };
};

const orderItemMock = (overrides) => {
    const defaultOrderItem = {
        addDtm: '',
        addUserId: '',
        updateDtm: '',
        updateUserId: '',
        sequence: 1,
        productNumber: 1,
        unitsOrdered: apiUpdatableMock({ currentValue: 1, previousValue: 1 }),
        eachesOrdered: apiUpdatableMock({ currentValue: 1, previousValue: 1 }),
        unitPriceOverride: 1,
        quantityAccepted: false,
        deleteFlag: false,
        unitsReserved: 1,
        eachesReserved: 1,
        unitPrice: 1,
        eachPrice: 1,
        totalDollars: 1,
        substituteFor: 1,
        addOrderSource: '',
        updateOrderSource: '',
        addUserRole: '',
        updateUserRole: '',
        substituteFlag: '',
        priceUOM: '',
        productExceptionCount: 0,
        purchasedFromVendor: 0,
        vendorLeadTime: 0,
        specialVendor: false,
    };
    return { ...defaultOrderItem, ...overrides };
};
const orderItemTransactionMock = (overrides) => {
    const defaultOrderItem = {
        addDtm: '',
        addUserId: '',
        updateDtm: '',
        updateUserId: '',
        sequence: 1,
        productNumber: 1,
        unitsOrdered: 1,
        eachesOrdered: 1,
        unitPriceOverride: 1,
        quantityAccepted: false,
        deleteFlag: false,
        unitsReserved: 1,
        eachesReserved: 1,
        unitPrice: 1,
        eachPrice: 1,
        totalDollars: 1,
        substituteFor: 1,
        addOrderSource: '',
        updateOrderSource: '',
        addUserRole: '',
        updateUserRole: '',
        substituteFlag: '',
        priceUOM: '',
        productExceptionCount: 0,
        purchasedFromVendor: 0,
        vendorLeadTime: 0,
        specialVendor: false,
    };
    return { ...defaultOrderItem, ...overrides };
};

const orderExceptionMock = (overrides) => {
    const defaultOrderException = {
        errorMessage: 'default error message',
        errorCode: 0,
        errorType: 'default error type',
        actionMessage: 'default action message',
        actionCode: 'default action code',
        productNumber: 12345,
        inStockDate: new Date().toISOString(),
        subOrReplaceItems: [orderItemMock()],
        exceptionDetails: ['default exception detail'],
    };
    return { ...defaultOrderException, ...overrides };
};

const resolvedOrderItemMock = (overrides) => {
    const defaultResolvedOrderItem = {
        originalProduct: orderItemMock(),
        substituteProduct: orderItemMock(),
    };
    return { ...defaultResolvedOrderItem, ...overrides };
};
const exceptionResolutionMock = (overrides) => {
    const defaultExceptionResolution = {
        orderException: orderExceptionMock(),
        orderItem: orderItemMock(),
        resolutionOrderItem: resolvedOrderItemMock(),
        resolutionDate: new Date().toISOString(),
        dateCompleted: false,
        flippedProductNumber: 12345,
        expanded: false,
        resolutionType: 'default resolution type',
        partialReserveFlag: 'default flag',
        updateTimeStamp: new Date().toISOString(),
    };
    return { ...defaultExceptionResolution, ...overrides };
};

const importOrderCheckMock = (overrides) => {
    const defaultImportOrderCheck = {
        importOrderIdentifier: '123',
        orderCount: 1,
        ordersLoaded: false,
    };
    return { ...defaultImportOrderCheck, ...overrides };
};

const orderTransactionMock = (overrides) => {
    const defaultOrderTransaction = {
        updateUserId: '123',
        updateDtm: new Date().toISOString(),
        addUserId: '123',
        addDtm: new Date().toISOString(),
        orderId: 'orderId123',
        tandemOrderNumber: 123,
        divisionNumber: 1,
        customerNumber: 1,
        departmentNumber: 1,
        orderGuideNumber: 1,
        purchaseOrderNumber: 'PO123',
        requestedDeliveryDate: new Date().toISOString(),
        confirmedDeliveryDate: new Date().toISOString(),
        orderType: 'type',
        orderStatus: 'status',
        purchasedFromVendor: 1,
        addOrderSource: 'source',
        updateOrderSource: 'source',
        addUserRole: 'role',
        updateUserRole: 'role',
        origOrderId: 'originalId',
        origSplitOrderId: 'originalSplitId',
        version: '1.0',
        orderDate: new Date().toISOString(),
        orderTakerId: 'takerId',
        contactName: 'contact',
        specialDeliveryInstructions: 'instructions',
        totalAllowances: 1,
        totalCharges: 1,
        totalTaxExempt: 1,
        totalSalesTax: 1,
        totalDollars: 1,
        deliveryMode: 'mode',
        deleteFlag: false,
        trackingAvailable: false,
        totalUnits: 1,
        totalEaches: 1,
        decomposeFlag: false,
        orderModifiable: false,
        orderItems: [],
        orderExceptions: [],
        orderTracking: [],
        watermarkDtm: new Date().toISOString(),
        importOrderIdentifier: '123',
    };
    return { ...defaultOrderTransaction, ...overrides };
};

const importOrderTransactionMock = (overrides) => {
    const defaultImportOrderTransaction = {
        ...orderTransactionMock(),
        clientId: '123',
    };
    return { ...defaultImportOrderTransaction, ...overrides };
};

const importOrdersPayloadMock = (overrides) => {
    const defaultImportOrdersPayload = {
        orderTransactions: [],
        fileImportError: false,
        fileImportErrors: [],
        message: '',
    };
    return { ...defaultImportOrdersPayload, ...overrides };
};

const importOrdersStateMock = (overrides) => {
    const defaultImportOrdersState = {
        ids: [],
        entities: {},
        loading: false,
        loaded: false,
        error: null,
        importOrderCheck: null,
        fileImportError: false,
        fileImportErrors: [],
        fileName: '',
        fileFormat: '',
        message: '',
    };
    return { ...defaultImportOrdersState, ...overrides };
};

const initialCartStateMock = (overrides) => {
    const defaultCartState = {
        orderHeader: {},
        orderItems: [],
        loading: false,
        error: null,
        dirty: null,
        saving: null,
        watermark: null,
        failCount: 0,
        tallies: null,
    };
    return { ...defaultCartState, ...overrides };
};

const initialEditCartStateMock = (overrides) => {
    const defaultCartState = {
        orderHeader: {},
        orderItems: [],
        loading: false,
        error: null,
        dirty: null,
        saving: null,
        watermark: null,
        failCount: 0,
        tallies: null,
    };
    return { ...defaultCartState, ...overrides };
};

const inspiredPicksMock = (overrides) => {
    const defaultInspiredPicks = {
        loading: false,
        error: undefined,
        displayText: {
            headerTextDesktop: 'Default Desktop Header Text',
            subHeaderTextDesktop: 'Default Desktop Sub Header Text',
            headerTextMobile: 'Default Mobile Header Text',
            subHeaderTextMobile: 'Default Mobile Sub Header Text',
        },
        productNumberList: [12345, 67890],
    };
    return { ...defaultInspiredPicks, ...overrides };
};

const orderHeaderMock = (overrides) => {
    const defaultOrderHeader = {
        decomposeFlag: false,
        origSplitOrderId: '',
        orderId: '2525-w72',
        divisionNumber: 1,
        customerNumber: 123456789,
        departmentNumber: 2,
        tandemOrderNumber: 24353,
        orderGuideNumber: 10345,
        purchaseOrderNumber: 'Test PO',
        requestedDeliveryDate: '2020-10-10T01:02:03Z',
        confirmedDeliveryDate: '2020-10-10T01:02:03Z',
        orderType: 'RT',
        orderStatus: OrderStatus.SUBMITTED,
        purchasedFromVendor: 23451,
        origOrderId: '23451',
        version: '23451',
        orderDate: '2020-10-10T01:02:03Z',
        contactName: 'Test Contact Name',
        specialDeliveryInstructions: 'Test Special Instruction',
        totalAllowances: 5,
        totalCharges: 1045,
        totalTaxExempt: 5,
        totalSalesTax: 103,
        totalDollars: 1034,
        deliveryMode: '1',
        deleteFlag: false,
        orderTakerId: '123',
        addOrderSource: '',
        updateOrderSource: '',
        addUserRole: '',
        updateUserRole: '',
        trackingAvailable: false,
        totalUnits: 0,
        totalEaches: 0,
        orderModifiable: false,
        orderExceptions: [],
        orderTracking: [],
        updateDtm: '',
        addDtm: '',
        addUserId: '',
        updateUserId: '',
        watermarkDtm: '',
        errorDetails: null,
        totalPrice: 2177,
    };
    return { ...defaultOrderHeader, ...overrides };
};

const myOrdersViewModelMock = (overrides) => {
    const defaultMyOrdersViewModel = {
        orderHeader: orderHeaderMock(),
        displayType: 'Default Display Type',
        displayTitle: 'Default Display Title',
        itemInCart: false,
        iconUrl: '',
    };
    return { ...defaultMyOrdersViewModel, ...overrides };
};

const nextDeliveryDateMock = (overrides) => {
    const defaultNextDeliveryDate = {
        creditIndicator: false,
        deliveryDate: new Date().toISOString(),
        errNumber: null,
        loading: false,
        error: null,
    };
    return { ...defaultNextDeliveryDate, ...overrides };
};

const orderMock = (overrides) => {
    const order = {
        orderHeader: orderHeaderMock(),
        orderItems: [orderItemMock()],
    };
    return { ...order, ...overrides };
};

const orderExceptionStateMock = (overrides) => {
    const defaultOrderExceptionState = {
        ids: [],
        entities: {},
        order: orderMock(),
        expandedSection: null,
        isConfirmationFlow: false,
    };
    return { ...defaultOrderExceptionState, ...overrides };
};

const orderHeaderStateMock = (overrides) => {
    const defaultOrderHeaderState = {
        ids: [],
        entities: {},
        loading: false,
        error: null,
    };
    return { ...defaultOrderHeaderState, ...overrides };
};

const orderItemStateMock = (overrides) => {
    const defaultOrderItemState = {
        ids: [],
        entities: {},
        tallies: undefined,
        loading: false,
        error: null,
    };
    return { ...defaultOrderItemState, ...overrides };
};

const orderStateMock = (overrides) => {
    const defaultOrderState = {
        ids: [],
        entities: {},
        ready: false,
        error: null,
        watermark: '',
        customerWatermarks: { 1: 'string' },
        willCallInFlight: false,
        orderStatusInFlight: false,
        inProgressOrdersLoading: false,
        recentOrdersLoading: false,
        importedOrdersLoading: false,
        customerOrdersLoading: false,
    };
    return { ...defaultOrderState, ...overrides };
};

const partnerMock = (overrides) => {
    const defaultPartner = {
        partnerId: '8122301027',
        partnerName: 'ACQUALINA RESORT SPA/BUY EFFICIENT CXML PUNCHOUT',
        punchoutProfile: {
            ebItemsOnly: true,
            permissions: true,
            autoTransfer: true,
            casesEaches: 'CA',
            catchWeight: true,
            orderCountFlag: true,
            punchout: true,
            retransferLinkFlag: true,
            returnLinkFlag: true,
            returnLink: '',
            submitButton: 'Transfer to iBuyEfficient',
            transferButton: 'Transfer to iBuyEfficient',
            updateButton: 'Update',
            returnLinkUrl: '',
            customCxmlLoginMapping: {
                buyerCookie: '/cXML/Request/PunchOutSetupRequest/BuyerCookie/text()',
                partnerName: '/cXML/Header/From/Credential/Identity/text()',
                password: '/cXML/Header/Sender/Credential/SharedSecret/text()',
                postUrl: '/cXML/Request/PunchOutSetupRequest/BrowserFormPost/URL/text()',
                userName: '/cXML/Header/Sender/Credential/Identity/text()',
            },
            customCxmlOrderRequestMapping: {
                poNumber: '/cXML/Request/OrderRequest/OrderRequestHeader/@orderID',
                partnerName: '/cXML/Header/From/Credential/Identity/text()',
                password: '/cXML/Header/Sender/Credential/SharedSecret/text()',
                supplierPartAuxillaryId: '/cXML/Request/OrderRequest/ItemOut/ItemDetail/Extrinsic[@ name= "LINEATTRIBUTE1"]',
                userName: '/cXML/Header/Sender/Credential/Identity/text()',
            },
        },
        siteRoleProfile: {
            exceptionRestricted: false,
            siteRestricted: false,
        },
    };
    return { ...defaultPartner, ...overrides };
};

const talliesMock = (overrides) => {
    const defaultTallies = {
        totalItems: 0,
        totalCases: 0,
        totalEaches: 0,
        totalShipments: 0,
        totalPrice: 0,
        orderWeight: 0,
        totalDirectShipmentSavings: 0,
    };
    return { ...defaultTallies, ...overrides };
};

const webSocketEventMock = (overrides) => {
    const defaultWebSocketEvent = {
        eventId: '',
        correlationId: '',
        version: '',
        namespace: '',
        eventType: '',
        data: {
            messageScope: '',
            messageIds: [],
            namespace: '',
            eventType: '',
            eventAction: '',
            domainScope: '',
            domainIds: [],
            watermark: '',
            messageContent: [],
            contexts: [
                {
                    divisionNumber: '',
                    customerNumber: '',
                    departmentNumber: '',
                },
            ],
        },
    };
    return { ...defaultWebSocketEvent, ...overrides };
};

const deliveryDetailsStateMock = (overrides) => {
    const defaultDeliveryDetailsState = {
        ids: [],
        entities: {},
        loading: false,
        loaded: false,
        error: null,
    };
    return { ...defaultDeliveryDetailsState, ...overrides };
};

const cancelOrderAsyncMock = (overrides) => {
    const defaultMockCancelOrderAsync = {
        orderTransactions: [orderTransactionMock()],
        watermark: '999999999',
        contexts: [
            {
                divisionNumber: '4117',
                customerNumber: '13761622',
                departmentNumber: '0',
            },
        ],
        version: '1.0.2',
    };
    return { ...defaultMockCancelOrderAsync, ...overrides };
};

const submitIpOrderAsyncMock = (overrides) => {
    const defaultMockCancelOrderAsync = {
        orderTransactions: [orderTransactionMock()],
        watermark: '999999999',
        contexts: [
            {
                divisionNumber: '4117',
                customerNumber: '13761622',
                departmentNumber: '0',
            },
        ],
        version: '1.0.2',
    };
    return { ...defaultMockCancelOrderAsync, ...overrides };
};

const importedOrdersFiltersStateMock = (overrides) => {
    const defaultImportOrdersState = {
        filters: {
            importedDate: '',
            orderStatus: {
                [OrderStatus.IN_PROGRESS]: false,
                [OrderStatus.SUBMITTING]: false,
                [OrderStatus.SUBMITTED]: false,
                [OrderStatus.SUBMITTED_CREDIT_HOLD]: false,
                [OrderStatus.SUBMITTED_WITH_EXCEPTIONS]: false,
                [OrderStatus.EDITING_SUBMITTED]: false,
                [OrderStatus.ORDER_ERROR]: false,
                [OrderStatus.SHIPPED]: false,
                [OrderStatus.SHIPPED_WITH_EXCEPTIONS]: false,
                [OrderStatus.PICKING]: false,
                [OrderStatus.INVOICE]: false,
                [OrderStatus.DELIVERED]: false,
                [OrderStatus.DELETED]: false,
                [OrderStatus.CANCELLED]: false,
                [OrderStatus.CANCELLING]: false,
                [OrderStatus.TANDEM_DELETED]: false,
                [OrderStatus.SUBMITTED_NEW]: false,
                [OrderStatus.NO_ORDER]: false,
                [OrderStatus.SUBMISSION_ERROR]: false,
                [OrderStatus.QUANTITIES_UPDATED]: false,
                [OrderStatus.OUT_FOR_DELIVERY]: false,
                [OrderStatus.DELIVERY_DELAYED]: false,
                [OrderStatus.ATTEMPTED_DELIVERY]: false,
                [OrderStatus.ORDER_CANCELLED]: false,
                [OrderStatus.DELIVERY_ISSUE]: false,
            },
            showAllOrdersForDate: false,
        },
        filtersSelected: 0,
    };
    return { ...defaultImportOrdersState, ...overrides };
};

const orderReviewPreferencesMock = (overrides) => {
    const defaultOrderReviewPreferences = {
        divisionNumber: 1,
        customerNumber: 1,
        departmentNumber: 1,
        reviewedUserId: 'JOESCHMO',
        reviewedDtm: new Date().toISOString(),
        tandemOrderNumber: 12345678,
        purchaseOrderNumber: 'PO123',
        confirmedDeliveryDate: '2023-08-16T00:00-05:00',
        requestedDeliveryDate: '2023-08-16T00:00-05:00',
        orderStatus: 'SUBMITTED',
        totalDollars: 123.45,
        totalPrice: 130.0,
        totalUnitsOrdered: 1,
        totalUnitsReserved: 1,
        totalEachesOrdered: 1,
        totalEachesReserved: 1,
    };
    return { ...defaultOrderReviewPreferences, ...overrides };
};

const orderReviewStateMock = (overrides) => {
    const defaultOrderReviewPreferences = {
        loading: false,
        error: null,
        ids: [],
        entities: {},
    };
    return { ...defaultOrderReviewPreferences, ...overrides };
};

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    apiUpdatableMock: apiUpdatableMock,
    asyncApiResponseMock: asyncApiResponseMock,
    cancelOrderAsyncMock: cancelOrderAsyncMock,
    deliveryDetailsMock: deliveryDetailsMock,
    deliveryDetailsStateMock: deliveryDetailsStateMock,
    directShippingSavingsMock: directShippingSavingsMock,
    directShippingStateMock: directShippingStateMock,
    dyfProductMock: dyfProductMock,
    exceptionResolutionMock: exceptionResolutionMock,
    importOrderCheckMock: importOrderCheckMock,
    importOrderTransactionMock: importOrderTransactionMock,
    importOrdersPayloadMock: importOrdersPayloadMock,
    importOrdersStateMock: importOrdersStateMock,
    importedOrdersFiltersStateMock: importedOrdersFiltersStateMock,
    initialCartStateMock: initialCartStateMock,
    initialEditCartStateMock: initialEditCartStateMock,
    inspiredPicksMock: inspiredPicksMock,
    myOrdersViewModelMock: myOrdersViewModelMock,
    nextDeliveryDateMock: nextDeliveryDateMock,
    orderExceptionMock: orderExceptionMock,
    orderExceptionStateMock: orderExceptionStateMock,
    orderHeaderMock: orderHeaderMock,
    orderHeaderStateMock: orderHeaderStateMock,
    orderItemMock: orderItemMock,
    orderItemStateMock: orderItemStateMock,
    orderItemTransactionMock: orderItemTransactionMock,
    orderMock: orderMock,
    orderReviewPreferencesMock: orderReviewPreferencesMock,
    orderReviewStateMock: orderReviewStateMock,
    orderStateMock: orderStateMock,
    orderTransactionMock: orderTransactionMock,
    partnerMock: partnerMock,
    productAndRankMock: productAndRankMock,
    resolvedOrderItemMock: resolvedOrderItemMock,
    submitIpOrderAsyncMock: submitIpOrderAsyncMock,
    talliesMock: talliesMock,
    webSocketEventMock: webSocketEventMock
});

class MyOrdersEffects {
    constructor(actions$, orderDataService, orderStateService, orderStoreService, panAppState, store, orderDtoService, orderItemDtoService) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.orderStateService = orderStateService;
        this.orderStoreService = orderStoreService;
        this.panAppState = panAppState;
        this.store = store;
        this.orderDtoService = orderDtoService;
        this.orderItemDtoService = orderItemDtoService;
        this.inProgressOrders$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getInProgressOrdersContext), switchMap(() => this.orderDataService.getInProgressOrders().pipe(concatMap((orders) => [
            MY_ORDERS_ACTIONS.getInProgressOrdersContextSuccess({ orders }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(MY_ORDERS_ACTIONS.getInProgressOrdersContextFail({ error }));
        })))));
        this.inProgressOrdersSuccess$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getInProgressOrdersContextSuccess), withLatestFrom(this.store.select(orderSelectors.selectOrdersWithStatus(OrderStatus.IN_PROGRESS)), this.panAppState.customer$, this.store.select(orderHeaderSelectors.selectOrderHeader)), switchMap(([payload, orders, customer, currentOrder]) => {
            const deletedOrders = orders
                .filter((order) => customer.customerNumber === order.orderHeader.customerNumber &&
                !payload.orders.some((o) => o.orderHeader.orderId === order.orderHeader.orderId))
                .map((order) => ({
                ...order,
                orderHeader: {
                    ...order.orderHeader,
                    orderStatus: OrderStatus.DELETED,
                },
            }));
            const actions = [];
            if (payload.orders.some((o) => currentOrder?.orderId === o.orderHeader.orderId)) {
                const order = payload.orders.find((o) => currentOrder?.orderId === o.orderHeader.orderId);
                this.orderStoreService.loadOrderIntoContext({
                    orderHeader: order.orderHeader,
                    orderItems: order.orderItems,
                });
            }
            else if (deletedOrders.some((order) => currentOrder?.orderId === order.orderHeader.orderId)) {
                actions.push(MY_ORDERS_ACTIONS.clearCart());
            }
            if (deletedOrders.length > 0) {
                actions.push(MY_ORDERS_ACTIONS.upsertMany({
                    orders: deletedOrders,
                }));
                actions.push(MY_ORDERS_ACTIONS.writeToUserOfflineStorage());
            }
            if (actions.length > 0) {
                return actions;
            }
            else {
                return EMPTY;
            }
        })));
        this.myOrders$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getMyOrdersContext), withLatestFrom(this.store.select(orderSelectors.selectWatermark())), switchMap(([_, watermark]) => this.orderDataService.getMyOrders(watermark).pipe(switchMap((orders) => [
            MY_ORDERS_ACTIONS.getMyOrdersContextSuccess({ orders }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(MY_ORDERS_ACTIONS.getMyOrdersContextFail({ error }));
        })))));
        this.getRecentOrders$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getRecentOrders), exhaustMap(() => this.orderDataService.getRecentOrders().pipe(switchMap((orders) => [
            MY_ORDERS_ACTIONS.getRecentOrdersSuccess({ orders }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(MY_ORDERS_ACTIONS.getRecentOrdersFail({ error }));
        })))));
        this.getCustomerOrders$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getCustomerOrders), withLatestFrom(this.store.select(orderSelectors.selectCustomerWatermarks()), this.panAppState.customer$), switchMap(([_, customerWatermarks, customer]) => this.orderDataService
            .getCustomerOrders(customerWatermarks, customer?.customerNumber)
            .pipe(switchMap((orders) => [
            MY_ORDERS_ACTIONS.getCustomerOrdersSuccess({ orders }),
        ]), catchError((error) => of(MY_ORDERS_ACTIONS.getCustomerOrdersFail({ error })))))));
        this.getCustomerOrdersSuccess$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getCustomerOrdersSuccess), switchMap(() => [MY_ORDERS_ACTIONS.writeToUserOfflineStorage()])));
        this.getMyOrdersContextSuccess$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getMyOrdersContextSuccess), switchMap(() => [MY_ORDERS_ACTIONS.writeToUserOfflineStorage()])));
        this.cancelOrderAsync$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.cancelOrderAsync), map((payload) => {
            const actionsToDispatch = [];
            for (const orderTransaction of payload.orderTransactions) {
                const order = {
                    orderHeader: this.orderDtoService.toClientModel(orderTransaction),
                    orderItems: this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems),
                };
                actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({ order }));
            }
            actionsToDispatch.push(MY_ORDERS_ACTIONS.writeToUserOfflineStorage());
            return actionsToDispatch;
        }), switchMap((actions) => actions)));
        this.submitIpOrderAsync$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.submitIpOrderAsync), withLatestFrom(this.store.select(orderHeaderSelectors.selectOrderHeader)), map(([payload, inContextOrder]) => {
            const actionsToDispatch = [];
            for (const orderTransaction of payload.orderTransactions) {
                const order = {
                    orderHeader: this.orderDtoService.toClientModel(orderTransaction),
                    orderItems: this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems),
                };
                actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({ order }));
                if (order?.orderHeader?.orderId === inContextOrder?.orderId) {
                    actionsToDispatch.push(MY_ORDERS_ACTIONS.clearCart());
                }
            }
            actionsToDispatch.push(MY_ORDERS_ACTIONS.writeToUserOfflineStorage());
            return actionsToDispatch;
        }), switchMap((actions) => actions)));
        this.updateSubmittedOrderAsync$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.updateSubmittedOrderAsync), 
        // Get the current orders from the store to compare timestamps before updating
        withLatestFrom(this.store.select(orderSelectors.selectEntities)), map(([payload, currentOrders]) => {
            const actionsToDispatch = [];
            for (const orderTransaction of payload.orderTransactions) {
                const order = {
                    orderHeader: this.orderDtoService.toClientModel(orderTransaction),
                    orderItems: this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems),
                };
                // Create a unique ID to find this order in the store
                const orderStoreId = `${order.orderHeader.customerNumber}:${order.orderHeader.departmentNumber}:${order.orderHeader.orderId}`;
                // Get the current version of this order from the store (if it exists)
                const currentOrder = (currentOrders || {})[orderStoreId];
                // Only add orders that are new or have a newer timestamp than what's in the store
                // This prevents out-of-order WebSocket events from overwriting newer data with stale data
                if (!currentOrder ||
                    new Date(order.orderHeader.watermarkDtm) >
                        new Date(currentOrder.orderHeader.watermarkDtm)) {
                    actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({ order }));
                }
            }
            return actionsToDispatch;
        }), switchMap((actions) => actions)));
        this.convertToWillCall$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.convertToWillCall), switchMap((resp) => this.orderDataService
            .convertToWillCall(resp)
            .pipe(map((wcOrder) => MY_ORDERS_ACTIONS.convertToWillCallSuccess(wcOrder)))), catchError((error) => of(MY_ORDERS_ACTIONS.convertToWillCallFail(error)))));
        this.convertToWillCallAsync$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.convertToWillCallAsync), map((payload) => {
            const actionsToDispatch = [];
            for (const orderTransaction of payload.orderTransactions) {
                const order = {
                    orderHeader: this.orderDtoService.toClientModel(orderTransaction),
                    orderItems: this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems),
                };
                if (order.orderHeader.errorDetails) {
                    const error = {
                        status: order.orderHeader.errorDetails.errNumber,
                        message: order.orderHeader.errorDetails.errMessage,
                    };
                    actionsToDispatch.push(MY_ORDERS_ACTIONS.convertToWillCallAsyncFail({ error }));
                }
                actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({ order }));
            }
            return actionsToDispatch;
        }), switchMap((actions) => actions)));
        this.updateShipToDetailsAsync$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.updateShipToDetailsAsync), map((payload) => {
            const actionsToDispatch = [];
            for (const orderTransaction of payload.orderTransactions) {
                const order = {
                    orderHeader: this.orderDtoService.toClientModel(orderTransaction),
                    orderItems: this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems),
                };
                if (order.orderHeader.errorDetails) {
                    const error = {
                        status: order.orderHeader.errorDetails.errNumber,
                        message: order.orderHeader.errorDetails.errMessage,
                    };
                    actionsToDispatch.push(MY_ORDERS_ACTIONS.updateShipToDetailsAsyncFail({ error }));
                }
                actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({ order }));
            }
            return actionsToDispatch;
        }), switchMap((actions) => actions)));
        this.getOrderDetails$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.getOrderDetails), switchMap((action) => {
            const isEditFlow = action?.isEditFlow;
            return this.orderDataService
                .getOrderDetails(action.tandemOrderNumber)
                .pipe(map((order) => {
                if (order.orderHeader?.errorDetails) {
                    return MY_ORDERS_ACTIONS.getOrderDetailsFailure(null);
                }
                return MY_ORDERS_ACTIONS.getOrderDetailsSuccess({
                    order,
                    isEditFlow,
                });
            }), catchError((error) => of(MY_ORDERS_ACTIONS.getOrderDetailsFailure(error))));
        })));
        // IndexedDB
        this.writeMyOrdersToOfflineStorage$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.writeToUserOfflineStorage), withLatestFrom(this.panAppState.user$, this.store.select(orderSelectors.selectOrderContextState)), distinctUntilChanged(), concatMap(([_, user, orders]) => this.orderStateService.writeToUserOfflineStorage(user, ORDERS_KEY, orders))), { dispatch: false });
        this.initializeUserStorage$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.initializeUserStorage), concatMap((param) => this.orderStateService
            .initializeUserStorage(param.user)
            .pipe(map(() => MY_ORDERS_ACTIONS.loadFromUserOfflineStorage(param))))));
        this.loadFromUserStorage$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.loadFromUserOfflineStorage), tap(() => console.log('[Ordering] loadFromUserStorage started')), concatMap((param) => this.orderStateService
            .getFromUserOfflineStorage(param.user, ORDERS_KEY)
            .pipe(map((orders) => MY_ORDERS_ACTIONS.loadFromUserOfflineStorageSuccess({
            orders,
        })), catchError((error) => of(MY_ORDERS_ACTIONS.loadFromUserOfflineStorageFail({ error })))))));
        this.loadFromUserOfflineStorageSuccess$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.loadFromUserOfflineStorageSuccess, MY_ORDERS_ACTIONS.loadFromUserOfflineStorageFail)),
        ]).pipe(tap(([action]) => console.log(`[Ordering] loadFromUserOfflineStorage complete with: ${action.type}`)), switchMap(([_]) => {
            const result = [];
            result.push(MY_ORDERS_ACTIONS.getRecentOrders());
            return result;
        })));
        this.clearCart$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.clearCart), tap(() => sessionStorage.removeItem('orderInCart'))));
        this.checkOrderStatus$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.checkOrderStatus), switchMap((action) => this.orderDataService.getOrderById(action.orderId).pipe(map((order) => MY_ORDERS_ACTIONS.checkOrderStatusSuccess({
            order,
        })), catchError((error) => of(MY_ORDERS_ACTIONS.checkOrderStatusFailure(error)))))));
        this.checkOrderStatusSuccess$ = createEffect(() => this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.checkOrderStatusSuccess), withLatestFrom(this.store.select(orderHeaderSelectors.selectOrderHeader)), switchMap(([action, orderHeader]) => {
            if ((action.order.orderHeader.orderStatus === OrderStatus.CANCELLED ||
                action.order.orderHeader.orderStatus === OrderStatus.DELETED) &&
                orderHeader.orderId === action.order.orderHeader.orderId) {
                this.orderStoreService.resetOrder();
                return [
                    CART_ACTIONS.removeBadOrderFromCart(),
                    MY_ORDERS_ACTIONS.upsertOne({ order: action.order }),
                ];
            }
            return EMPTY;
        })));
    }
}
MyOrdersEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }, { token: OrderStateService }, { token: OrderStoreService }, { token: i2.PanAppState }, { token: i1.Store }, { token: OrderDtoService }, { token: OrderItemDTOService }], target: i0.ɵɵFactoryTarget.Injectable });
MyOrdersEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MyOrdersEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }, { type: OrderStateService }, { type: OrderStoreService }, { type: i2.PanAppState }, { type: i1.Store }, { type: OrderDtoService }, { type: OrderItemDTOService }]; } });

class NextDeliveryEffects {
    constructor(actions$, orderDataService, store, panAppState) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.store = store;
        this.panAppState = panAppState;
        this.nextDeliveryDate$ = createEffect(() => this.actions$.pipe(ofType(NEXT_DELIVERY_ACTIONS.getDeliveryInfo), switchMap(() => this.orderDataService.getDeliveryDate().pipe(withLatestFrom(this.store.select(orderHeaderSelectors.selectOrderHeader), this.panAppState.customer$), map(([nextDelivery, orderHeader, customer]) => {
            const commands = [
                NEXT_DELIVERY_ACTIONS.getDeliveryInfoSuccess({
                    nextDelivery,
                }),
            ];
            //only update requestedDeliveryDate and confirmedDeliveryDate if nextDelivery.deliveryDate is in the future or null
            //offset for timezone
            const deliveryDate = new Date(nextDelivery.deliveryDate);
            const offset = deliveryDate.getTimezoneOffset();
            deliveryDate.setHours(deliveryDate.getHours() + offset / 60);
            const deliveryDateInPast = new Date(deliveryDate) < new Date();
            if (customer.customerNumber === orderHeader.customerNumber &&
                orderHeader.orderStatus === OrderStatus.IN_PROGRESS &&
                nextDelivery?.deliveryDate &&
                dayjs(orderHeader.requestedDeliveryDate).diff(nextDelivery.deliveryDate, 'day') < 0 &&
                !deliveryDateInPast) {
                commands.push(CART_ACTIONS.updateDeliveryDates({
                    nextDeliveryDate: nextDelivery.deliveryDate,
                }));
            }
            else if (customer.customerNumber === orderHeader.customerNumber &&
                orderHeader.orderStatus === OrderStatus.IN_PROGRESS &&
                nextDelivery.deliveryDate === null) {
                commands.push(CART_ACTIONS.updateDeliveryDates({
                    nextDeliveryDate: null,
                }));
            }
            return commands;
        }), concatMap((commandsToExecute) => commandsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(NEXT_DELIVERY_ACTIONS.getDeliveryInfoFail({ error }));
        })))));
    }
}
NextDeliveryEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NextDeliveryEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }, { token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
NextDeliveryEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NextDeliveryEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NextDeliveryEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }, { type: i1.Store }, { type: i2.PanAppState }]; } });

class DyfDataService {
    constructor() {
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
        this.httpVerbService = inject(HttpVerbService);
    }
    getDyfProducts() {
        return this.httpVerbService
            .get(`${this.config.apiUrl}/dyfproducts`)
            .pipe(filter((resp) => !!resp), map((payload) => {
            const productsForDay = {};
            ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].forEach((day) => {
                if (payload[day]) {
                    productsForDay[day] = payload[day].map((productRankObj) => {
                        const productRank = {
                            productNumber: productRankObj.productNumber,
                            rank: productRankObj.rank,
                        };
                        return productRank;
                    });
                }
            });
            const dyfProducts = {
                customerNumber: payload.customerNumber,
                departmentNumber: payload.departmentNumber,
                divisionNumber: payload.divisionNumber,
                productsForDay,
            };
            return dyfProducts;
        }), catchError((error) => throwError(error)));
    }
}
DyfDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DyfDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DyfDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DyfDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DyfDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DYFEffects {
    constructor(actions$, dyfDataService) {
        this.actions$ = actions$;
        this.dyfDataService = dyfDataService;
        this.getDYFProducts$ = createEffect(() => this.actions$.pipe(ofType(DYF_ACTIONS.getDyfProducts), switchMap((_) => this.dyfDataService.getDyfProducts().pipe(map((products) => DYF_ACTIONS.getDyfProductsSuccess({ products })), catchError((error) => of(DYF_ACTIONS.getDyfProductsError({ error })))))));
    }
}
DYFEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DYFEffects, deps: [{ token: i1$4.Actions }, { token: DyfDataService }], target: i0.ɵɵFactoryTarget.Injectable });
DYFEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DYFEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DYFEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: DyfDataService }]; } });

class OrderExceptionEffects {
    constructor(actions$, orderDataService, deliveryStoreService) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.deliveryStoreService = deliveryStoreService;
        this.resolveOrder$ = createEffect(() => this.actions$.pipe(ofType(ORDER_EXCEPTION_ACTIONS.resolveOrder), map((props) => {
            const orderHeader = { ...props.order.orderHeader, decomposeFlag: true };
            // update the order header delivery date if needed
            this.deliveryStoreService
                .getNextDeliveryInformation()
                .pipe(take(1))
                .subscribe((nextDeliveryInfo) => {
                const deliveryDate = new Date(nextDeliveryInfo.deliveryDate);
                const offset = deliveryDate.getTimezoneOffset();
                deliveryDate.setHours(deliveryDate.getHours() + offset / 60);
                const deliveryDateInPast = new Date(deliveryDate) < new Date();
                const reqDate = new Date(orderHeader.requestedDeliveryDate);
                const offsetReqDate = reqDate.getTimezoneOffset();
                reqDate.setHours(reqDate.getHours() + offsetReqDate / 60);
                const reqDeliveryDateInPast = new Date(reqDate) < new Date();
                // Determine if next delivery date needs to show new delivery date
                if (!deliveryDateInPast && reqDeliveryDateInPast) {
                    orderHeader.requestedDeliveryDate = nextDeliveryInfo.deliveryDate;
                }
            });
            return {
                ...props.order,
                orderHeader,
            };
        }), switchMap((payload) => this.orderDataService.resolveOrder(payload).pipe(concatMap((resp) => [
            ORDER_EXCEPTION_ACTIONS.resolveOrderSuccess({ order: resp }),
        ]), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(ORDER_EXCEPTION_ACTIONS.resolveOrderFail({ error }));
        })))));
        this.storeResolvedOrder$ = createEffect(() => this.actions$.pipe(ofType(ORDER_EXCEPTION_ACTIONS.resolveOrder), concatMap((payload) => [
            MY_ORDERS_ACTIONS.upsertOne({ order: payload.order }),
        ])));
        this.homePageResolveExceptions$ = createEffect(() => this.actions$.pipe(ofType(ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptions), switchMap((payload) => this.orderDataService.getOrderById(payload.orderId).pipe(map((order) => {
            if (order?.orderHeader?.orderModifiable &&
                order?.orderHeader?.orderStatus ===
                    OrderStatus.SUBMITTED_WITH_EXCEPTIONS) {
                return ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptionsSuccess({
                    order,
                });
            }
            else {
                return ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptionsFail({
                    order,
                });
            }
        }), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(ORDER_EXCEPTION_ACTIONS.homePageRouteResolveExceptionsApiFail({
                orderId: payload.orderId,
                error,
            }));
        })))));
    }
}
OrderExceptionEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }, { token: DeliveryStoreService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderExceptionEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderExceptionEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }, { type: DeliveryStoreService }]; } });

const intialDyfProductState = {
    productsForDay: null,
    customerNumber: null,
    departmentNumber: null,
    divisionNumber: null,
};
const reducer$4 = createReducer(intialDyfProductState, on(DYF_ACTIONS.getDyfProducts, (state, action) => ({
    ...state,
    loading: true,
    error: null,
    displayText: {
        headerTextDesktop: '',
        subHeaderTextDesktop: '',
        headerTextMobile: '',
        subHeaderTextMobile: '',
    },
})), on(DYF_ACTIONS.getDyfProductsSuccess, (state, action) => ({
    ...state,
    loading: false,
    error: null,
    productsForDay: action.products.productsForDay,
    customerNumber: action.products.customerNumber,
    departmentNumber: action.products.departmentNumber,
    divisionNumber: action.products.divisionNumber,
})), on(DYF_ACTIONS.getDyfProductsError, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function dyfProductsReducer(state, action) {
    return reducer$4(state, action);
}

const intialInspiredPicksState = {
    loading: true,
    error: null,
    displayText: {
        headerTextDesktop: '',
        subHeaderTextDesktop: '',
        headerTextMobile: '',
        subHeaderTextMobile: '',
    },
    productNumberList: [],
};
const reducer$3 = createReducer(intialInspiredPicksState, on(INSPIRED_PICKS_ACTIONS.getInspiredPicks, (state, action) => ({
    ...state,
    loading: true,
    error: null,
    displayText: {
        headerTextDesktop: '',
        subHeaderTextDesktop: '',
        headerTextMobile: '',
        subHeaderTextMobile: '',
    },
})), on(INSPIRED_PICKS_ACTIONS.getInspiredPicksSuccess, (state, action) => ({
    ...state,
    loading: false,
    productNumberList: action.inspiredPicks.productNumberList,
    displayText: action.inspiredPicks.displayText,
})), on(INSPIRED_PICKS_ACTIONS.getInspiredPicksFail, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function inspiredPicksReducer(state, action) {
    return reducer$3(state, action);
}

class InspiredPicksDataService {
    constructor() {
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
        this.httpVerbService = inject(HttpVerbService);
    }
    getInspiredPicks() {
        return this.httpVerbService
            .get(`${this.config.apiUrl}/inspiredpicks`)
            .pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
InspiredPicksDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
InspiredPicksDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class InspiredPicksEffects {
    constructor(actions$, inspiredPicksDataService) {
        this.actions$ = actions$;
        this.inspiredPicksDataService = inspiredPicksDataService;
        this.getInspiredPicks$ = createEffect(() => this.actions$.pipe(ofType(INSPIRED_PICKS_ACTIONS.getInspiredPicks), switchMap((_) => this.inspiredPicksDataService.getInspiredPicks().pipe(map((inspiredPicks) => INSPIRED_PICKS_ACTIONS.getInspiredPicksSuccess({ inspiredPicks })), catchError((error) => of(INSPIRED_PICKS_ACTIONS.getInspiredPicksFail({ error })))))));
    }
}
InspiredPicksEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksEffects, deps: [{ token: i1$4.Actions }, { token: InspiredPicksDataService }], target: i0.ɵɵFactoryTarget.Injectable });
InspiredPicksEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: InspiredPicksEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: InspiredPicksDataService }]; } });

class OrderPunchoutEffects {
    constructor(actions$, orderPunchoutDataService) {
        this.actions$ = actions$;
        this.orderPunchoutDataService = orderPunchoutDataService;
        this.punchoutLogout$ = createEffect(() => this.actions$.pipe(ofType(ORDER_PUNCHOUT_ACTIONS.punchoutLogout), switchMap((props) => {
            const logXMl = props.orderXml?.replace(/<!DOCTYPE[^>]*>/, '');
            return this.orderPunchoutDataService.logUserXml(logXMl).pipe(tap((resp) => console.log('RESP:', resp)), map((resp) => ORDER_PUNCHOUT_ACTIONS.punchoutLogoutSuccess({
                orderXml: props.orderXml,
            })), catchError((error) => of(ORDER_PUNCHOUT_ACTIONS.punchoutLogoutFail({
                error,
                orderXml: props.orderXml,
            }))));
        })));
    }
}
OrderPunchoutEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutEffects, deps: [{ token: i1$4.Actions }, { token: OrderPunchoutDataService }], target: i0.ɵɵFactoryTarget.Injectable });
OrderPunchoutEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderPunchoutEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderPunchoutDataService }]; } });

const directShipAdapter = createEntityAdapter({
    selectId: (directShippingSavings) => directShippingSavings.orderId,
});
const initialDirectShippingState = directShipAdapter.getInitialState({
    loading: false,
    error: null,
});
const reducer$2 = createReducer(initialDirectShippingState, on(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavings, (state, action) => ({
    ...state,
    loading: true,
    error: null,
})), on(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavingsSuccess, (state, action) => {
    const lastUpdated = new Date().toISOString();
    const savingsWithTimestamp = {
        ...action.directShippingSavings,
        lastUpdated,
    };
    return directShipAdapter.upsertOne(savingsWithTimestamp, {
        ...state,
        loading: false,
    });
}), on(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavingsFail, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
})), on(DIRECT_SHIPPING_ACTIONS.clearLastModified, (state, action) => {
    if (state.entities[action.orderId]) {
        const newEntity = { ...state.entities[action.orderId], lastUpdated: '' };
        return directShipAdapter.upsertOne(newEntity, state);
    }
    return state;
}));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function directShippingReducer(state, action) {
    return reducer$2(state, action);
}

class DirectShipDataService {
    constructor() {
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
        this.httpVerbService = inject(HttpVerbService);
    }
    directShippingSavings(items) {
        return this.httpVerbService
            .post(`${this.config.requestReplyApiUrl}/directShippingSavings`, items)
            .pipe(filter((resp) => !!resp), catchError((error) => throwError(error)));
    }
}
DirectShipDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShipDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DirectShipDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShipDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShipDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class DirectShippingEffects {
    constructor(actions$, directShipDataService) {
        this.actions$ = actions$;
        this.directShipDataService = directShipDataService;
        this.getDirectShippingSavings$ = createEffect(() => this.actions$.pipe(ofType(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavings), switchMap((props) => {
            const items = props.order?.orderItems?.map((item) => ({
                productNumber: item.productNumber,
                eachQuantity: item.eachesOrdered?.currentValue
                    ? item.eachesOrdered.currentValue
                    : 0,
                casesQuantity: item.unitsOrdered?.currentValue
                    ? item.unitsOrdered.currentValue
                    : 0,
            }));
            return this.directShipDataService.directShippingSavings(items).pipe(map((directShippingResponse) => DIRECT_SHIPPING_ACTIONS.getDirectShippingSavingsSuccess({
                directShippingSavings: {
                    orderId: props.order?.orderHeader?.orderId,
                    directShippingSavings: directShippingResponse,
                },
            })), catchError((error) => of(DIRECT_SHIPPING_ACTIONS.getDirectShippingSavingsFail({ error }))));
        })));
    }
}
DirectShippingEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingEffects, deps: [{ token: i1$4.Actions }, { token: DirectShipDataService }], target: i0.ɵɵFactoryTarget.Injectable });
DirectShippingEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DirectShippingEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: DirectShipDataService }]; } });

// Define the initial state
const initialEditCartState = {
    orderHeader: {},
    orderItems: [],
    loading: false,
    error: null,
    dirty: null,
    saving: null,
    watermark: null,
    failCount: 0,
    tallies: null,
};

// cart.effects.ts
class CartEffects {
    constructor(actions$, orderDataService, store, panAppState) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.store = store;
        this.panAppState = panAppState;
        this.creatNewOrder$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.createNewCart), withLatestFrom(this.store.select(nextDeliverySelectors.selectNextDeliveryDetails)), switchMap(([action, nextDelivery]) => {
            const order = {};
            order.requestedDeliveryDate = nextDelivery?.deliveryDate;
            order.confirmedDeliveryDate = nextDelivery?.deliveryDate;
            order.purchaseOrderNumber = action?.defaultPo || '';
            order.orderItems = [];
            return this.orderDataService.getOrderContext(order).pipe(map((resp) => {
                const actions = [
                    CART_ACTIONS.createNewCartSuccess({ order: resp }),
                ];
                if (action.message) {
                    actions.push(CART_ACTIONS.createNewCartMessage({
                        message: action.message,
                    }));
                }
                return actions;
            }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
                const error = { status: err.status, message: err.message };
                return of(CART_ACTIONS.createNewCartFail({ error }));
            }));
        })));
        this.deleteOrder$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.deleteCart), switchMap((payload) => this.orderDataService
            .deleteOrder({
            orderHeader: payload.order.orderHeader,
            orderItems: payload.order.orderItems,
        })
            .pipe(map((resp) => {
            let actionsToExecute = [];
            if (resp.orderHeader?.errorDetails) {
                actionsToExecute.push(CART_ACTIONS.deleteCartWithErrorDetails({
                    order: {
                        orderHeader: resp.orderHeader,
                        orderItems: resp.orderItems,
                    },
                }));
            }
            else {
                actionsToExecute = [
                    CART_ACTIONS.deleteCartSuccess({
                        order: {
                            orderHeader: resp.orderHeader,
                            orderItems: resp.orderItems,
                        },
                    }),
                    MY_ORDERS_ACTIONS.removeFromMyOrders({
                        id: `${resp.orderHeader.customerNumber}:${resp.orderHeader.departmentNumber}:${resp.orderHeader.orderId}`,
                    }),
                ];
            }
            return actionsToExecute;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            console.log('Delete in progress order failed...');
            console.log('Customer number:', payload?.order?.orderHeader?.customerNumber, 'Error:', err);
            return of(CART_ACTIONS.deleteCartFail({
                order: {
                    orderHeader: payload?.order?.orderHeader,
                    orderItems: payload?.order?.orderItems,
                },
                error,
            }));
        })))));
        this.createCopiedOrder$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.createCopiedOrder), withLatestFrom(this.store.select(nextDeliverySelectors.selectNextDeliveryDetails)), exhaustMap(([payload, nextDelivery]) => this.orderDataService
            .createCopiedOrder({
            orderHeader: {
                ...payload?.newOrder?.orderHeader,
                requestedDeliveryDate: nextDelivery?.deliveryDate,
                confirmedDeliveryDate: nextDelivery?.deliveryDate,
            },
            orderItems: payload?.newOrder?.orderItems,
        })
            .pipe(map((resp) => {
            const actions = [];
            const newOrder = {
                orderHeader: resp.orderHeader,
                orderItems: resp.orderItems,
            };
            actions.push(CART_ACTIONS.createCopiedOrderSuccess({
                newOrder,
                previousOrder: payload?.previousOrder,
            }));
            return actions;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(CART_ACTIONS.createCopiedOrderFail({ error }));
        })))));
        this.loadCopiedOrderIntoCart$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.createCopiedOrderSuccess), switchMap((resp) => [
            CART_ACTIONS.loadCartIntoContext({ order: resp?.newOrder }),
        ])));
        this.clearCartOnCopyOrderFail$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.createCopiedOrderFail), switchMap((_) => [CART_ACTIONS.clearCart()])));
        this.storeOrderOnSubmit$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.submitCart, VISUAL_PUNCHTHRU_ACTIONS.submitVptOrder), concatMap((payload) => [
            MY_ORDERS_ACTIONS.upsertOne({
                order: {
                    orderHeader: {
                        ...payload.order.orderHeader,
                        orderStatus: OrderStatus.SUBMITTING,
                    },
                    orderItems: payload.order.orderItems,
                },
            }),
        ])));
        this.submitCart$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.submitCart), exhaustMap((payload) => this.orderDataService
            .submitOrder({
            orderHeader: payload.order.orderHeader,
            orderItems: payload.order.orderItems,
        })
            .pipe(map((resp) => {
            const actions = [];
            actions.push(CART_ACTIONS.submitCartSuccess({
                order: {
                    orderHeader: resp.orderHeader,
                    orderItems: resp.orderItems,
                },
            }));
            return actions;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(CART_ACTIONS.submitCartFail({ error }));
        })))));
        this.submitCartSuccess$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.submitCartSuccess), switchMap((resp) => {
            const actions = [];
            if (resp.order.orderHeader) {
                actions.push(MY_ORDERS_ACTIONS.upsertOne({
                    order: {
                        orderHeader: resp.order.orderHeader,
                        orderItems: resp.order.orderItems,
                    },
                }));
                if ((resp.order.orderHeader.orderStatus === OrderStatus.SUBMITTING ||
                    resp.order.orderHeader.orderStatus ===
                        OrderStatus.EDITING_SUBMITTED) &&
                    !resp.order.orderHeader.errorDetails) {
                    actions.push(CART_ACTIONS.clearCart());
                }
                else if (resp.order.orderHeader.errorDetails?.errNumber === 10007) {
                    actions.push(CART_ACTIONS.clearCart());
                }
            }
            return actions;
        })));
        this.clearCartFromSessionStorage$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.clearCart), tap(() => sessionStorage.removeItem('orderInCart'))), { dispatch: false });
        this.clearCartOnDeleteOrder$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.deleteCart), switchMap(() => [CART_ACTIONS.clearCart()])));
        this.cancelSubmittedCart$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.cancelSubmittedCart), switchMap((payload) => this.orderDataService.cancelSubmittedOrder(payload.order).pipe(map((serverResp) => {
            let actionsToExecute = [];
            if (serverResp.order.orderHeader?.errorDetails) {
                actionsToExecute.push(CART_ACTIONS.cancelSubmittedCartWithErrorDetails());
            }
            else {
                actionsToExecute = [
                    CART_ACTIONS.cancelSubmittedCartSuccess({
                        ...serverResp,
                    }),
                    MY_ORDERS_ACTIONS.removeFromMyOrders({
                        // eslint-disable-next-line max-len
                        id: `${serverResp.order.orderHeader.customerNumber}:${serverResp.order.orderHeader.departmentNumber}:${serverResp.order.orderHeader.orderId}`,
                    }),
                ];
            }
            return actionsToExecute;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            console.log('Cancel submitted order failed...');
            console.log('Customer number:', payload?.order?.orderHeader?.customerNumber, 'Order number:', payload?.order?.orderHeader?.tandemOrderNumber, 'Error:', err);
            const error = { status: err.status, message: err.message };
            return of(CART_ACTIONS.cancelSubmittedCartFail({
                order: {
                    orderHeader: payload?.order?.orderHeader,
                    orderItems: payload?.order?.orderItems,
                },
                error,
            }));
        })))));
        this.clearCartAndSetStatusToCancelling$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.cancelSubmittedCart), withLatestFrom(this.store.select(orderHeaderSelectors.selectOrderHeader)), switchMap(([payload, orderInCart]) => {
            const actionsToDispatch = [];
            const updatedOrderHeader = {
                ...payload.order.orderHeader,
                orderStatus: OrderStatus.CANCELLING,
            };
            actionsToDispatch.push(MY_ORDERS_ACTIONS.upsertOne({
                order: {
                    orderHeader: updatedOrderHeader,
                    orderItems: payload.order.orderItems,
                },
            }));
            if (payload.order.orderHeader.orderId === orderInCart.orderId) {
                actionsToDispatch.push(CART_ACTIONS.clearCart());
            }
            return actionsToDispatch;
        })));
        this.clearUqeOnCartActions$ = createEffect(() => this.actions$.pipe(ofType(CART_ACTIONS.cancelSubmittedCartSuccess, CART_ACTIONS.clearCart, CART_ACTIONS.createNewCartSuccess, CART_ACTIONS.loadCartIntoContext), map(() => UQE_ACTIONS.clearUqe())));
        this.clearEditCartOnClearCart$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(CART_ACTIONS.clearCart)),
            this.panAppState.feature$([FEATURES.split_global_order_edit_cart]),
        ]).pipe(withLatestFrom(this.panAppState.customer$), filter(([[_, enableEditCartUpdates], __]) => !!enableEditCartUpdates), filter(([[_, __], customerState]) => !!customerState), map(() => EDIT_CART_ACTIONS.updateEditCart({
            editCartState: initialEditCartState,
        }))));
        this.clearEditCartOnCreateNewCartSuccess$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(CART_ACTIONS.createNewCartSuccess)),
            this.panAppState.feature$([FEATURES.split_global_order_edit_cart]),
        ]).pipe(filter(([_, enableEditCartUpdates]) => !!enableEditCartUpdates), map(() => EDIT_CART_ACTIONS.updateEditCart({
            editCartState: initialEditCartState,
        }))));
        this.clearEditCartOnCancelSubmittedCartSuccess$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(CART_ACTIONS.cancelSubmittedCartSuccess)),
            this.panAppState.feature$([FEATURES.split_global_order_edit_cart]),
        ]).pipe(filter(([_, enableEditCartUpdates]) => !!enableEditCartUpdates), withLatestFrom(this.store.select(CART_SELECTORS.selectCart)), filter(([[action, _], cartState]) => !!cartState &&
            cartState?.orderHeader?.orderId ===
                action?.order?.orderHeader?.orderId), map(() => EDIT_CART_ACTIONS.updateEditCart({
            editCartState: initialEditCartState,
        }))));
        this.updateEditCartWithCartChange$ = createEffect(() => combineLatest([
            this.store.select(CART_SELECTORS.selectCart),
            this.panAppState.feature$([FEATURES.split_global_order_edit_cart]),
        ]).pipe(filter(([_, enableEditCartUpdates]) => !!enableEditCartUpdates), filter(([cartState, _]) => !!cartState?.orderHeader?.orderStatus &&
            cartState?.orderHeader?.orderStatus !== OrderStatus.IN_PROGRESS), map(([cart, _]) => EDIT_CART_ACTIONS.updateEditCart({
            editCartState: {
                ...cart,
                watermark: new Date().toISOString(),
            },
        }))));
    }
}
CartEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }, { token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
CartEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }, { type: i1.Store }, { type: i2.PanAppState }]; } });

class CartDataService {
    constructor() {
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
        this.httpVerbService = inject(HttpVerbService);
        this.orderItemDTOService = inject(OrderItemDTOService);
        this.orderDTOService = inject(OrderDtoService);
    }
    static calculateTotalUnitsAndCases(orderTransaction) {
        let totalEaches = 0;
        let totalUnits = 0;
        orderTransaction.orderItems.forEach((eachItem) => {
            totalEaches += eachItem.eachesOrdered ? eachItem.eachesOrdered : 0;
            totalUnits += eachItem.unitsOrdered ? eachItem.unitsOrdered : 0;
        });
        orderTransaction.totalEaches = totalEaches;
        orderTransaction.totalUnits = totalUnits;
    }
    syncCart(cart) {
        const orderTransaction = this.orderDTOService.toServerModel(cart.orderHeader);
        orderTransaction.orderItems = this.orderItemDTOService.toServerModelArray(cart.orderItems);
        CartDataService.calculateTotalUnitsAndCases(orderTransaction);
        orderTransaction.watermarkDtm = new Date().toISOString();
        return this.httpVerbService
            .put(`${this.config.apiUrl}/orders`, orderTransaction)
            .pipe(filter((resp) => !!resp), map((resp) => resp[0]), map((resp) => {
            const clientOrderItems = this.orderItemDTOService.toClientModelArray(resp.orderItems);
            const clientOrder = this.orderDTOService.toClientModel(resp);
            return {
                orderHeader: clientOrder,
                orderItems: clientOrderItems,
            };
        }), catchError((error) => throwError(error)));
    }
}
CartDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CartDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

// cartSync.effects.ts
class CartSyncEffects {
    constructor(actions$, cartDataService, panAppState) {
        this.actions$ = actions$;
        this.cartDataService = cartDataService;
        this.panAppState = panAppState;
        this.syncCart$ = createEffect(() => this.actions$.pipe(ofType(CART_SYNC_ACTIONS.cartSync), switchMap((action) => this.panAppState.customer$.pipe(filter((customer) => !!customer), take(1), map((customer) => ({ action, customer })))), switchMap(({ action, customer }) => {
            const order = action.order;
            if (!order.orderHeader.customerNumber ||
                customer.customerNumber === order.orderHeader.customerNumber) {
                return this.cartDataService.syncCart(order).pipe(mergeMap((response) => {
                    if (response.orderHeader.errorDetails &&
                        (response.orderHeader.orderStatus === OrderStatus.DELETED ||
                            response.orderHeader.orderStatus === OrderStatus.CANCELLED)) {
                        return [
                            CART_ACTIONS.clearCart(),
                            MY_ORDERS_ACTIONS.upsertOne({ order: response }),
                            MY_ORDERS_ACTIONS.writeToUserOfflineStorage(),
                            CART_SYNC_ACTIONS.cartNotUpdatable({ order: response }),
                        ];
                    }
                    else {
                        return [
                            CART_SYNC_ACTIONS.cartSyncSuccess({ order: response }),
                            MY_ORDERS_ACTIONS.upsertOne({ order: response }),
                            MY_ORDERS_ACTIONS.writeToUserOfflineStorage(),
                        ];
                    }
                }), catchError((error) => of(CART_SYNC_ACTIONS.cartSyncFail({ error }))));
            }
            else {
                return [
                    CART_SYNC_ACTIONS.cartSyncFail({
                        error: 'Current customer does not match order',
                    }),
                ];
            }
        })));
    }
}
CartSyncEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncEffects, deps: [{ token: i1$4.Actions }, { token: CartDataService }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
CartSyncEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CartSyncEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: CartDataService }, { type: i2.PanAppState }]; } });

const importedOrdersApiRetryInterval = 10000; //20 seconds
const maxImportedOrdersRefreshCalls = 2;
const IMPORT_ORDERS_CONSTANTS = {
    importedOrdersApiRetryInterval,
    maxImportedOrdersRefreshCalls,
};

// Utility function to read File as ArrayBuffer and return a Promise
const readFileAsArrayBuffer = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.addEventListener('load', () => resolve(reader.result));
    reader.addEventListener('error', () => reject(new Error('Error reading file')));
});
class ImportOrdersDataService {
    constructor() {
        this.config = inject(NGRX_ORDER_LIB_CONFIG);
        this.httpVerbService = inject(HttpVerbService);
        this.orderItemDtoService = inject(OrderItemDTOService);
        this.orderDtoService = inject(OrderDtoService);
    }
    /**
     * Calls the API to convert file order contents into array of OrderTransactions.
     *
     * @param ordersFile the file containing the orders to import
     * @returns Observable of OrderTransactions
     */
    load$(ordersFile, fileType) {
        return from(readFileAsArrayBuffer(ordersFile)).pipe(switchMap((arrayBuffer) => {
            // Convert ArrayBuffer to Blob
            const blob = new Blob([new Uint8Array(arrayBuffer)], {
                type: 'application/octet-stream',
            });
            // Call the API to convert file contents into array of OrderTransactions
            return this.httpVerbService.post(`${this.config.orderImportApiUrl}/submit`, blob, new HttpParams().set('format', fileType));
        }), filter((resp) => !!resp), map((resp) => resp), catchError((error) => throwError(error)));
    }
    /**
     * Submitts all OrderTransactions not flagged as deleted.
     *
     * @param orders the OrderTransactions to submit.
     * @returns OrderTransactions that were submitted.
     */
    submit$(orders) {
        return this.httpVerbService
            .post(`${this.config.submissionApiUrl}/submitImportOrders`, orders)
            .pipe(filter((resp) => !!resp), map((resp) => resp), catchError((error) => throwError(error)));
    }
    getImportedOrdersByDate(importDate, watermark) {
        const params = new HttpParams()
            .set('importDate', importDate)
            .set('watermark', watermark);
        return this.httpVerbService
            .get(`${this.config.apiUrl}/importedorders`, params)
            .pipe(filter((resp) => !!resp), map((resp) => resp
            .filter((a) => !!a)
            .map((orderTransaction) => {
            const orderItems = this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDtoService.toClientModel(orderTransaction);
            return {
                orderHeader,
                orderItems,
            };
        })), catchError((error) => throwError(error)));
    }
    getImportedOrdersById(importOrderIdentifier) {
        const params = new HttpParams().set('importOrderIdentifier', importOrderIdentifier);
        return this.httpVerbService
            .get(`${this.config.apiUrl}/importedorders`, params)
            .pipe(filter((resp) => !!resp), map((resp) => resp
            .filter((a) => !!a)
            .map((orderTransaction) => {
            const orderItems = this.orderItemDtoService.toClientModelArray(orderTransaction.orderItems);
            const orderHeader = this.orderDtoService.toClientModel(orderTransaction);
            return {
                orderHeader,
                orderItems,
            };
        })), catchError((error) => throwError(error)));
    }
}
ImportOrdersDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersDataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ImportOrdersDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ImportOrdersEffects {
    constructor(actions$, importOrdersDataService, store, panAppState) {
        this.actions$ = actions$;
        this.importOrdersDataService = importOrdersDataService;
        this.store = store;
        this.panAppState = panAppState;
        this.loadImportOrders$ = createEffect(() => this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.load), withLatestFrom(this.panAppState.user$), switchMap(([payload, user]) => {
            const orderTakerId = user?.tmUser === 'Y' ? user.userId : user.ecomUserId.toString();
            return this.importOrdersDataService
                .load$(payload.ordersFile, payload.fileType)
                .pipe(map((importOrders) => {
                if (!importOrders.orderTransactions) {
                    importOrders.orderTransactions = [];
                }
                const importOrderIdentifier = v4();
                importOrders.orderTransactions?.forEach((order) => {
                    order.importOrderIdentifier = importOrderIdentifier;
                    order.clientId = v4();
                    order.importOrderTakerId = orderTakerId;
                });
                return IMPORT_ORDERS_ACTIONS.loadSuccess({ importOrders });
            }), catchError((error) => of(IMPORT_ORDERS_ACTIONS.loadFail({ error }))));
        })));
        this.submitImportOrders$ = createEffect(() => this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.submit), filter((payload) => !!payload?.orders?.length), mergeMap((payload) => {
            const setImportOrderCheckAction = IMPORT_ORDERS_ACTIONS.setImportOrderCheck({
                expectation: payload.expectation,
            });
            return merge(of(setImportOrderCheckAction), this.importOrdersDataService.submit$(payload.orders).pipe(map((orders) => IMPORT_ORDERS_ACTIONS.submitSuccess({
                orders,
                expectation: payload.expectation,
            })), catchError((error) => of(IMPORT_ORDERS_ACTIONS.submitFail({ error })))));
        })));
        this.handleEmptyImportOrdersWebsocket$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.submitSuccess)),
            this.actions$.pipe(ofType(MY_ORDERS_ACTIONS.submitIpOrderAsync)),
        ]).pipe(filter(([importOrdersAction, myOrdersAction]) => myOrdersAction?.orderTransactions?.length === 0 &&
            !!importOrdersAction?.expectation &&
            !importOrdersAction?.expectation?.ordersLoaded), switchMap(([importOrdersAction, _myOrdersAction]) => [
            IMPORT_ORDERS_ACTIONS.pollGetImportedOrders({
                importOrderIdentifier: importOrdersAction?.expectation?.importOrderIdentifier,
            }),
        ])));
        this.pollImportedOrdersCall$ = createEffect(() => this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.pollGetImportedOrders), switchMap(({ importOrderIdentifier }) => interval(IMPORT_ORDERS_CONSTANTS.importedOrdersApiRetryInterval).pipe(take(IMPORT_ORDERS_CONSTANTS.maxImportedOrdersRefreshCalls), mergeMap((action) => combineLatest([
            of(action),
            this.store.select(orderSelectors.selectImportedOrdersById(importOrderIdentifier)),
            this.store.select(IMPORT_ORDERS_SELECTORS.selectImportOrderCheck),
        ]).pipe(take(1))), filter(([_action, importedOrders, importOrderCheck]) => !!importOrderCheck &&
            !importOrderCheck?.ordersLoaded &&
            importOrderCheck?.orderCount > importedOrders?.length), switchMap(([_action, _importedOrders, importOrderCheck]) => [
            IMPORT_ORDERS_ACTIONS.getImportedOrdersById({
                importOrderIdentifier: importOrderCheck?.importOrderIdentifier,
            }),
        ])))));
        this.retrieveImportedOrdersDate$ = createEffect(() => this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDate), withLatestFrom(this.store.select(orderSelectors.selectWatermark())), switchMap(([payload, watermark]) => this.importOrdersDataService
            .getImportedOrdersByDate(payload.importDate, watermark)
            .pipe(switchMap((orders) => [
            IMPORT_ORDERS_ACTIONS.getImportedOrdersByDateSuccess({ orders }),
        ]), catchError((error) => of(IMPORT_ORDERS_ACTIONS.getImportedOrdersByDateFail({ error })))))));
        this.retrieveImportedOrdersId$ = createEffect(() => this.actions$.pipe(ofType(IMPORT_ORDERS_ACTIONS.getImportedOrdersById), switchMap((payload) => this.importOrdersDataService
            .getImportedOrdersById(payload?.importOrderIdentifier)
            .pipe(switchMap((orders) => [
            IMPORT_ORDERS_ACTIONS.getImportedOrdersByIdSuccess({ orders }),
        ]), catchError((error) => of(IMPORT_ORDERS_ACTIONS.getImportedOrdersByIdFail({ error })))))));
    }
    getExpectedOrderCount(orders) {
        return orders.length;
    }
}
ImportOrdersEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersEffects, deps: [{ token: i1$4.Actions }, { token: ImportOrdersDataService }, { token: i1.Store }, { token: i2.PanAppState }], target: i0.ɵɵFactoryTarget.Injectable });
ImportOrdersEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ImportOrdersEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: ImportOrdersDataService }, { type: i1.Store }, { type: i2.PanAppState }]; } });

class PartnerDataService {
    constructor(config, httpVerbService) {
        this.config = config;
        this.httpVerbService = httpVerbService;
    }
    getPartnerData() {
        return this.httpVerbService
            .get(`${this.config.partnerApiUrl}/partner`)
            .pipe(filter((resp) => !!resp), map((partnerData) => partnerData), catchError((error) => throwError(error)));
    }
}
PartnerDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerDataService, deps: [{ token: NGRX_ORDER_LIB_CONFIG }, { token: HttpVerbService }], target: i0.ɵɵFactoryTarget.Injectable });
PartnerDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ORDER_LIB_CONFIG]
                }] }, { type: HttpVerbService }]; } });

class PartnerEffects {
    constructor(actions$, partnerDataService) {
        this.actions$ = actions$;
        this.partnerDataService = partnerDataService;
        this.getPartnerData$ = createEffect(() => this.actions$.pipe(ofType(PARTNER_ACTIONS.getPartnerData), switchMap((_) => this.partnerDataService.getPartnerData().pipe(map((partner) => PARTNER_ACTIONS.getPartnerDataSuccess({ partner })), catchError((error) => of(PARTNER_ACTIONS.getPartnerDataFail({ error })))))));
    }
}
PartnerEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerEffects, deps: [{ token: i1$4.Actions }, { token: PartnerDataService }], target: i0.ɵɵFactoryTarget.Injectable });
PartnerEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PartnerEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: PartnerDataService }]; } });

class UqeDataService {
    constructor(config, httpVerbService) {
        this.config = config;
        this.httpVerbService = httpVerbService;
    }
    getUqeProducts$(uqeProducts) {
        const uqeBody = { products: uqeProducts };
        return this.httpVerbService
            .post(`${this.config.apiUrl}/getUqeProducts`, uqeBody)
            .pipe(filter((resp) => !!resp), map((resp) => resp.products));
    }
}
UqeDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeDataService, deps: [{ token: NGRX_ORDER_LIB_CONFIG }, { token: HttpVerbService }], target: i0.ɵɵFactoryTarget.Injectable });
UqeDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeDataService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UqeDataService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ORDER_LIB_CONFIG]
                }] }, { type: HttpVerbService }]; } });

class UnusualQuantitiesEffects {
    constructor(actions$, store, uqeDataService) {
        this.actions$ = actions$;
        this.store = store;
        this.uqeDataService = uqeDataService;
        this.getUqeProducts$ = createEffect(() => this.actions$.pipe(ofType(UQE_ACTIONS.getUqeProducts), concatLatestFrom((action) => this.store.select(UQE_SELECTORS.filterOutExistingUqeProducts(action.productNumbers))), filter(([_aciton, filteredProductNumbers]) => !!filteredProductNumbers && filteredProductNumbers.length > 0), concatMap(([_action, filteredProductNumbers]) => this.uqeDataService.getUqeProducts$(filteredProductNumbers).pipe(switchMap((uqeProducts) => [
            UQE_ACTIONS.getUqeProductsSuccess({ uqeProducts }),
        ]), catchError((error) => of(UQE_ACTIONS.getUqeProductsFail({ error })))))));
    }
}
UnusualQuantitiesEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnusualQuantitiesEffects, deps: [{ token: i1$4.Actions }, { token: i1.Store }, { token: UqeDataService }], target: i0.ɵɵFactoryTarget.Injectable });
UnusualQuantitiesEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnusualQuantitiesEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnusualQuantitiesEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: i1.Store }, { type: UqeDataService }]; } });

const importedOrdersFiltersFeatureKey = 'importedOrdersFilters';
const formatImportDate = (importedDate) => `${importedDate.getMonth() + 1}/${importedDate.getDate()}/${importedDate.getFullYear()}`;
const initialState$1 = {
    filters: {
        importedDate: formatImportDate(new Date()),
        showAllOrdersForDate: false,
        orderStatus: {
            [OrderStatus.IN_PROGRESS]: false,
            [OrderStatus.SUBMITTING]: false,
            [OrderStatus.SUBMITTED]: false,
            [OrderStatus.SUBMITTED_CREDIT_HOLD]: false,
            [OrderStatus.SUBMITTED_WITH_EXCEPTIONS]: false,
            [OrderStatus.EDITING_SUBMITTED]: false,
            [OrderStatus.ORDER_ERROR]: false,
            [OrderStatus.SHIPPED]: false,
            [OrderStatus.SHIPPED_WITH_EXCEPTIONS]: false,
            [OrderStatus.PICKING]: false,
            [OrderStatus.INVOICE]: false,
            [OrderStatus.DELIVERED]: false,
            [OrderStatus.DELETED]: false,
            [OrderStatus.CANCELLED]: false,
            [OrderStatus.CANCELLING]: false,
            [OrderStatus.TANDEM_DELETED]: false,
            [OrderStatus.SUBMITTED_NEW]: false,
            [OrderStatus.NO_ORDER]: false,
            [OrderStatus.SUBMISSION_ERROR]: false,
            [OrderStatus.QUANTITIES_UPDATED]: false,
            [OrderStatus.OUT_FOR_DELIVERY]: false,
            [OrderStatus.DELIVERY_DELAYED]: false,
            [OrderStatus.ATTEMPTED_DELIVERY]: false,
            [OrderStatus.ORDER_CANCELLED]: false,
            [OrderStatus.DELIVERY_ISSUE]: false,
        },
    },
    filtersSelected: 1,
};
const reducer$1 = createReducer(initialState$1, on(IMPORTED_ORDERS_FILTERS_ACTIONS.setImportedOrdersFilters, (state, { filters, filtersSelected }) => ({
    filters: { ...state.filters, ...filters },
    filtersSelected,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function importedOrdersFiltersReducer(state, action) {
    return reducer$1(state, action);
}

class VisualPunchThruEffects {
    constructor(actions$, orderDataService) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.getVptOrderByOrderNumber$ = createEffect(() => this.actions$.pipe(ofType(VISUAL_PUNCHTHRU_ACTIONS.getVptOrderByOrderNumber), switchMap((props) => this.orderDataService.getVptOrderByOrderNumber(props.orderNumber).pipe(map((resp) => ({
            ...resp,
            order: {
                ...resp.order,
                orderHeader: {
                    ...resp.order.orderHeader,
                    orderStatus: getOrderErrorOriginalStatus(resp.order.orderHeader),
                },
            },
        })), map((resp) => VISUAL_PUNCHTHRU_ACTIONS.getVptOrderByOrderNumberSuccess({
            order: resp.order,
            orderNumber: resp.orderNumber,
        })), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(VISUAL_PUNCHTHRU_ACTIONS.getVptOrderByOrderNumberFail({ error }));
        })))));
        this.submitVptOrder$ = createEffect(() => this.actions$.pipe(ofType(VISUAL_PUNCHTHRU_ACTIONS.submitVptOrder), exhaustMap((payload) => this.orderDataService
            .submitOrder({
            orderHeader: payload.order.orderHeader,
            orderItems: payload.order.orderItems,
        })
            .pipe(map((resp) => {
            const actions = [];
            actions.push(VISUAL_PUNCHTHRU_ACTIONS.submitVptOrderSuccess({
                order: {
                    orderHeader: resp.orderHeader,
                    orderItems: resp.orderItems,
                },
            }));
            return actions;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(VISUAL_PUNCHTHRU_ACTIONS.submitVptOrderFail({ error }));
        })))));
        this.submitVptOrderSuccess$ = createEffect(() => this.actions$.pipe(ofType(VISUAL_PUNCHTHRU_ACTIONS.submitVptOrderSuccess), switchMap((resp) => {
            const actions = [];
            if (resp.order.orderHeader) {
                actions.push(MY_ORDERS_ACTIONS.upsertOne({
                    order: {
                        orderHeader: resp.order.orderHeader,
                        orderItems: resp.order.orderItems,
                    },
                }));
                if ((resp.order.orderHeader.orderStatus === OrderStatus.SUBMITTING ||
                    resp.order.orderHeader.orderStatus ===
                        OrderStatus.EDITING_SUBMITTED) &&
                    !resp.order.orderHeader.errorDetails) {
                    actions.push(CART_ACTIONS.clearCart());
                }
                else if (resp.order.orderHeader.errorDetails?.errNumber === 10007) {
                    actions.push(CART_ACTIONS.clearCart());
                }
            }
            return actions;
        })));
    }
}
VisualPunchThruEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VisualPunchThruEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }], target: i0.ɵɵFactoryTarget.Injectable });
VisualPunchThruEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VisualPunchThruEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VisualPunchThruEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }]; } });

const orderItemFilterFeatureKey = 'orderItemFilter';
const initialState = {
    searchKey: '',
};
const reducer = createReducer(initialState, on(ORDER_ITEM_FILTER_ACTIONS.setOrderItemFilter, (state, { searchKey }) => ({
    ...state,
    searchKey,
})));
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function orderItemFilterReducer(state, action) {
    return reducer(state, action);
}

class ShipToEffects {
    constructor(actions$, orderDataService) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.updateShipToDetails$ = createEffect(() => this.actions$.pipe(ofType(SHIP_TO_ACTIONS.updateShipToDetails), exhaustMap((payload) => this.orderDataService
            .updateShipToDetails({
            orderHeader: payload.order.orderHeader,
            orderItems: payload.order.orderItems,
        })
            .pipe(map((resp) => {
            const actions = [];
            actions.push(SHIP_TO_ACTIONS.updateShipToDetailsSuccess({
                order: {
                    orderHeader: resp.orderHeader,
                    orderItems: resp.orderItems,
                },
            }));
            return actions;
        }), concatMap((actionsToExecute) => actionsToExecute), catchError((err) => {
            const error = { status: err.status, message: err.message };
            return of(SHIP_TO_ACTIONS.updateShipToDetailsFail({ error }));
        })))));
    }
}
ShipToEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShipToEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }], target: i0.ɵɵFactoryTarget.Injectable });
ShipToEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShipToEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ShipToEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }]; } });

const editCartReducer = createReducer(initialEditCartState, on(EDIT_CART_ACTIONS.clearEditCart, () => ({
    ...initialEditCartState,
})), on(EDIT_CART_ACTIONS.updateEditCart, (state, { editCartState }) => ({
    ...editCartState,
    dirty: null,
    saving: null,
    loading: null,
})));

class EditCartStateStorageService {
    constructor(browserStorageService) {
        this.browserStorageService = browserStorageService;
    }
    read(user, storeEntityName) {
        const dbName = `${user?.userId}_${ORDER_DOMAIN_NAME}`;
        return this.browserStorageService.loadFromOfflineStorage(dbName, storeEntityName);
    }
    write(user, storeEntityName, state) {
        const dbName = `${user?.userId}_${ORDER_DOMAIN_NAME}`;
        return this.browserStorageService.indexDB(dbName, storeEntityName, '0', state, MessageTypes.saveBrowserStorage);
    }
}
EditCartStateStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartStateStorageService, deps: [{ token: i1$1.BrowserStorageService }], target: i0.ɵɵFactoryTarget.Injectable });
EditCartStateStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartStateStorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartStateStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.BrowserStorageService }]; } });

class EditCartEffects {
    constructor(actions$, editCartStateStorageService, panAppState, myOrdersStoreService) {
        this.actions$ = actions$;
        this.editCartStateStorageService = editCartStateStorageService;
        this.panAppState = panAppState;
        this.myOrdersStoreService = myOrdersStoreService;
        // Write edit-cart state to indexdb
        this.writeToIndexDB$ = createEffect(() => combineLatest([
            this.actions$.pipe(ofType(EDIT_CART_ACTIONS.updateEditCart)),
            this.panAppState.user$.pipe(filter$1((user) => !!user?.assignedCustomers?.length)),
        ]).pipe(concatMap$1(([action, user]) => this.editCartStateStorageService.write(user, EDIT_CART_KEY, {
            ...action.editCartState,
            dirty: null,
            saving: null,
            loading: null,
        }))), { dispatch: false });
        // Read edit-cart state from indexdb and update cart state
        this.readFromIndexDB$ = createEffect(() => combineLatest([
            this.panAppState.user$.pipe(filter$1((user) => !!user?.assignedCustomers?.length), first$1()),
            this.panAppState.customer$.pipe(filter$1((customer) => !!customer), first$1()),
            this.panAppState
                .feature$([FEATURES.split_global_order_edit_cart])
                .pipe(filter$1((feature) => !!feature)),
        ]).pipe(concatMap$1(([user, customer, _]) => this.editCartStateStorageService
            .read(user, EDIT_CART_KEY)
            .pipe(filter$1((editCartState) => !!editCartState && Object.keys(editCartState).length > 0), filter$1((editCartState) => editCartState.orderHeader?.customerNumber ===
            customer.customerNumber &&
            editCartState.orderHeader?.divisionNumber ===
                customer.divisionNumber &&
            editCartState.orderHeader?.departmentNumber?.toString() ===
                customer.departmentNumber?.toString()), concatMap$1((editCartState) => {
            const orderId = `${editCartState.orderHeader?.customerNumber}:` +
                `${editCartState.orderHeader?.departmentNumber}:` +
                `${editCartState.orderHeader?.orderId}`;
            return this.myOrdersStoreService.getOrderWithId(orderId).pipe(filter$1((order) => !!order), first$1(), mergeMap$1((order) => {
                const editCartWatermarkDate = new Date(editCartState.watermark);
                const orderWatermarkDate = new Date(order.orderHeader.watermarkDtm);
                const threeHoursAgo = new Date(Date.now() - 3 * 60 * 60 * 1000);
                if (editCartWatermarkDate < threeHoursAgo ||
                    editCartWatermarkDate < orderWatermarkDate) {
                    return from([
                        EDIT_CART_ACTIONS.updateEditCart({
                            editCartState: initialEditCartState,
                        }),
                    ]);
                }
                else {
                    return from([
                        CART_ACTIONS.updateCart({
                            order: {
                                orderHeader: editCartState.orderHeader,
                                orderItems: editCartState.orderItems,
                            },
                        }),
                        EDIT_CART_ACTIONS.loadProductsForEditCart({
                            productNumbers: this.getProductNumbers(editCartState),
                        }),
                    ]);
                }
            }));
        })))));
    }
    getProductNumbers(editCartState) {
        return editCartState.orderItems.map((orderItem) => orderItem.productNumber);
    }
}
EditCartEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartEffects, deps: [{ token: i1$4.Actions }, { token: EditCartStateStorageService }, { token: i2.PanAppState }, { token: MyOrdersStoreService }], target: i0.ɵɵFactoryTarget.Injectable });
EditCartEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EditCartEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: EditCartStateStorageService }, { type: i2.PanAppState }, { type: MyOrdersStoreService }]; } });

class OrderReviewEffects {
    constructor(actions$, orderReviewDataService, panAppState, store) {
        this.actions$ = actions$;
        this.orderReviewDataService = orderReviewDataService;
        this.panAppState = panAppState;
        this.store = store;
        this.updateOrderReviewPreferences$ = createEffect(() => this.actions$.pipe(ofType(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferences), mergeMap$1((payload) => combineLatest([
            this.store.select(orderSelectors.selectOrderWithId(payload.orderId)),
            this.panAppState.user$,
            this.panAppState.feature$([FEATURES.split_global_order_reviewed]),
        ]).pipe(take$1(1))), exhaustMap$1(([order, user, flag]) => iif(() => user.userKind === UserKinds.Internal && flag, this.orderReviewDataService.updateOrderReviewPreferences(order).pipe(map$1((orderReviewPreferences) => ORDER_REVIEW_ACTIONS.updateOrderReviewPreferencesSuccess({
            orderReviewPreferences,
        })), catchError$1((err) => of(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferencesFail({
            error: err,
        })))), of(ORDER_REVIEW_ACTIONS.updateOrderReviewPreferencesFail({
            error: `Feature flag: ${flag}. Is Internal User: ${user.userKind}`,
        }))))));
        this.getOrderReviewPreferences$ = createEffect(() => this.actions$.pipe(ofType(ORDER_REVIEW_ACTIONS.getOrderReviewPreferences), mergeMap$1((payload) => combineLatest([
            this.panAppState.user$,
            this.panAppState.feature$([FEATURES.split_global_order_reviewed]),
        ]).pipe(take$1(1))), exhaustMap$1(([user, flag]) => iif(() => user.userKind === UserKinds.Internal && flag, this.orderReviewDataService.getOrderReviewPreferences$().pipe(map$1((orderReviewPreferences) => ORDER_REVIEW_ACTIONS.getOrderReviewPreferencesSuccess({
            orderReviewPreferences,
        })), catchError$1((err) => of(ORDER_REVIEW_ACTIONS.getOrderReviewPreferencesFail({
            error: err,
        })))), of(ORDER_REVIEW_ACTIONS.getOrderReviewPreferencesFail({
            error: `Feature flag: ${flag}. Is Internal User: ${user.userKind}`,
        }))))));
    }
}
OrderReviewEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewEffects, deps: [{ token: i1$4.Actions }, { token: OrderReviewDataService }, { token: i2.PanAppState }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Injectable });
OrderReviewEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewEffects });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: OrderReviewEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderReviewDataService }, { type: i2.PanAppState }, { type: i1.Store }]; } });

class NonVisualPunchThruEffects {
    constructor(actions$, orderDataService) {
        this.actions$ = actions$;
        this.orderDataService = orderDataService;
        this.getNvptOrderByOrderNumber$ = createEffect(() => this.actions$.pipe(ofType(NON_VISUAL_PUNCHTHRU_ACTIONS.getNvptOrderByOrderNumber), switchMap((action) => this.orderDataService.getOrderDetails(Number(action.orderNumber)).pipe(map((resp) => ({
            ...resp,
            orderHeader: {
                ...resp.orderHeader,
                orderStatus: getOrderErrorOriginalStatus(resp.orderHeader),
            },
        })), map((order) => [
            MY_ORDERS_ACTIONS.upsertOne({ order }),
            NON_VISUAL_PUNCHTHRU_ACTIONS.getNvptOrderByOrderNumberSuccess({
                order,
            }),
        ]), concatMap((actions) => from(actions)), catchError((error) => of(NON_VISUAL_PUNCHTHRU_ACTIONS.getNvptOrderByOrderNumberFail({
            error,
        })))))));
    }
}
NonVisualPunchThruEffects.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NonVisualPunchThruEffects, deps: [{ token: i1$4.Actions }, { token: OrderDataService }], target: i0.ɵɵFactoryTarget.Injectable });
NonVisualPunchThruEffects.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NonVisualPunchThruEffects, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NonVisualPunchThruEffects, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Actions }, { type: OrderDataService }]; } });

class NgRxOrderModule {
    constructor(ngRxOrderLibConfig, store, panAppState, webSocketService) {
        this.ngRxOrderLibConfig = ngRxOrderLibConfig;
        this.store = store;
        this.panAppState = panAppState;
        this.webSocketService = webSocketService;
        this.subscripions = [];
    }
    static forRoot(ngRxOrderLibConfig, store, panAppState, webSocketService) {
        return {
            ngModule: NgRxOrderModule,
            providers: [
                {
                    provide: NGRX_ORDER_LIB_CONFIG,
                    useValue: ngRxOrderLibConfig,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeWebSocket,
                    deps: [OrderClientWebSocketService],
                    multi: true,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeOrderState,
                    deps: [OrderStateService],
                    multi: true,
                },
                CartSyncService,
                {
                    provide: APP_INITIALIZER,
                    useFactory: initializeCartSyncService,
                    deps: [CartSyncService],
                    multi: true,
                },
            ],
        };
    }
}
NgRxOrderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxOrderModule, deps: [{ token: NGRX_ORDER_LIB_CONFIG }, { token: i1.Store }, { token: i2.PanAppState }, { token: i1$2.WebSocketService, optional: true }], target: i0.ɵɵFactoryTarget.NgModule });
NgRxOrderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: NgRxOrderModule, imports: [i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1.StoreFeatureModule, i1$4.EffectsFeatureModule] });
NgRxOrderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxOrderModule, providers: [
        HttpVerbService,
        MyOrdersEffects,
        NextDeliveryEffects,
        OrderStateService,
        DYFEffects,
        InspiredPicksEffects,
        DirectShippingEffects,
        ImportOrdersEffects,
        PartnerEffects,
        OrderPunchoutEffects,
        ShipToEffects,
        VisualPunchThruEffects,
        NonVisualPunchThruEffects,
        UnusualQuantitiesEffects,
    ], imports: [StoreModule.forFeature(ORDERS_KEY, orderReducer),
        StoreModule.forFeature(ORDERS_FILTERS_KEY, ordersFiltersReducer),
        StoreModule.forFeature(NEXT_DELIVERY_KEY, nextDeliveryReducer),
        StoreModule.forFeature(ORDER_EXCEPTION_KEY, orderExceptionReducer),
        StoreModule.forFeature(DYF_PRODUCT_KEY, dyfProductsReducer),
        StoreModule.forFeature(INSPIRED_PICKS_KEY, inspiredPicksReducer),
        StoreModule.forFeature(DIRECT_SHIPPING_KEY, directShippingReducer),
        StoreModule.forFeature(CART_KEY, cartReducer),
        StoreModule.forFeature(EDIT_CART_KEY, editCartReducer),
        StoreModule.forFeature(IMPORT_ORDERS_KEY, importOrdersReducer),
        StoreModule.forFeature(PARTNER_KEY, partnerReducer),
        StoreModule.forFeature(UQE_KEY, uqeReducer),
        StoreModule.forFeature(IMPORTED_ORDERS_FILTERS_KEY, importedOrdersFiltersReducer),
        StoreModule.forFeature(ORDER_ITEM_FILTER_KEY, orderItemFilterReducer),
        StoreModule.forFeature(ORDER_REVIEW_KEY, orderReviewReducer),
        StoreModule.forFeature(ORDER_CONTROL_KEY, orderControlReducer),
        StoreModule.forFeature(DSM_KEY, dsmInfoReducer),
        EffectsModule.forFeature([
            MyOrdersEffects,
            NextDeliveryEffects,
            OrderExceptionEffects,
            DYFEffects,
            InspiredPicksEffects,
            DirectShippingEffects,
            CartEffects,
            CartSyncEffects,
            ImportOrdersEffects,
            PartnerEffects,
            OrderPunchoutEffects,
            ShipToEffects,
            VisualPunchThruEffects,
            NonVisualPunchThruEffects,
            UnusualQuantitiesEffects,
            EditCartEffects,
            OrderReviewEffects,
        ])] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: NgRxOrderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        StoreModule.forFeature(ORDERS_KEY, orderReducer),
                        StoreModule.forFeature(ORDERS_FILTERS_KEY, ordersFiltersReducer),
                        StoreModule.forFeature(NEXT_DELIVERY_KEY, nextDeliveryReducer),
                        StoreModule.forFeature(ORDER_EXCEPTION_KEY, orderExceptionReducer),
                        StoreModule.forFeature(DYF_PRODUCT_KEY, dyfProductsReducer),
                        StoreModule.forFeature(INSPIRED_PICKS_KEY, inspiredPicksReducer),
                        StoreModule.forFeature(DIRECT_SHIPPING_KEY, directShippingReducer),
                        StoreModule.forFeature(CART_KEY, cartReducer),
                        StoreModule.forFeature(EDIT_CART_KEY, editCartReducer),
                        StoreModule.forFeature(IMPORT_ORDERS_KEY, importOrdersReducer),
                        StoreModule.forFeature(PARTNER_KEY, partnerReducer),
                        StoreModule.forFeature(UQE_KEY, uqeReducer),
                        StoreModule.forFeature(IMPORTED_ORDERS_FILTERS_KEY, importedOrdersFiltersReducer),
                        StoreModule.forFeature(ORDER_ITEM_FILTER_KEY, orderItemFilterReducer),
                        StoreModule.forFeature(ORDER_REVIEW_KEY, orderReviewReducer),
                        StoreModule.forFeature(ORDER_CONTROL_KEY, orderControlReducer),
                        StoreModule.forFeature(DSM_KEY, dsmInfoReducer),
                        EffectsModule.forFeature([
                            MyOrdersEffects,
                            NextDeliveryEffects,
                            OrderExceptionEffects,
                            DYFEffects,
                            InspiredPicksEffects,
                            DirectShippingEffects,
                            CartEffects,
                            CartSyncEffects,
                            ImportOrdersEffects,
                            PartnerEffects,
                            OrderPunchoutEffects,
                            ShipToEffects,
                            VisualPunchThruEffects,
                            NonVisualPunchThruEffects,
                            UnusualQuantitiesEffects,
                            EditCartEffects,
                            OrderReviewEffects,
                        ]),
                    ],
                    providers: [
                        HttpVerbService,
                        MyOrdersEffects,
                        NextDeliveryEffects,
                        OrderStateService,
                        DYFEffects,
                        InspiredPicksEffects,
                        DirectShippingEffects,
                        ImportOrdersEffects,
                        PartnerEffects,
                        OrderPunchoutEffects,
                        ShipToEffects,
                        VisualPunchThruEffects,
                        NonVisualPunchThruEffects,
                        UnusualQuantitiesEffects,
                    ],
                    exports: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [NGRX_ORDER_LIB_CONFIG]
                }] }, { type: i1.Store }, { type: i2.PanAppState }, { type: i1$2.WebSocketService, decorators: [{
                    type: Optional
                }] }]; } });
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeOrderState(orderState) {
    const state = () => orderState.initializeStore();
    return state;
}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeWebSocket(webSocketService) {
    const websocket = () => webSocketService.initialize();
    return websocket;
}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function initializeCartSyncService(service) {
    return () => service.initialize();
}

/*
 * Public API Surface of ngrx-order
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CART_ACTIONS, CART_KEY, CART_SELECTORS, CART_SYNC_ACTIONS, CartSyncService, DIRECT_SHIPPING_ACTIONS, DIRECT_SHIPPING_KEY, DSM_ACTIONS, DSM_KEY, DYF_ACTIONS, DYF_PRODUCT_KEY, DeliveryStoreService, DidYouForgetStoreService, DirectShippingStoreService, EDIT_CART_ACTIONS, EDIT_CART_KEY, IMPORTED_ORDERS_FILTERS_ACTIONS, IMPORTED_ORDERS_FILTERS_KEY, IMPORTED_ORDERS_FILTERS_SELECTORS, IMPORT_ORDERS_ACTIONS, IMPORT_ORDERS_KEY, IMPORT_ORDERS_SELECTORS, INSPIRED_PICKS_ACTIONS, INSPIRED_PICKS_KEY, ImportOrdersStoreService, InspiredPicksStoreService, MY_ORDERS_ACTIONS, MyOrdersStoreService, NEXT_DELIVERY_ACTIONS, NEXT_DELIVERY_KEY, NON_VISUAL_PUNCHTHRU_ACTIONS, NgRxOrderModule, ORDERS_FILTERS_KEY, ORDERS_KEY, ORDER_CONTROL_ACTIONS, ORDER_CONTROL_KEY, ORDER_DOMAIN_NAME, ORDER_EXCEPTION_ACTIONS, ORDER_EXCEPTION_KEY, ORDER_ITEM_FILTER_ACTIONS, ORDER_ITEM_FILTER_KEY, ORDER_ITEM_FILTER_SELECTORS, ORDER_PUNCHOUT_ACTIONS, ORDER_REVIEW_ACTIONS, ORDER_REVIEW_KEY, ORDER_REVIEW_SELECTORS, ORDER_STORAGE_KEYS, OrderAnalyticsService, OrderClientWebSocketService, OrderDataService, OrderDtoService, OrderETAMessageType, OrderExceptionStoreService, OrderItemDTOService, OrderItemStoreService, OrderPunchoutDataService, OrderPunchoutStoreService, OrderReviewDataService, OrderReviewStoreService, OrderStateService, OrderStatus, OrderStoreService, PARTNER_ACTIONS, PARTNER_KEY, PartnerStoreService, PriceParseService, SHIP_TO_ACTIONS, UQE_ACTIONS, UQE_KEY, UQE_SELECTORS, UqeStoreService, VISUAL_PUNCHTHRU_ACTIONS, cartMocks, cartReducer, directShippingSelectors, dsmInfoReducer, dsmSelectors, dyfSelectors, importOrdersReducer, initialCartState, initialNextDeliveryState, initialOrderState, initialPartnerState, inspiredPicksSelectors, nextDeliveryReducer, nextDeliverySelectors, orderAdapter, orderControlReducer, orderExceptionReducer, orderExceptionSelectors, orderHeaderSelectors, orderItemSelectors, index as orderLibMocks, orderReducer, orderSelectors, ordersFiltersReducer, ordersFiltersSelectors, ordersFiltersState, partnerReducer, partnerSelectors };
